// js/calendar-demo.js
// Modal handlers and event listeners for Calendar Demo
// Sincronizado con app.js para datos reales

// Mantener el calendario con la misma estructura visual Tailwind (Dom..Sáb + Recap)
// app.js lee esta preferencia al iniciar.
try {
    localStorage.setItem('showWeekendTrades', '1');
} catch (_) {}

let selectedDateForModal = null;

// VARIABLES GLOBALES PARA MODALES (accesibles desde qualquier función)
let addTradeModal, addNotesModal, tradeDetailsModal, importModal, accountModal, dayModal;

// ============================================
// HELPER: Detectar trades en Break Even (BE)
// BE = -0.1% <= resultado <= 0.1% del balance
// ============================================
function isBreakEvenTrade(trade, balance) {
    const profitUSD = parseFloat(trade.profitUSD) || 0;
    const profitPercent = (profitUSD / balance) * 100;
    return profitPercent >= -0.1 && profitPercent <= 0.1;
}

document.addEventListener('DOMContentLoaded', function() {
    
    // Asegurar que la línea hover esté oculta desde el inicio
    const hoverLine = document.getElementById('hoverLine');
    if (hoverLine) {
        hoverLine.setAttribute('opacity', '0');
        hoverLine.style.opacity = '0';
        hoverLine.style.pointerEvents = 'none';
    }
    
    // ========== INICIALIZAR REFERENCIAS A MODALES ==========
    addTradeModal = document.getElementById('addTradeModal');
    addNotesModal = document.getElementById('addNotesModal');
    tradeDetailsModal = document.getElementById('tradeDetailsModal');
    importModal = document.getElementById('importModal');
    accountModal = document.getElementById('accountModal');
    dayModal = document.getElementById('dayModal');
    
    // Inicialización básica: calendar-demo.js se encarga del UI; app.js del estado/datos
    loadUserData();
    setupAccountSwitcher();
    
    // IMPORTANTE: Llamar init de modales ANTES de simplifyCalendarDisplay para que las funciones estén disponibles
    initAccountSwitcher();
    initDayModal();
    initTradeAndNotesModals();
    initImportModal();
    initAccountModal();
    initTradeDetailsModal();
    initTradeControl();
    initEbookBtn();
    initCalculatorModal();
    initRecapBtn();
    initMobileMenu();
    initUserProfileBtn(); // Actualizar nombre de usuario en header
    initSyncTipNotification(); // Mostrar tip de resincronización una sola vez
    
    // Ocultar botón de Eventos para usuarios Free
    updateSyncEventsButtonVisibility();
    
    // AHORA que todas las funciones están disponibles, adjuntar los click handlers del calendario
    simplifyCalendarDisplay();
    setupEconomicEventsSync();
    
    // Re-aplicar eventos económicos cuando el usuario vuelve a la página (sin hacer request)
    document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
            // VERIFICAR PLAN antes de mostrar eventos
            const userPlan = (sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'free').toLowerCase();
            if (userPlan === 'free') return; // FREE no tiene acceso
            
            const cachedEvents = localStorage.getItem('economicEventsCache');
            if (cachedEvents) {
                try {
                    const eventsData = JSON.parse(cachedEvents);
                    setTimeout(() => markEconomicEventDates(eventsData), 100);
                } catch (e) {
                    // Ignore
                }
            }
        }
    });
    
    // 🆕 Inicializar métricas con el mes actual del calendario (con delay para que funciones estén cargadas)
    setTimeout(() => {
        if (window.currentDate && typeof updateRealTimeMetrics === 'function') {
            updateRealTimeMetrics(window.currentDate);
        }
    }, 300);
    
    // Actualizar últimas operaciones después de un pequeño delay para que journalData esté listo
    setTimeout(() => {
        if (typeof updateLatestTrades === 'function') {
            updateLatestTrades();
            
            // Retry si no se encontraron trades pero hay journalData
            setTimeout(() => {
                const journalData = window.journalData || JSON.parse(localStorage.getItem('journalData') || '{}');
                if (Object.keys(journalData).length > 0) {
                    updateLatestTrades();
                }
            }, 1000);
        }
    }, 500);
    
    // Retry en mobile para asegurar que el calendar esté visible
    setTimeout(() => {
        const bridge = document.getElementById('calendar');
        if (bridge && bridge.querySelector('.day-cell')) {
            // Llamar directamente la función
            const allDayCells = Array.from(bridge.querySelectorAll('.day-cell'));
            if (allDayCells.length > 0) {
                // Triggear el mirror nuevamente
                bridge.dispatchEvent(new CustomEvent('refresh-calendar'));
            }
        }
    }, 1000);

    function getAccountInitials(name) {
        const safe = String(name || '').trim();
        if (!safe) return 'AC';
        const parts = safe.split(/\s+/).filter(Boolean);
        const letters = parts
            .map(p => p.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/g, ''))
            .filter(p => p.length > 0);
        const initials = letters.slice(0, 2).map(p => p[0]).join('');
        return (initials || 'AC').toUpperCase();
    }

    function getAccountBalance(account) {
        // 🆕 Usar función centralizada de app.js si está disponible
        if (typeof window.calculateAccountBalance === 'function' && account?.id) {
            return window.calculateAccountBalance(account.id);
        }
        
        // Fallback: calcular manualmente (solo para cuenta actual)
        const initialBalance = account?.initial_balance ?? account?.balance ?? 0;
        let realBalance = Number(initialBalance);
        
        const journalData = window.journalData || {};
        Object.keys(journalData).forEach(dateKey => {
            const trades = journalData[dateKey] || [];
            trades.forEach(trade => {
                realBalance += (parseFloat(trade.profitUSD) || 0);
            });
        });
        
        return Number.isFinite(realBalance) ? realBalance : 0;
    }

    function syncAccountSwitcherVisual(accountId) {
        const accounts = window.accounts || {};
        const account = accounts[accountId];
        if (!account) return;

        const avatar = document.getElementById('accountSwitchAvatar');
        const nameEl = document.getElementById('accountSwitchName');
        const balanceEl = document.getElementById('accountSwitchBalance');

        const safeName = String(account.name || 'Cuenta').trim() || 'Cuenta';
        if (avatar) avatar.textContent = getAccountInitials(safeName);
        if (nameEl) nameEl.textContent = safeName;
        
        // 🆕 Usar balance state manager
        if (balanceEl) {
            let balance;
            if (window.balanceStateManager && accountId === window.currentAccount) {
                balance = window.balanceStateManager.getAccountBalance(accountId);
            } else {
                balance = getAccountBalance(account);
            }
            const safeBalance = Number(balance);
            const formatted = Number.isFinite(safeBalance) ? safeBalance : 0;
            balanceEl.textContent = `$${formatted.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
        }

        // Sync badge
        const syncBadge = document.getElementById('accountSyncBadge');
        const syncTooltip = document.getElementById('accountSyncBadgeTooltip');
        const isSynced = !!(account.mt_account_number || account.sync_provider === 'tradovate');
        let providerLabel = '';
        if (account.sync_provider === 'tradovate') {
            providerLabel = 'Tradovate';
        } else if (account.mt_account_number) {
            providerLabel = 'MetaTrader (MT4/MT5)';
        }
        if (syncBadge) {
            if (isSynced) {
                syncBadge.classList.remove('hidden');
                if (syncTooltip) {
                    syncTooltip.textContent = providerLabel ? `Cuenta sincronizada · ${providerLabel}` : 'Cuenta sincronizada';
                }
            } else {
                syncBadge.classList.add('hidden');
            }
        }

        const dropdownButtons = document.querySelectorAll('#accountDropdown button[class*="px-3 py-3"]');
        dropdownButtons.forEach((btn, index) => {
            const ids = Object.keys(accounts);
            const id = btn.dataset.accountId || ids[index];
            const isActive = id === accountId;

            btn.classList.toggle('bg-blue-600/20', isActive);
            btn.classList.toggle('border', isActive);
            btn.classList.toggle('border-blue-500/30', isActive);
            btn.classList.toggle('mb-2', isActive);
            btn.classList.toggle('hover:bg-blue-600/30', isActive);
            btn.classList.toggle('hover:bg-slate-800/50', !isActive);

            const existing = btn.querySelector('svg[data-active-check]');
            if (existing) existing.remove();
            if (isActive) {
                const wrap = btn.querySelector('.flex.items-center.gap-3');
                if (wrap) {
                    wrap.insertAdjacentHTML('beforeend', '<svg class="w-5 h-5 text-green-400" data-active-check="1" fill="currentColor" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>');
                }
            }
        });
    }

// REEMPLAZA TODA LA FUNCIÓN simplifyCalendarDisplay() CON ESTE CÓDIGO:

function simplifyCalendarDisplay() {
    const bridge = document.getElementById('calendar');
    const calendarDays = document.getElementById('calendarDays');
    const goToTodayBtn = document.getElementById('goToTodayBtn') || document.getElementById('todayBtn');
    if (!bridge || !calendarDays) return;

    bridge.style.setProperty('display', 'none', 'important');

    const monthYear = document.getElementById('monthYear');
    const currentMonth = document.getElementById('currentMonth');

    function injectForceStyles() {
        let styleEl = document.getElementById('calendar-force-styles');
        if (styleEl) styleEl.remove();
        
        styleEl = document.createElement('style');
        styleEl.id = 'calendar-force-styles';
        styleEl.textContent = `
            /* Ocultar bridge completamente */
            #calendar {
                display: none !important;
                visibility: hidden !important;
                position: absolute !important;
                left: -9999px !important;
            }
            
            /* Ocultar TODOS los day-header y weekly-header del bridge */
            #calendar .day-header,
            #calendar .weekend-header,
            #calendar .weekly-header {
                display: none !important;
            }
            
            /* Grid 7 columnas SIEMPRE para mantener línea horizontal */
            #calendarDays .days-grid {
                display: grid !important;
                grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
            }
            
            /* Day cell: Aspect ratio 1:1 SIEMPRE */
            #calendarDays .day-cell.aspect-square,
            #calendarDays .weekend-cell.aspect-square {
                aspect-ratio: 1 / 1 !important;
                overflow: hidden !important;
                cursor: pointer !important;
            }
            
            /* Contenido dentro de day-cell NO se expande */
            #calendarDays .day-cell.aspect-square > * {
                overflow: hidden !important;
                text-overflow: ellipsis !important;
            }
            
            /* Texto dentro debe ser pequeño y no salirse */
            #calendarDays .day-cell .day-number {
                line-height: 1.1 !important;
                max-height: fit-content !important;
            }
            
            #calendarDays .day-cell .day-result-circle {
                line-height: 1.1 !important;
                max-height: fit-content !important;
            }
            
            #calendarDays .day-cell .trades-count {
                line-height: 1.1 !important;
                max-height: fit-content !important;
            }
            
            /* Recap: Ancho completo, altura adaptativa */
            #calendarDays .weekly-summary {
                width: 100% !important;
                height: auto !important;
                min-height: 60px !important;
            }
            
            /* Mobile: altura más compacta */
            @media (max-width: 768px) {
                #calendarDays .weekly-summary {
                    min-height: 80px !important;
                    max-height: 120px !important;
                }
            }
            
            /* Desktop: altura baja */
            @media (min-width: 769px) {
                #calendarDays .weekly-summary {
                    min-height: 60px !important;
                    max-height: 80px !important;
                }
            }
            
            /* Recap NO debe tener aspect ratio */
            #calendarDays .weekly-summary.aspect-square {
                aspect-ratio: unset !important;
            }
            
            /* Colores de fondo para tarjetas de resultado diario */
            .day-result-circle.positive {
                background-color: rgb(22 101 52) !important; /* bg-green-800 */
                border-radius: 0.5rem !important;
                padding: 0.25rem 0.5rem !important;
            }
            
            .day-result-circle.negative {
                background-color: rgb(153 27 27) !important; /* bg-red-900 */
                border-radius: 0.5rem !important;
                padding: 0.25rem 0.5rem !important;
            }
            
            .day-result-circle.breakeven {
                background-color: rgb(146 64 14) !important; /* bg-amber-900 */
                border-radius: 0.5rem !important;
                padding: 0.25rem 0.5rem !important;
            }
        `;
        document.head.appendChild(styleEl);
    }

    // ========== ESTILIZAR DÍA ==========
    function styleDayCell(cell) {
        const isToday = cell.classList.contains('today');
        const isOtherMonth = cell.classList.contains('other-month');
        const tradesCount = cell.querySelector('.trades-count');
        const resultCircle = cell.querySelector('.day-result-circle');
        
        const rawCount = (tradesCount?.textContent || '').match(/\d+/);
        const hasActivity = rawCount && parseInt(rawCount[0]) > 0;
        
        // Determinar profit/loss desde resultCircle
        const isProfit = resultCircle?.classList.contains('positive');
        const isLoss = resultCircle?.classList.contains('negative');
        
        const keepClasses = ['day-cell', 'profit', 'loss', 'today', 'other-month'];
        cell.className = cell.className.split(' ').filter(c => keepClasses.includes(c)).join(' ');
        
        cell.classList.add(
            'aspect-square', 'rounded', 'md:rounded-lg', 'border', 'transition-all', 'duration-200',
            'p-0.5', 'sm:p-1', 'md:p-2', 'lg:p-3', 'xl:p-4', 'flex', 'flex-col',
            'justify-between',
            'relative', 'group', 'overflow-hidden'
        );
        
        if (isOtherMonth) {
            cell.classList.add('bg-transparent', 'border-transparent', 'invisible');
        } else if (isToday) {
            cell.classList.add('bg-blue-500/10', 'border-blue-500/50', 'ring-2', 'ring-blue-500/30');
            if (hasActivity) cell.classList.add('hover:scale-[1.02]', 'cursor-pointer');
        } else {
            if (isProfit) {
                cell.classList.add('bg-emerald-500/10', 'border-emerald-500/30', 'hover:bg-emerald-500/15', 'hover:border-emerald-500/40');
            } else if (isLoss) {
                cell.classList.add('bg-red-500/10', 'border-red-500/30', 'hover:bg-red-500/15', 'hover:border-red-500/40');
            } else {
                cell.classList.add('bg-slate-900/40', 'border-slate-800/60', 'hover:border-slate-700', 'hover:bg-slate-900/60');
            }
            
            if (hasActivity) {
                cell.classList.add('hover:scale-[1.02]', 'cursor-pointer');
            } else {
                cell.classList.add('cursor-default');
            }
        }

        const dayNumber = cell.querySelector('.day-number');
        if (dayNumber && !isOtherMonth) {
            dayNumber.className = 'text-[8px] sm:text-[9px] md:text-xs lg:text-sm xl:text-base font-black leading-none ' + 
                (isToday ? 'text-blue-400' : 'text-slate-200');
        }

        const dayContent = cell.querySelector('.day-content');
        if (dayContent) dayContent.classList.add('hidden');

        const dayTopInfo = cell.querySelector('.day-top-info');
        if (dayTopInfo) {
            dayTopInfo.className = 'flex flex-col items-center justify-center gap-0.5 flex-1';
        }

        if (resultCircle && !isOtherMonth) {
            const isPositive = resultCircle.classList.contains('positive');
            const isNegative = resultCircle.classList.contains('negative');
            const isBreakeven = resultCircle.classList.contains('breakeven');
            resultCircle.style.cssText = '';
            const baseClasses = 'text-[9px] sm:text-[10px] md:text-xs lg:text-sm xl:text-base font-black leading-none text-center';
            if (isPositive) {
                resultCircle.className = 'day-result-circle positive ' + baseClasses + ' text-emerald-400';
            } else if (isNegative) {
                resultCircle.className = 'day-result-circle negative ' + baseClasses + ' text-red-400';
            } else if (isBreakeven) {
                resultCircle.className = 'day-result-circle breakeven ' + baseClasses + ' text-amber-400';
            } else {
                resultCircle.className = 'day-result-circle ' + baseClasses + ' text-slate-400';
            }
            let text = (resultCircle.textContent || '').trim();
            const numMatch = text.match(/([+-]?\d+\.?\d*)/);
            if (numMatch && !text.includes('%')) {
                const num = parseFloat(numMatch[1]);
                resultCircle.textContent = (num > 0 ? '+' : '') + numMatch[1] + '%';
            }
        }

        if (tradesCount && !isOtherMonth) {
            const raw = (tradesCount.textContent || '').trim();
            const match = raw.match(/\d+/);
            const n = match ? parseInt(match[0]) : 0;
            tradesCount.className = 'text-[6px] sm:text-[7px] md:text-[8px] lg:text-[9px] font-semibold ' + (n > 0 ? 'text-slate-500' : 'text-slate-700');
            if (n === 0) {
                tradesCount.textContent = '—';
            } else if (n === 1) {
                tradesCount.textContent = '1 op';
            } else {
                tradesCount.textContent = n + ' ops';
            }
        }
    }

    // ========== WEEKEND ==========
    function styleWeekendCell(cell) {
        cell.className = 'weekend-cell aspect-square rounded-xl bg-slate-900/20 border border-slate-800/40 flex items-center justify-center';
        cell.innerHTML = '<span class="text-xs text-slate-700 font-medium">—</span>';
    }

    // ========== RECAP SEMANAL - RESPONSIVE ==========
    function styleWeeklyRecap(cell, weekNumber) {
        const allText = cell.textContent || '';
        const percentMatch = allText.match(/([+-]?\d+\.?\d*)%/);
        const tradesMatch = allText.match(/(\d+)\s*(?:trades?|ops?)/i);
        const wrMatch = allText.match(/(\d+)%?\s*WR/i);
        
        const rawPerformance = percentMatch ? percentMatch[1].replace(/[+-]/g, '') : '0';
        const perfNum = parseFloat(rawPerformance) || 0;
        const hasNegative = (percentMatch?.[1] || '').includes('-');
        const finalPerfNum = hasNegative ? -perfNum : perfNum;
        
        const trades = tradesMatch ? tradesMatch[1] : '0';
        const winRate = wrMatch ? wrMatch[1] : '0';
        const duration = cell.dataset.duration || '0m';
        
        const isPositive = finalPerfNum > 0;
        const isNegative = finalPerfNum < 0;
        const pnlClass = isPositive ? 'text-emerald-400' : isNegative ? 'text-red-400' : 'text-slate-400';
        const formattedPnl = (isPositive ? '+' : isNegative ? '-' : '') + Math.abs(finalPerfNum).toFixed(1) + '%';
        
        // Layout RESPONSIVE - horizontal en desktop, más compacto en mobile
        cell.className = 'weekly-summary w-full rounded-lg bg-gradient-to-r from-purple-500/10 via-purple-600/5 to-transparent border border-purple-500/30 p-1.5 md:p-2 lg:p-3 cursor-pointer hover:from-purple-500/15 hover:border-purple-500/40 transition-all duration-300';
        cell.dataset.weekNumber = weekNumber;
        
        // MOBILE: Layout apilado más compacto
        // DESKTOP: Layout horizontal
        cell.innerHTML = `
            <div class="flex flex-col gap-1.5 md:flex-row md:items-center md:justify-between md:gap-4">
                <!-- Header semana con botón toggle -->
                <div class="flex items-center gap-1.5">
                    <button class="week-toggle-btn flex-shrink-0 p-0.5 rounded transition-transform duration-300" aria-label="Toggle semana">
                        <svg class="week-chevron w-3 h-3 md:w-4 md:h-4 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                    </button>
                    <svg class="w-2.5 h-2.5 md:w-3 md:h-3 text-purple-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                    </svg>
                    <span class="text-[10px] md:text-xs font-black text-purple-300 tracking-wide">SEMANA ${weekNumber}</span>
                </div>
                
                <!-- Métricas - flex row en todos los tamaños, grid para la distribución -->
                <div class="grid grid-cols-2 md:flex md:items-center gap-2 md:gap-3 lg:gap-4">
                    <!-- Performance -->
                    <div class="flex flex-row items-center gap-1.5">
                        <span class="text-[7px] md:text-[9px] text-slate-500 font-semibold uppercase">Perf:</span>
                        <span class="text-sm md:text-base lg:text-lg font-black leading-none ${pnlClass}">${formattedPnl}</span>
                    </div>
                    
                    <!-- Operaciones -->
                    <div class="flex flex-row items-center gap-1.5">
                        <span class="text-[7px] md:text-[9px] text-slate-500 font-semibold uppercase">Ops:</span>
                        <span class="text-xs md:text-sm lg:text-base font-bold text-slate-200 leading-none">${trades}</span>
                    </div>
                    
                    <!-- Win Rate -->
                    <div class="flex flex-row items-center gap-1.5">
                        <span class="text-[7px] md:text-[9px] text-slate-500 font-semibold uppercase">WR:</span>
                        <span class="text-xs md:text-sm lg:text-base font-bold text-slate-200 leading-none">${winRate}%</span>
                    </div>
                    
                    <!-- Avg Duration -->
                    <div class="flex flex-row items-center gap-1.5">
                        <span class="text-[7px] md:text-[9px] text-slate-500 font-semibold uppercase">Avg:</span>
                        <span class="text-xs md:text-sm lg:text-base font-bold text-blue-300 leading-none">${duration}</span>
                    </div>
                </div>
            </div>
        `;
    }

    // ========== SINCRONIZAR ==========
    function syncMonthTitle() {
        if (!monthYear || !currentMonth) return;
        const text = (monthYear.textContent || '').trim();
        if (text) currentMonth.textContent = text;
    }

    function updateMonthlySummary(totalPnl, totalTrades, wins, totalActiveDays) {
        const pnlEl = document.getElementById('monthlyPnl');
        const tradesEl = document.getElementById('monthlyTrades');
        const wrEl = document.getElementById('monthlyWinRate');

        if (pnlEl) {
            const sign = totalPnl >= 0 ? '+' : '';
            pnlEl.textContent = `${sign}${totalPnl.toFixed(1)}%`;
            pnlEl.classList.remove('text-emerald-400', 'text-red-400');
            pnlEl.classList.add(totalPnl >= 0 ? 'text-emerald-400' : 'text-red-400');
        }
        if (tradesEl) tradesEl.textContent = String(totalTrades);
        if (wrEl) {
            const wr = totalActiveDays > 0 ? Math.round((wins / totalActiveDays) * 100) : 0;
            wrEl.textContent = `${wr}%`;
        }
        const activeDaysLabel = document.getElementById('activeDaysCount');
        if (activeDaysLabel) activeDaysLabel.textContent = `${totalActiveDays} días activos`;
    }

    // ========== MIRROR ==========
    function mirrorBridgeToTailwind() {
        const bridge = document.getElementById('calendar');
        
        if (!bridge) {
            return;
        }
        
        // ✅ FILTRAR: Solo obtener .day-cell (excluir headers y weekly-summary)
        const allDayCells = Array.from(bridge.querySelectorAll('.day-cell'));
        const weeklySummaries = Array.from(bridge.querySelectorAll('.weekly-summary'));

        if (allDayCells.length === 0) {
            return;
        }

        calendarDays.innerHTML = '';
        
        let monthlyTotalPnl = 0, monthlyTotalTrades = 0, monthlyWins = 0, monthlyActiveDays = 0;
        
        // ✅ AHORA SÍ: procesar por grupos de 7
        const daysPerWeek = 7;
        
        // 🆕 Solo iterar sobre las semanas que tienen resumen (no la semana 6 vacía)
        const weeks = weeklySummaries.length;

        for (let week = 0; week < weeks; week++) {
            const start = week * daysPerWeek;
            const weekCells = allDayCells.slice(start, start + daysPerWeek);
            
            if (weekCells.length === 0) break;

            const weekNumber = week + 1;
            
            // Detectar si esta semana contiene el día actual
            const today = new Date();
            const isCurrentWeek = weekCells.some(cell => {
                if (cell.dataset.date) {
                    const cellDate = new Date(cell.dataset.date + 'T00:00:00');
                    return cellDate.toDateString() === today.toDateString();
                }
                return false;
            });

            const weekContainer = document.createElement('div');
            weekContainer.className = 'space-y-2 md:space-y-3';
            weekContainer.dataset.week = String(weekNumber);
            weekContainer.dataset.expanded = isCurrentWeek ? 'true' : 'false';

            // ===== RECAP ARRIBA (toda la fila) =====
            const summary = weeklySummaries[week];
            if (summary) {
                const recap = summary.cloneNode(true);
                styleWeeklyRecap(recap, weekNumber);
                weekContainer.appendChild(recap);
            }

            // ===== GRID DE DÍAS (7 columnas) =====
            const daysGrid = document.createElement('div');
            daysGrid.className = `days-grid grid grid-cols-7 gap-0.5 sm:gap-1 md:gap-2 lg:gap-3 xl:gap-4 overflow-hidden ${isCurrentWeek ? 'opacity-100' : 'opacity-0 max-h-0'}`;
            daysGrid.dataset.weekDays = String(weekNumber);

            weekCells.forEach((cell) => {
                const clone = cell.cloneNode(true);
                
                // Copiar data-date
                if (cell.dataset.date) {
                    clone.dataset.date = cell.dataset.date;
                }

                if (clone.classList.contains('weekend-cell')) {
                    styleWeekendCell(clone);
                } else {
                    styleDayCell(clone);
                    if (!clone.classList.contains('other-month')) {
                        const resultCircle = clone.querySelector('.day-result-circle');
                        const tradesCount = clone.querySelector('.trades-count');
                        if (resultCircle) {
                            const pnlText = (resultCircle.textContent || '').replace(/[^0-9.\-+]/g, '');
                            const pnlVal = parseFloat(pnlText) || 0;
                            monthlyTotalPnl += pnlVal;
                            if (pnlVal > 0) monthlyWins++;
                        }
                        if (tradesCount) {
                            const countText = (tradesCount.textContent || '').match(/\d+/);
                            const count = countText ? parseInt(countText[0]) : 0;
                            if (count > 0) {
                                monthlyTotalTrades += count;
                                monthlyActiveDays++;
                            }
                        }
                    }
                }
                daysGrid.appendChild(clone);
            });

            weekContainer.appendChild(daysGrid);
            calendarDays.appendChild(weekContainer);
        }

        updateMonthlySummary(monthlyTotalPnl, monthlyTotalTrades, monthlyWins, monthlyActiveDays);
        syncMonthTitle();
        attachWeekToggles();
        
        setTimeout(injectForceStyles, 50);

        if (typeof window.markEconomicEventDates === 'function') {
            const cachedEvents = localStorage.getItem(EVENTS_CACHE_KEY);
            if (cachedEvents) {
                try {
                    const eventsData = JSON.parse(cachedEvents);
                    if (Array.isArray(eventsData) && eventsData.length > 0) {
                        window.markEconomicEventDates(eventsData);
                    }
                } catch (e) {
                    // Ignore cache parse errors
                }
            }
        }
    }
    
    // ========== TOGGLE WEEKS ==========
    function attachWeekToggles() {
        const recaps = calendarDays.querySelectorAll('.weekly-summary');
        recaps.forEach(recap => {
            recap.addEventListener('click', function(e) {
                e.stopPropagation();
                const weekNum = this.dataset.weekNumber;
                const weekContainer = this.closest('[data-week]');
                if (!weekContainer) return;
                
                const isExpanded = weekContainer.dataset.expanded === 'true';
                const daysGrid = weekContainer.querySelector('.days-grid');
                const chevron = this.querySelector('.week-chevron');
                
                if (!daysGrid) return;
                
                // Toggle estado
                weekContainer.dataset.expanded = isExpanded ? 'false' : 'true';
                
                if (isExpanded) {
                    // Colapsar
                    daysGrid.classList.remove('opacity-100');
                    daysGrid.classList.add('opacity-0', 'max-h-0');
                    if (chevron) chevron.style.transform = 'rotate(-90deg)';
                } else {
                    // Expandir  
                    daysGrid.classList.remove('opacity-0', 'max-h-0');
                    daysGrid.classList.add('opacity-100');
                    if (chevron) chevron.style.transform = 'rotate(0deg)';
                }
            });
        });
        
        // Inicializar chevrons según estado inicial
        const weekContainers = calendarDays.querySelectorAll('[data-week]');
        weekContainers.forEach(container => {
            const isExpanded = container.dataset.expanded === 'true';
            const chevron = container.querySelector('.week-chevron');
            if (chevron && !isExpanded) {
                chevron.style.transform = 'rotate(-90deg)';
            }
        });
    }

    // ========== UPDATE REAL-TIME METRICS ==========
    let selectedEquityPeriod = '1M'; // Período por defecto
    
    function filterTradesByPeriod(trades, period) {
        if (period === 'ALL' || trades.length === 0) return trades;
        
        const now = new Date();
        let cutoffDate = new Date();
        
        switch(period) {
            case '1W':
                cutoffDate.setDate(now.getDate() - 7);
                break;
            case '1M':
                cutoffDate.setMonth(now.getMonth() - 1);
                break;
            case '3M':
                cutoffDate.setMonth(now.getMonth() - 3);
                break;
            case '6M':
                cutoffDate.setMonth(now.getMonth() - 6);
                break;
            case '1Y':
                cutoffDate.setFullYear(now.getFullYear() - 1);
                break;
            default:
                return trades;
        }
        
        return trades.filter(trade => {
            const tradeDate = new Date((trade.trade_date || trade.date) + 'T00:00:00');
            return tradeDate >= cutoffDate;
        });
    }
    
    // 🆕 Actualizar solo el Balance Display sin recalcular todas las métricas
    async function updateBalanceDisplay() {
        const currentAccountData = window.accounts?.[window.currentAccount];
        if (!currentAccountData) return;

        if (window.refreshAccountTotalProfit && window.currentAccount) {
            try { await window.refreshAccountTotalProfit(window.currentAccount); } catch (e) {}
        }
        
        const initialBalance = currentAccountData?.initial_balance || currentAccountData?.balance || 10000;
        
        // Obtener balance actual de forma centralizada
        const currentBalance = window.balanceStateManager 
            ? window.balanceStateManager.getAccountBalance(window.currentAccount)
            : getAccountBalance(currentAccountData);
        
        // Calcular cambios
        const totalProfitUSD = currentBalance - initialBalance;
        const balanceChangePercent = ((totalProfitUSD / initialBalance) * 100);
        
        // Actualizar elementos
        const balanceEl = document.getElementById('currentBalance');
        const balanceChangeUSDEl = document.getElementById('balanceChangeUSD');
        const balanceChangePercentEl = document.getElementById('balanceChangePercent');
        
        // Mostrar balance actual
        if (balanceEl) {
            balanceEl.textContent = `$${currentBalance.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            balanceEl.className = `text-3xl font-bold bg-gradient-to-r ${totalProfitUSD >= 0 ? 'from-green-400 to-emerald-500' : 'from-red-400 to-red-500'} bg-clip-text text-transparent mb-1`;
        }
        if (balanceChangeUSDEl) {
            const sign = totalProfitUSD >= 0 ? '+' : '';
            balanceChangeUSDEl.textContent = `${sign}$${Math.abs(totalProfitUSD).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            balanceChangeUSDEl.className = `${totalProfitUSD >= 0 ? 'text-green-400' : 'text-red-400'}`;
        }
        if (balanceChangePercentEl) {
            const sign = balanceChangePercent >= 0 ? '+' : '';
            balanceChangePercentEl.textContent = `${sign}${balanceChangePercent.toFixed(2)}%`;
        }

        // Mantener sincronizado el balance del selector de cuenta
        if (typeof updateAccountSwitchUI === 'function' && window.currentAccount) {
            updateAccountSwitchUI(window.currentAccount);
        } else if (typeof window.updateAccountSwitchUI === 'function' && window.currentAccount) {
            window.updateAccountSwitchUI(window.currentAccount);
        }
    }
    
    // 🆕 Exponer globalmente para que pueda ser llamada desde otros contextos
    window.updateBalanceDisplay = updateBalanceDisplay;
    
    // 🆕 Exponer como función global para que changeMonth pueda llamarla
    async function updateRealTimeMetrics(targetDate = null) {
        const journalData = window.journalData || {};
        
        // Verificar si hay cuentas activas
        const accounts = window.accounts || {};
        if (Object.keys(accounts).length === 0) {
            // No hay cuentas, mostrar métricas vacías
            showEmptyMetrics();
            return;
        }
        
        // 🆕 CRITICAL FIX: Cuando cambias de mes, recalcular totalProfit desde BD
        // Esto asegura que el balance acumulativo sea correcto
        if (window.refreshAccountTotalProfit && window.currentAccount) {
            try { await window.refreshAccountTotalProfit(window.currentAccount); } catch (e) {}
        }
        
        // 🆕 Obtener initial_balance de la cuenta actual
        const currentAccountData = window.accounts?.[window.currentAccount];
        if (!currentAccountData) {
            // No hay cuenta actual, mostrar métricas vacías
            showEmptyMetrics();
            return;
        }
        
        const initialBalance = currentAccountData?.initial_balance || currentAccountData?.balance || 10000;
        
        // 🆕 BALANCE ACTUAL - Usar balanceStateManager que mantiene sincronizado con la UI
        // balanceStateManager calcula: initialBalance + totalProfit + cashflows
        let currentBalance = initialBalance;
        
        if (window.balanceStateManager && typeof window.balanceStateManager.getAccountBalance === 'function') {
            // Usar el gestor centralizado que está siempre sincronizado
            currentBalance = window.balanceStateManager.getAccountBalance(window.currentAccount);
        } else {
            // Fallback: calcular desde journalData si balanceStateManager no está disponible
            if (window.journalData && typeof window.journalData === 'object') {
                let totalProfit = 0;
                Object.entries(window.journalData).forEach(([dateKey, trades]) => {
                    if (Array.isArray(trades)) {
                        trades.forEach(trade => {
                            const profit = parseFloat(trade.profitUSD || trade.profit || 0) || 0;
                            totalProfit += profit;
                        });
                    }
                });
                currentBalance = initialBalance + totalProfit;
            }
        }
        
        // Obtener todos los trades del mes del calendario (no siempre el actual)
        const dateToUse = targetDate || new Date();
        const currentYear = dateToUse.getFullYear();
        const currentMonth = dateToUse.getMonth();
        
        let allTradesThisMonth = [];
        let allTradesEver = [];
        
        Object.keys(journalData).forEach(dateKey => {
            const trades = journalData[dateKey] || [];
            const tradeDate = new Date(dateKey + 'T00:00:00');
            
            trades.forEach(trade => {
                // Añadir dateKey al trade para que formatTradeDate pueda encontrar la fecha
                const tradeWithDate = { ...trade, date: trade.date || dateKey };
                allTradesEver.push(tradeWithDate);
                if (tradeDate.getFullYear() === currentYear && tradeDate.getMonth() === currentMonth) {
                    allTradesThisMonth.push(tradeWithDate);
                }
            });
        });
        
        // Ordenar trades por fecha
        allTradesEver.sort((a, b) => {
            const dateA = new Date((a.trade_date || a.date) + 'T00:00:00');
            const dateB = new Date((b.trade_date || b.date) + 'T00:00:00');
            return dateA - dateB;
        });
        
        allTradesThisMonth.sort((a, b) => {
            const dateA = new Date((a.trade_date || a.date) + 'T00:00:00');
            const dateB = new Date((b.trade_date || b.date) + 'T00:00:00');
            return dateA - dateB;
        });
        
        // 1. BALANCE ACTUAL (sistema adaptado de journal.html)
        const totalProfitUSD = currentBalance - initialBalance;
        
        const balanceEl = document.getElementById('currentBalance');
        const initialBalanceDisplayEl = document.getElementById('initialBalanceDisplay');
        const balanceChangeUSDEl = document.getElementById('balanceChangeUSD');
        const balanceChangePercentEl = document.getElementById('balanceChangePercent');
        
        // Mostrar balance actual (ACUMULATIVO)
        if (balanceEl) {
            balanceEl.textContent = `$${currentBalance.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            balanceEl.className = `text-3xl font-bold bg-gradient-to-r ${totalProfitUSD >= 0 ? 'from-green-400 to-emerald-500' : 'from-red-400 to-red-500'} bg-clip-text text-transparent mb-1`;
        }
        
        // Mostrar balance inicial (estático)
        if (initialBalanceDisplayEl) {
            initialBalanceDisplayEl.textContent = `$${initialBalance.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
        }
        
        // 2. WIN RATE (excluyendo trades BE)
        const beTrades = allTradesThisMonth.filter(t => isBreakEvenTrade(t, initialBalance));
        const beCount = beTrades.length;
        const tradesExcludingBE = allTradesThisMonth.filter(t => !isBreakEvenTrade(t, initialBalance));
        const wins = tradesExcludingBE.filter(t => (parseFloat(t.profitUSD) || 0) > 0).length;
        const totalTrades = allTradesThisMonth.length;
        const totalTradesExcludingBE = tradesExcludingBE.length;
        const winRate = totalTradesExcludingBE > 0 ? (wins / totalTradesExcludingBE) * 100 : 0;
        
        const winRatePercentEl = document.getElementById('winRatePercent');
        const winRateBarEl = document.getElementById('winRateBar');
        const winRateRatioEl = document.getElementById('winRateRatio');
        
        if (winRatePercentEl) winRatePercentEl.textContent = `${Math.round(winRate)}%`;
        if (winRateBarEl) {
            winRateBarEl.style.transition = 'none';
            winRateBarEl.style.width = `${winRate}%`;
        }
        if (winRateRatioEl) {
            // Mostrar formato: wins/totalExcludingBE - beCount BE
            if (beCount > 0) {
                winRateRatioEl.textContent = `${wins}/${totalTradesExcludingBE} - ${beCount} BE`;
            } else {
                winRateRatioEl.textContent = `${wins}/${totalTradesExcludingBE}`;
            }
        }
        
        // 3. TRADES MES
        const monthProfitUSD = allTradesThisMonth.reduce((sum, t) => sum + (parseFloat(t.profitUSD) || 0), 0);
        const monthResultPercent = ((monthProfitUSD / initialBalance) * 100);
        
        const tradesThisMonthEl = document.getElementById('tradesThisMonth');
        const tradesWonEl = document.getElementById('tradesWon');
        const tradesLostEl = document.getElementById('tradesLost');
        const tradesBEEl = document.getElementById('tradesBE');
        
        if (tradesThisMonthEl) tradesThisMonthEl.textContent = totalTrades;
        
        // Contar: ganados, perdidos, break even
        // IMPORTANTE: Contar sobre tradesExcludingBE para que no se superponga con beCount
        const tradesWon = tradesExcludingBE.filter(t => (parseFloat(t.profitUSD) || 0) > 0).length;
        const tradesLost = tradesExcludingBE.filter(t => (parseFloat(t.profitUSD) || 0) < 0).length;
        const tradesBreakEven = beCount; // Ya calculado en sección 2
        
        if (tradesWonEl) tradesWonEl.textContent = tradesWon;
        if (tradesLostEl) tradesLostEl.textContent = tradesLost;
        if (tradesBEEl) tradesBEEl.textContent = tradesBreakEven;
        
        // 🆕 Mostrar resultado del mes en TRADES MES
        const monthResultUSDEl = document.getElementById('monthResultUSD');
        const monthResultEl = document.getElementById('monthResult');
        
        if (monthResultUSDEl) {
            const sign = monthProfitUSD >= 0 ? '+' : '';
            monthResultUSDEl.textContent = `${sign}$${monthProfitUSD.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            monthResultUSDEl.className = monthProfitUSD >= 0 ? 'text-green-400 font-semibold' : 'text-red-400 font-semibold';
        }
        
        if (monthResultEl) {
            const sign = monthResultPercent >= 0 ? '+' : '';
            monthResultEl.textContent = `${sign}${monthResultPercent.toFixed(2)}%`;
            monthResultEl.className = monthResultPercent >= 0 ? 'text-green-400' : 'text-red-400';
        }
        
        // 🔄 ACTUALIZAR balanceChangeUSD y balanceChangePercent (ACUMULATIVO, en BALANCE ACTUAL)
        // Mostrar profit total desde inicio, no solo del mes
        const cumulativePercent = (totalProfitUSD / initialBalance) * 100;
        
        if (balanceChangeUSDEl) {
            const sign = totalProfitUSD >= 0 ? '+' : '';
            balanceChangeUSDEl.textContent = `${sign}$${totalProfitUSD.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            balanceChangeUSDEl.className = totalProfitUSD >= 0 ? 'text-green-400' : 'text-red-400';
        }
        if (balanceChangePercentEl) {
            const sign = cumulativePercent >= 0 ? '+' : '';
            balanceChangePercentEl.textContent = `${sign}${cumulativePercent.toFixed(2)}%`;
            balanceChangePercentEl.className = cumulativePercent >= 0 ? 'text-green-400' : 'text-red-400';
        }
        
        // 4. PROFIT FACTOR
        const totalWins = allTradesThisMonth.filter(t => (parseFloat(t.profitUSD) || 0) > 0).reduce((sum, t) => sum + parseFloat(t.profitUSD), 0);
        const totalLosses = Math.abs(allTradesThisMonth.filter(t => (parseFloat(t.profitUSD) || 0) < 0).reduce((sum, t) => sum + parseFloat(t.profitUSD), 0));
        // Si no hay pérdidas pero sí ganancias, mostrar 0.00 en lugar de infinito
        const profitFactor = totalLosses > 0 ? totalWins / totalLosses : 0;
        const avgWin = wins > 0 ? totalWins / wins : 0;
        
        const profitFactorEl = document.getElementById('profitFactor');
        const avgWinEl = document.getElementById('avgWin');
        
        if (profitFactorEl) profitFactorEl.textContent = profitFactor.toFixed(2);
        if (avgWinEl) avgWinEl.textContent = `$${Math.round(avgWin)}`;
        
        // 5. RACHA ACTUAL
        // 🆕 Filtrar trades BE (-0.1% a 0.1%)
        const allTradesThisMonthNoBE = allTradesThisMonth.filter(t => {
            const profitPercent = (parseFloat(t.profitUSD) || 0) / initialBalance * 100;
            return profitPercent < -0.1 || profitPercent > 0.1;
        });
        
        let currentStreak = 0;
        let bestStreak = 0;
        let worstStreak = 0;
        let tempStreak = 0;
        
        // Calcular racha ACTUAL (últimos trades consecutivos)
        for (let i = allTradesThisMonthNoBE.length - 1; i >= 0; i--) {
            const profit = parseFloat(allTradesThisMonthNoBE[i].profitUSD) || 0;
            if (i === allTradesThisMonthNoBE.length - 1) {
                currentStreak = profit > 0 ? 1 : profit < 0 ? -1 : 0;
            } else {
                const prevProfit = parseFloat(allTradesThisMonthNoBE[i + 1].profitUSD) || 0;
                if ((profit > 0 && prevProfit > 0) || (profit < 0 && prevProfit < 0)) {
                    currentStreak = profit > 0 ? Math.abs(currentStreak) + 1 : -(Math.abs(currentStreak) + 1);
                } else {
                    break;
                }
            }
        }
        
        // Calcular mejor y peor racha
        for (let i = 0; i < allTradesThisMonthNoBE.length; i++) {
            const profit = parseFloat(allTradesThisMonthNoBE[i].profitUSD) || 0;
            if (profit > 0) {
                tempStreak = tempStreak > 0 ? tempStreak + 1 : 1;
            } else {
                tempStreak = tempStreak < 0 ? tempStreak - 1 : -1;
            }
            if (tempStreak > 0 && tempStreak > bestStreak) {
                bestStreak = tempStreak;
            } else if (tempStreak < 0 && tempStreak < worstStreak) {
                worstStreak = tempStreak;
            }
        }
        
        const currentStreakEl = document.getElementById('currentStreak');
        const bestStreakEl = document.getElementById('bestStreak');
        const worstStreakEl = document.getElementById('worstStreak');
        
        if (currentStreakEl) {
            const sign = currentStreak > 0 ? '+' : '';
            currentStreakEl.textContent = currentStreak === 0 ? '0' : `${sign}${currentStreak}`;
            currentStreakEl.className = `text-3xl font-bold ${currentStreak > 0 ? 'text-green-400' : currentStreak < 0 ? 'text-red-400' : 'text-slate-400'} mb-3`;
        }
        
        // Mostrar mejor racha y peor racha en elementos separados
        if (bestStreakEl) {
            bestStreakEl.textContent = bestStreak > 0 ? bestStreak : '0';
        }
        
        if (worstStreakEl) {
            worstStreakEl.textContent = worstStreak < 0 ? Math.abs(worstStreak) : '0';
        }
        
        // 6. CURVA DE EQUITY (sin filtrar - mostrar TODOS los trades históricos)
        updateEquityCurve(allTradesEver, initialBalance);
        
        // 7. AVG TRADE DURATION
        updateTradeDuration(allTradesThisMonth, initialBalance);
        
        // 8. CONTROL EMOCIONAL
        updateEmotionalControl(allTradesThisMonth, initialBalance);
        
        // 9. MEJOR/PEOR TRADE DEL MES
        updateBestWorstTrades(allTradesThisMonth, initialBalance);
        
        // 10. SHORTS VS LONGS GANADORES
        updateShortsLongsChart(allTradesThisMonth, initialBalance);
    }
    
    function updateEquityCurve(trades, initialBalance) {
        const svg = document.getElementById('equityCurve');
        const yAxis = document.getElementById('equityYAxis');
        const hoverLine = document.getElementById('hoverLine');
        
        if (!svg) return;
        
        // Reiniciar hover line y tooltip para evitar que se queden visibles
        if (hoverLine) {
            hoverLine.setAttribute('opacity', '0');
            hoverLine.setAttribute('x1', '0');
            hoverLine.setAttribute('x2', '0');
        }
        
        const tooltip = document.getElementById('equityTooltip');
        if (tooltip) {
            tooltip.classList.add('hidden');
        }
        
        // Si no hay trades, mostrar línea plana
        if (trades.length === 0) {
            const equityLine = document.getElementById('equityLine');
            const equityArea = document.getElementById('equityArea');
            const pointsContainer = document.getElementById('equityPoints');
            
            if (equityLine) equityLine.setAttribute('d', 'M 0 125 L 800 125');
            if (equityArea) equityArea.setAttribute('d', 'M 0 125 L 800 125 L 800 250 L 0 250 Z');
            if (pointsContainer) pointsContainer.innerHTML = '';
            
            // Actualizar labels del eje Y para el balance inicial
            if (yAxis) {
                const k = initialBalance >= 1000 ? (initialBalance / 1000).toFixed(1) + 'k' : initialBalance.toFixed(0);
                const spans = yAxis.querySelectorAll('span');
                spans.forEach(span => span.textContent = `$${k}`);
            }
            return;
        }
        
        // Calcular equity points
        let equity = initialBalance;
        const equityPoints = [{x: 0, balance: initialBalance, trade: null}];
        
        trades.forEach((trade, idx) => {
            equity += (parseFloat(trade.profitUSD) || 0);
            equityPoints.push({x: idx + 1, balance: equity, trade: trade});
        });
        
        const maxBalance = Math.max(...equityPoints.map(p => p.balance));
        const minBalance = Math.min(...equityPoints.map(p => p.balance));
        const range = maxBalance - minBalance || 1;
        const finalBalance = equityPoints[equityPoints.length - 1].balance;
        const isPositive = finalBalance >= initialBalance;
        
        // Dimensiones SVG - Usar viewBox pero asegurar que el container respete límites
        const width = 800;  // viewBox width (fijo para cálculos)
        const height = 250;  // viewBox height (fijo para cálculos)
        const xStep = width / (equityPoints.length - 1 || 1);
        
        // Asegurar que el SVG no cause overflow
        svg.style.maxWidth = '100%';
        svg.style.overflow = 'hidden';
        
        // Convertir a coordenadas SVG
        const points = equityPoints.map((p, i) => ({
            x: i * xStep,
            y: height - ((p.balance - minBalance) / range) * height,
            balance: p.balance,
            trade: p.trade,
            index: i
        }));
        
        // Generar curva suave usando Bézier (Catmull-Rom spline)
        const generateSmoothPath = (points) => {
            if (points.length < 2) return '';
            
            let path = `M ${points[0].x} ${points[0].y}`;
            
            for (let i = 0; i < points.length - 1; i++) {
                const current = points[i];
                const next = points[i + 1];
                
                // Puntos de control para curva cuadrática suave
                const tension = 0.3;
                const controlX = current.x + (next.x - current.x) * tension;
                const controlY = current.y + (next.y - current.y) * tension;
                
                // Usar curva cuadrática para suavidad
                path += ` Q ${controlX} ${current.y}, ${(current.x + next.x) / 2} ${(current.y + next.y) / 2}`;
                
                if (i < points.length - 2) {
                    path += ` T ${next.x} ${next.y}`;
                } else {
                    path += ` L ${next.x} ${next.y}`;
                }
            }
            
            return path;
        };
        
        const smoothPath = generateSmoothPath(points);
        
        // Actualizar línea principal
        const equityLine = document.getElementById('equityLine');
        if (equityLine) {
            equityLine.setAttribute('d', smoothPath);
            equityLine.setAttribute('stroke', isPositive ? '#10b981' : '#ef4444');
        }
        
        // Actualizar área bajo la curva
        const equityArea = document.getElementById('equityArea');
        if (equityArea) {
            const areaPath = `${smoothPath} L ${width} ${height} L 0 ${height} Z`;
            equityArea.setAttribute('d', areaPath);
            const gradientId = isPositive ? 'gradientPositive' : finalBalance < initialBalance ? 'gradientNegative' : 'gradientNeutral';
            equityArea.setAttribute('fill', `url(#${gradientId})`);
        }
        
        // Actualizar Y-axis labels
        if (yAxis) {
            const labels = [
                maxBalance,
                maxBalance * 0.75 + minBalance * 0.25,
                (maxBalance + minBalance) / 2,
                maxBalance * 0.25 + minBalance * 0.75,
                minBalance
            ];
            const spans = yAxis.querySelectorAll('span');
            labels.forEach((val, i) => {
                if (spans[i]) {
                    const k = val >= 1000 ? (val / 1000).toFixed(1) + 'k' : val.toFixed(0);
                    spans[i].textContent = `$${k}`;
                }
            });
        }
        
        // Limpiar y agregar puntos interactivos
        const pointsContainer = document.getElementById('equityPoints');
        if (pointsContainer) {
            pointsContainer.innerHTML = '';
            
            // Solo mostrar algunos puntos clave para no saturar
            const keyIndices = [
                0,
                Math.floor(points.length * 0.25),
                Math.floor(points.length * 0.5),
                Math.floor(points.length * 0.75),
                points.length - 1
            ];
            
            keyIndices.forEach(idx => {
                if (idx < points.length) {
                    const p = points[idx];
                    const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                    circle.setAttribute('cx', p.x);
                    circle.setAttribute('cy', p.y);
                    circle.setAttribute('r', 4);
                    circle.setAttribute('fill', isPositive ? '#10b981' : '#ef4444');
                    circle.setAttribute('stroke', '#0f172a');
                    circle.setAttribute('stroke-width', 2);
                    circle.setAttribute('class', 'equity-point');
                    circle.style.cursor = 'pointer';
                    circle.style.transition = 'all 0.2s';
                    
                    // Hover effect
                    circle.addEventListener('mouseenter', function() {
                        this.setAttribute('r', 6);
                    });
                    circle.addEventListener('mouseleave', function() {
                        this.setAttribute('r', 4);
                    });
                    
                    pointsContainer.appendChild(circle);
                }
            });
        }
        
        // Agregar interactividad con tooltip
        const hoverArea = document.getElementById('equityHoverArea');
        // hoverLine ya fue declarada arriba
        // const hoverLine = document.getElementById('hoverLine');  // ❌ Removido para evitar duplicado
        
        if (hoverArea && tooltip) {
            // Remover listeners anteriores clonando el elemento
            const newHoverArea = hoverArea.cloneNode(false);
            hoverArea.parentNode.replaceChild(newHoverArea, hoverArea);
            
            // Agregar nuevos listeners al elemento clonado
            newHoverArea.addEventListener('mousemove', (e) => {
                const svgRect = svg.getBoundingClientRect();
                const x = ((e.clientX - svgRect.left) / svgRect.width) * width;
                
                // Encontrar punto más cercano
                let closestPoint = points[0];
                let minDist = Math.abs(points[0].x - x);
                
                points.forEach(p => {
                    const dist = Math.abs(p.x - x);
                    if (dist < minDist) {
                        minDist = dist;
                        closestPoint = p;
                    }
                });
                
                // Mostrar línea vertical (DISABLED - nunca mostrar hoverLine)
                if (hoverLine) {
                    hoverLine.setAttribute('x1', closestPoint.x);
                    hoverLine.setAttribute('x2', closestPoint.x);
                    hoverLine.setAttribute('opacity', '0'); // ❌ Siempre 0, nunca 0.5
                    hoverLine.style.opacity = '0 !important';
                }
                
                // Actualizar tooltip
                const tooltipTradeNum = document.getElementById('tooltipTradeNum');
                const tooltipBalance = document.getElementById('tooltipBalance');
                const tooltipPnl = document.getElementById('tooltipPnl');
                
                if (tooltipTradeNum) tooltipTradeNum.textContent = closestPoint.index;
                if (tooltipBalance) {
                    tooltipBalance.textContent = `$${closestPoint.balance.toFixed(2)}`;
                }
                if (tooltipPnl && closestPoint.trade) {
                    const pnl = parseFloat(closestPoint.trade.profitUSD) || 0;
                    const sign = pnl >= 0 ? '+' : '';
                    tooltipPnl.textContent = `${sign}$${pnl.toFixed(2)}`;
                    tooltipPnl.className = `font-bold ${pnl >= 0 ? 'text-green-400' : 'text-red-400'}`;
                }
                
                // Posicionar tooltip
                const tooltipX = e.clientX - svgRect.left + 10;
                const tooltipY = e.clientY - svgRect.top - 20;
                tooltip.style.left = `${tooltipX}px`;
                tooltip.style.top = `${tooltipY}px`;
                tooltip.classList.remove('hidden');
            });
            
            newHoverArea.addEventListener('mouseleave', () => {
                if (hoverLine) hoverLine.setAttribute('opacity', '0');
                tooltip.classList.add('hidden');
            });
        }
    }
    
    // 🆕 Exponer updateRealTimeMetrics globalmente para que changeMonth pueda llamarla
    window.updateRealTimeMetrics = updateRealTimeMetrics;
    window.updateTradeDuration = updateTradeDuration;
    window.updateEquityCurve = updateEquityCurve;
    window.updateShortsLongsChart = updateShortsLongsChart;
    
    function updateTradeDuration(trades, initialBalance) {
        const durationCard = document.getElementById('tradeDurationCard');
        const userPlan = (sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'free').toLowerCase().trim();
        
        const avgDurationEl = document.getElementById('avgDuration');
        const shortestTradeEl = document.getElementById('shortestTrade');
        const longestTradeEl = document.getElementById('longestTrade');
        const shortestBarEl = document.getElementById('shortestTradeBar');
        const longestBarEl = document.getElementById('longestTradeBar');
        const winRateShortEl = document.getElementById('winRateShort');
        const winRateLongEl = document.getElementById('winRateLong');
        
        // Mostrar card solo si NO es plan FREE
        if (durationCard) {
            if (userPlan === 'free') {
                durationCard.style.display = 'none';
            } else {
                durationCard.style.display = '';
            }
        }
        
        if (trades.length === 0) {
            // Sin trades: mostrar --
            if (avgDurationEl) avgDurationEl.textContent = '--';
            if (shortestTradeEl) shortestTradeEl.textContent = '--';
            if (longestTradeEl) longestTradeEl.textContent = '--';
            if (shortestBarEl) shortestBarEl.style.width = '0%';
            if (longestBarEl) longestBarEl.style.width = '0%';
            if (winRateShortEl) winRateShortEl.textContent = '0%';
            if (winRateLongEl) winRateLongEl.textContent = '0%';
            return;
        }
        
        const durations = [];
        
        trades.forEach(trade => {
            const entry = trade.entryTime || trade.entry_time || '';
            const exit = trade.exitTime || trade.exit_time || '';
            if (entry && exit) {
                const [eH, eM] = entry.split(':').map(Number);
                const [xH, xM] = exit.split(':').map(Number);
                const minutes = (xH * 60 + xM) - (eH * 60 + eM);
                if (minutes > 0) {
                    durations.push(minutes);
                }
            }
        });
        
        if (durations.length === 0) {
            // Hay trades pero sin duración: mostrar --
            if (avgDurationEl) avgDurationEl.textContent = '--';
            if (shortestTradeEl) shortestTradeEl.textContent = '--';
            if (longestTradeEl) longestTradeEl.textContent = '--';
            if (shortestBarEl) shortestBarEl.style.width = '0%';
            if (longestBarEl) longestBarEl.style.width = '0%';
            if (winRateShortEl) winRateShortEl.textContent = '0%';
            if (winRateLongEl) winRateLongEl.textContent = '0%';
            return;
        }
        
        // Mostrar card si hay datos y NO es plan FREE
        if (durationCard) {
            if (userPlan === 'free') {
                durationCard.style.display = 'none';
            } else {
                durationCard.style.display = '';
            }
        }
        
        // Calcular threshold dinámico basado en el promedio real
        const avgMinutes = durations.reduce((a, b) => a + b, 0) / durations.length;
        const dynamicThreshold = avgMinutes;
        
        // Actualizar label dinámico
        const thresholdLabel = document.getElementById('thresholdLabel');
        if (thresholdLabel) {
            const formatThreshold = (mins) => {
                if (mins >= 60) {
                    const h = Math.floor(mins / 60);
                    const m = Math.round(mins % 60);
                    return m > 0 ? `≤${h}h ${m}m` : `≤${h}h`;
                }
                return `≤${Math.round(mins)}m`;
            };
            thresholdLabel.textContent = formatThreshold(dynamicThreshold);
        }
        
        // Clasificar trades usando el threshold dinámico y calcular win rates (excluyendo BE)
        let shortWins = 0, shortTotal = 0, shortBE = 0;
        let longWins = 0, longTotal = 0, longBE = 0;
        
        trades.forEach(trade => {
            const entry = trade.entryTime || trade.entry_time || '';
            const exit = trade.exitTime || trade.exit_time || '';
            if (entry && exit) {
                const [eH, eM] = entry.split(':').map(Number);
                const [xH, xM] = exit.split(':').map(Number);
                const minutes = (xH * 60 + xM) - (eH * 60 + eM);
                if (minutes > 0) {
                    const profit = parseFloat(trade.profitUSD || 0);
                    const isBE = isBreakEvenTrade(trade, initialBalance);
                    
                    if (minutes <= dynamicThreshold) {
                        shortTotal++;
                        if (isBE) {
                            shortBE++;
                        } else if (profit > 0) {
                            shortWins++;
                        }
                    } else {
                        longTotal++;
                        if (isBE) {
                            longBE++;
                        } else if (profit > 0) {
                            longWins++;
                        }
                    }
                }
            }
        });
        const shortestMinutes = Math.min(...durations);
        const longestMinutes = Math.max(...durations);
        
        const formatDuration = (mins) => {
            if (mins >= 60) {
                const h = Math.floor(mins / 60);
                const m = Math.round(mins % 60);
                return m > 0 ? `${h}h ${m}m` : `${h}h`;
            }
            return `${Math.round(mins)}m`;
        };
        
        if (avgDurationEl) avgDurationEl.textContent = formatDuration(avgMinutes);
        if (shortestTradeEl) shortestTradeEl.textContent = formatDuration(shortestMinutes);
        if (longestTradeEl) longestTradeEl.textContent = formatDuration(longestMinutes);
        if (shortestBarEl) shortestBarEl.style.width = `${(shortestMinutes / longestMinutes) * 100}%`;
        if (longestBarEl) longestBarEl.style.width = '100%';
        
        // Win rates por duración (excluyendo BE)
        const shortTotalExcludingBE = shortTotal - shortBE;
        const longTotalExcludingBE = longTotal - longBE;
        const shortWinRate = shortTotalExcludingBE > 0 ? Math.round((shortWins / shortTotalExcludingBE) * 100) : 0;
        const longWinRate = longTotalExcludingBE > 0 ? Math.round((longWins / longTotalExcludingBE) * 100) : 0;
        if (winRateShortEl) winRateShortEl.textContent = `${shortWinRate}%`;
        if (winRateLongEl) winRateLongEl.textContent = `${longWinRate}%`;
    }

    function updateEmotionalControl(trades, initialBalance) {
        const emotionalScoreEl = document.getElementById('emotionalScore');
        const emotionalScoreBarEl = document.getElementById('emotionalScoreBar');
        const revengeTradesEl = document.getElementById('revengeTrades');
        const revengeWinRateEl = document.getElementById('revengeWinRate');
        
        if (!emotionalScoreEl) return;
        
        if (trades.length === 0) {
            emotionalScoreEl.textContent = '--';
            if (emotionalScoreBarEl) emotionalScoreBarEl.style.width = '0%';
            if (revengeTradesEl) revengeTradesEl.textContent = '0';
            if (revengeWinRateEl) revengeWinRateEl.textContent = '0%';
            return;
        }
        
        // Ordenar trades por fecha y hora
        const sortedTrades = [...trades].sort((a, b) => {
            const dateA = new Date((a.trade_date || a.date) + 'T' + (a.exitTime || a.exit_time || '00:00'));
            const dateB = new Date((b.trade_date || b.date) + 'T' + (b.exitTime || b.exit_time || '00:00'));
            return dateA - dateB;
        });
        
        // Detectar revenge trades (trades abiertos dentro de 30 min después de una pérdida)
        let revengeTrades = [];
        for (let i = 1; i < sortedTrades.length; i++) {
            const prevTrade = sortedTrades[i - 1];
            const currentTrade = sortedTrades[i];
            
            const prevProfit = parseFloat(prevTrade.profitUSD) || 0;
            if (prevProfit < 0) {
                const prevExit = prevTrade.exitTime || prevTrade.exit_time || '00:00';
                const currentEntry = currentTrade.entryTime || currentTrade.entry_time || '00:00';
                
                if (prevExit && currentEntry) {
                    const [prevH, prevM] = prevExit.split(':').map(Number);
                    const [currH, currM] = currentEntry.split(':').map(Number);
                    const minutesDiff = (currH * 60 + currM) - (prevH * 60 + prevM);
                    
                    // Si abrió dentro de 30 minutos después de la pérdida
                    if (minutesDiff >= 0 && minutesDiff <= 30) {
                        revengeTrades.push(currentTrade);
                    }
                }
            }
        }
        
        // Calcular score (100 = perfecto, 0 = muchos impulsos)
        const revengeCount = revengeTrades.length;
        const revengePercentage = (revengeCount / trades.length) * 100;
        const score = Math.max(0, Math.round(100 - (revengePercentage * 2))); // Penaliza x2
        
        // Win rate de revenge trades (excluyendo BE)
        const revengeBE = revengeTrades.filter(t => isBreakEvenTrade(t, initialBalance)).length;
        const revengeExcludingBE = revengeTrades.filter(t => !isBreakEvenTrade(t, initialBalance));
        const revengeWins = revengeExcludingBE.filter(t => (parseFloat(t.profitUSD) || 0) > 0).length;
        const revengeCountExcludingBE = revengeExcludingBE.length;
        const revengeWinRate = revengeCountExcludingBE > 0 ? Math.round((revengeWins / revengeCountExcludingBE) * 100) : 0;
        
        // Actualizar UI
        emotionalScoreEl.textContent = score;
        
        // Color del score según nivel
        let scoreColor = 'text-green-400';
        let barColor = 'bg-gradient-to-r from-green-500 to-emerald-500';
        if (score < 50) {
            scoreColor = 'text-red-400';
            barColor = 'bg-gradient-to-r from-red-500 to-rose-500';
        } else if (score < 80) {
            scoreColor = 'text-yellow-400';
            barColor = 'bg-gradient-to-r from-yellow-500 to-orange-500';
        }
        
        emotionalScoreEl.className = `text-2xl font-bold ${scoreColor}`;
        
        if (emotionalScoreBarEl) {
            emotionalScoreBarEl.style.width = `${score}%`;
            emotionalScoreBarEl.className = `h-full ${barColor}`;
        }
        
        if (revengeTradesEl) {
            revengeTradesEl.textContent = revengeCount;
            revengeTradesEl.className = revengeCount === 0 ? 'text-lg font-bold text-green-400' : 'text-lg font-bold text-red-400';
        }
        
        if (revengeWinRateEl) {
            revengeWinRateEl.textContent = `${revengeWinRate}%`;
            revengeWinRateEl.className = revengeWinRate >= 50 ? 'text-lg font-bold text-green-400' : 'text-lg font-bold text-red-400';
        }
    }

    function updateBestWorstTrades(trades, initialBalance) {
        const bestTradeCard = document.getElementById('bestTradeCard');
        const worstTradeCard = document.getElementById('worstTradeCard');
        const noTradesMessage = document.getElementById('noTradesMessage');
        
        if (!bestTradeCard || !worstTradeCard) return;
        
        if (trades.length === 0) {
            bestTradeCard.classList.add('hidden');
            worstTradeCard.classList.add('hidden');
            if (noTradesMessage) noTradesMessage.classList.remove('hidden');
            return;
        }
        
        // Separar trades ganadores y perdedores
        const winningTrades = trades.filter(t => (parseFloat(t.profitUSD) || 0) > 0);
        const losingTrades = trades.filter(t => (parseFloat(t.profitUSD) || 0) < 0);
        
        // Encontrar mejor trade (mayor ganancia) solo si hay ganancias
        const bestTrade = winningTrades.length > 0 
            ? winningTrades.reduce((max, t) => (parseFloat(t.profitUSD) || 0) > (parseFloat(max.profitUSD) || 0) ? t : max)
            : null;
        
        // Encontrar peor trade (mayor pérdida) solo si hay pérdidas
        const worstTrade = losingTrades.length > 0
            ? losingTrades.reduce((min, t) => (parseFloat(t.profitUSD) || 0) < (parseFloat(min.profitUSD) || 0) ? t : min)
            : null;
        
        // Ocultar mensaje de "sin trades"
        if (noTradesMessage) noTradesMessage.classList.add('hidden');
        
        // Formatear fecha
        const formatTradeDate = (trade) => {
            const dateStr = trade?.date || trade?.trade_date;
            if (!dateStr) return 'Sin fecha';
            const date = new Date(dateStr + 'T00:00:00');
            if (isNaN(date.getTime())) return 'Fecha inválida';
            const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
            return `${date.getDate()} ${months[date.getMonth()]}`;
        };
        
        // Actualizar mejor trade (solo si existe)
        if (bestTrade) {
            bestTradeCard.classList.remove('hidden');
            const bestProfit = parseFloat(bestTrade.profitUSD) || 0;
            const bestProfitPercent = ((bestProfit / initialBalance) * 100).toFixed(2);
            
            document.getElementById('bestTradePair').textContent = bestTrade.pair || bestTrade.symbol || '--';
            
            const bestDirection = document.getElementById('bestTradeDirection');
            const direction = (bestTrade.direction || 'LONG').toUpperCase();
            bestDirection.textContent = direction;
            bestDirection.className = `text-[10px] px-1.5 py-0.5 rounded font-medium ${
                direction === 'LONG' ? 'bg-green-600/20 text-green-400' : 'bg-red-600/20 text-red-400'
            }`;
            
            document.getElementById('bestTradeProfit').textContent = `+${bestProfitPercent}%`;
            document.getElementById('bestTradeDate').textContent = formatTradeDate(bestTrade);
        } else {
            bestTradeCard.classList.add('hidden');
        }
        
        // Actualizar peor trade (solo si existe)
        if (worstTrade) {
            worstTradeCard.classList.remove('hidden');
            const worstProfit = parseFloat(worstTrade.profitUSD) || 0;
            const worstProfitPercent = ((worstProfit / initialBalance) * 100).toFixed(2);
            
            document.getElementById('worstTradePair').textContent = worstTrade.pair || worstTrade.symbol || '--';
            
            const worstDirection = document.getElementById('worstTradeDirection');
            const direction = (worstTrade.direction || 'LONG').toUpperCase();
            worstDirection.textContent = direction;
            worstDirection.className = `text-[10px] px-1.5 py-0.5 rounded font-medium ${
                direction === 'LONG' ? 'bg-green-600/20 text-green-400' : 'bg-red-600/20 text-red-400'
            }`;
            
            document.getElementById('worstTradeProfit').textContent = `${worstProfitPercent}%`;
            document.getElementById('worstTradeDate').textContent = formatTradeDate(worstTrade);
        } else {
            worstTradeCard.classList.add('hidden');
        }
        
        // Si no hay ni mejor ni peor, mostrar mensaje
        if (!bestTrade && !worstTrade && noTradesMessage) {
            noTradesMessage.classList.remove('hidden');
        }
    }
    
    // 🆕 Exponer globalmente para que pueda ser llamada desde otros contextos
    window.updateBestWorstTrades = updateBestWorstTrades;

    // 🆕 ACTUALIZAR GRÁFICO DE SHORTS VS LONGS
    function updateShortsLongsChart(trades, initialBalance) {
        let longsCount = 0;
        let shortsCount = 0;
        let longsWin = 0;
        let shortsWin = 0;
        let longsProfit = 0;
        let shortsProfit = 0;
        
        // Contar todos los trades y calcular ganancias por dirección
        trades.forEach(trade => {
            const profit = parseFloat(trade.profitUSD) || 0;
            // Si no hay dirección definida, tratar como LONG
            const direction = (trade.direction || 'LONG').toUpperCase();
            
            if (direction === 'LONG' || direction === '') {
                longsCount++;
                longsProfit += profit;
                if (profit > 0) longsWin++;
            } else if (direction === 'SHORT') {
                shortsCount++;
                shortsProfit += profit;
                if (profit > 0) shortsWin++;
            }
        });
        
        const totalTrades = longsCount + shortsCount;
        const totalWins = longsWin + shortsWin;
        const totalProfit = longsProfit + shortsProfit;
        const longsWinPercent = longsCount > 0 ? ((longsWin / longsCount) * 100).toFixed(1) : 0;
        const shortsWinPercent = shortsCount > 0 ? ((shortsWin / shortsCount) * 100).toFixed(1) : 0;
        const totalWinPercent = totalTrades > 0 ? ((totalWins / totalTrades) * 100).toFixed(1) : 0;
        
        // Actualizar totales de trades
        document.getElementById('longsTotal').textContent = longsCount;
        document.getElementById('shortsTotal').textContent = shortsCount;
        
        // Actualizar barra de progreso: Rentabilidad comparativa
        // Muestra qué % del beneficio total viene de cada lado
        let longsRentabilidad = 0;
        let shortsRentabilidad = 0;
        
        if (totalProfit > 0) {
            // Si hay ganancias totales positivas
            longsRentabilidad = longsProfit > 0 ? (longsProfit / totalProfit) * 100 : 0;
            shortsRentabilidad = shortsProfit > 0 ? (shortsProfit / totalProfit) * 100 : 0;
        } else if (totalProfit < 0) {
            // Si hay pérdidas totales, mostrar cuál pierde menos
            const absTotalProfit = Math.abs(totalProfit);
            longsRentabilidad = longsProfit !== 0 ? (Math.abs(longsProfit) / absTotalProfit) * 100 : 0;
            shortsRentabilidad = shortsProfit !== 0 ? (Math.abs(shortsProfit) / absTotalProfit) * 100 : 0;
        }
        
        // Estos elementos ya no existen en el nuevo diseño, así que comentamos su acceso
        // document.getElementById('longsProgressBar').style.width = longsRentabilidad + '%';
        // document.getElementById('shortsProgressBar').style.width = shortsRentabilidad + '%';
        // document.getElementById('longsProgressText').textContent = longsRentabilidad > 5 ? longsRentabilidad.toFixed(0) + '%' : '';
        // document.getElementById('shortsProgressText').textContent = shortsRentabilidad > 5 ? shortsRentabilidad.toFixed(0) + '%' : '';
        
        // Mostrar ganancias y calcular rentabilidad promedio
        document.getElementById('longsProfit').textContent = '$' + longsProfit.toFixed(2);
        document.getElementById('shortsProfit').textContent = '$' + shortsProfit.toFixed(2);
        
        // Calcular promedio por trade
        const longsAvgProfit = longsCount > 0 ? longsProfit / longsCount : 0;
        const shortsAvgProfit = shortsCount > 0 ? shortsProfit / shortsCount : 0;
        
        // Mostrar Win Rate por lado (% de victorias)
        document.getElementById('longsWinPercent').textContent = longsWinPercent;
        document.getElementById('longsWinCount').textContent = longsWin;
        document.getElementById('longsWinRatio').textContent = longsCount;
        
        document.getElementById('shortsWinPercent').textContent = shortsWinPercent;
        document.getElementById('shortsWinCount').textContent = shortsWin;
        document.getElementById('shortsWinRatio').textContent = shortsCount;
        
        // Mostrar/ocultar mensaje de sin datos
        const noDataEl = document.getElementById('noShortsLongsData');
        const chartCanvas = document.getElementById('shortsLongsChart');
        const contentEl = document.getElementById('shortsLongsContent');
        
        if (totalTrades === 0) {
            if (noDataEl) noDataEl.classList.remove('hidden');
            if (chartCanvas) chartCanvas.classList.add('hidden');
            if (contentEl) contentEl.classList.add('hidden');
            return;
        } else {
            if (noDataEl) noDataEl.classList.add('hidden');
            if (chartCanvas) chartCanvas.classList.remove('hidden');
            if (contentEl) contentEl.classList.remove('hidden');
        }
        
        // Crear/actualizar gráfico con Chart.js
        const ctx = document.getElementById('shortsLongsChart');
        if (!ctx) return;
        
        // Actualizar gráfico existente en lugar de destruir/recrear
        if (window.shortsLongsChartInstance) {
            window.shortsLongsChartInstance.data.datasets[0].data = [longsCount, shortsCount];
            window.shortsLongsChartInstance.update('none'); // 'none' = sin animación
            return;
        }
        
        // Limpiar event listeners anteriores del resize
        if (window.shortsLongsResizeHandler) {
            window.removeEventListener('resize', window.shortsLongsResizeHandler);
        }
        
        const isSmallScreen = window.matchMedia('(max-width: 640px)').matches;

        window.shortsLongsChartInstance = new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: ['Longs', 'Shorts'],
                datasets: [{
                    data: [longsCount, shortsCount],
                    backgroundColor: [
                        '#3b82f6',  // Azul para Longs
                        '#f97316'   // Naranja para Shorts
                    ],
                    borderColor: [
                        '#1e40af',  // Azul oscuro
                        '#ea580c'   // Naranja oscuro
                    ],
                    borderWidth: 1.5,
                    hoverOffset: 6
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: 14
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: !isSmallScreen,
                        backgroundColor: 'rgba(15, 23, 42, 0.98)',
                        borderColor: 'rgba(148, 163, 184, 0.4)',
                        borderWidth: 2,
                        titleColor: '#f1f5f9',
                        bodyColor: '#cbd5e1',
                        padding: 12,
                        displayColors: true,
                        callbacks: {
                            title: function(context) {
                                return context[0].label;
                            },
                            label: function(context) {
                                const value = context.parsed || 0;
                                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                const percentage = ((value / total) * 100).toFixed(1);
                                const isLongs = context.label === 'Longs';
                                const profit = isLongs ? longsProfit : shortsProfit;
                                const winCount = isLongs ? longsWin : shortsWin;
                                const winPercent = isLongs ? longsWinPercent : shortsWinPercent;
                                
                                return [
                                    `Trades: ${value} (${percentage}%)`,
                                    `Ganancias: $${profit.toFixed(2)}`,
                                    `Win Rate: ${winPercent}% (${winCount}/${value})`
                                ];
                            }
                        }
                    }
                }
            }
        });

        // Mostrar detalles en mobile al tocar el gráfico
        const detailsEl = document.getElementById('detailedStats');
        if (detailsEl && !ctx.dataset.detailsBound) {
            ctx.dataset.detailsBound = '1';
            const toggleDetails = () => {
                detailsEl.classList.toggle('hidden');
            };
            ctx.addEventListener('click', toggleDetails);
            ctx.addEventListener('touchstart', toggleDetails, { passive: true });
        }
    }

    // ========== OBSERVERS ==========
    const observer = new MutationObserver(() => {
        mirrorBridgeToTailwind();
        // 🆕 Pasar currentDate del calendario
        const calendarDate = window.currentDate || new Date();
        updateRealTimeMetrics(calendarDate);
    });
    observer.observe(bridge, { childList: true, subtree: true });

    if (monthYear && currentMonth) {
        const titleObserver = new MutationObserver(syncMonthTitle);
        titleObserver.observe(monthYear, { childList: true, subtree: true, characterData: true });
    }

    // ========== EVENTS ==========
    // Adjuntar click handler directamente al contenedor
    const clickHandler = (e) => {
        // Buscar específicamente el .day-cell (no solo cualquier elemento con data-date)
        let cell = e.target.closest('.day-cell');
        
        if (!cell) {
            return;
        }
        
        // Verificar que no sea un día de otro mes
        if (cell.classList.contains('other-month')) {
            return;
        }
        
        // Obtener la fecha del atributo data-date de la celda
        let date = cell.dataset.date;
        
        if (!date) {
            return;
        }

        // Abrir modal con la fecha
        if (typeof window.openDayModalForDate === 'function') {
            window.openDayModalForDate(date);
        } else {
            // Reintentar en 100ms si la función no está disponible aún
            setTimeout(() => {
                if (typeof window.openDayModalForDate === 'function') {
                    window.openDayModalForDate(date);
                }
            }, 100);
        }
    };
    
    calendarDays.addEventListener('click', clickHandler);
    if (goToTodayBtn) {
        goToTodayBtn.addEventListener('click', () => {
            const now = new Date();
            if (typeof window.currentMonth !== 'undefined' && typeof window.currentYear !== 'undefined') {
                window.currentMonth = now.getMonth();
                window.currentYear = now.getFullYear();
                if (typeof window.generateCalendar === 'function') {
                    window.generateCalendar();
                }
            }
        });
    }

    // ========== INIT ==========
    injectForceStyles();
    
    function initCalendarMirror() {
        const dayCells = bridge.querySelectorAll('.day-cell');
        if (dayCells.length > 0) {
            mirrorBridgeToTailwind();
            const calendarDate = window.currentDate || new Date();
            updateRealTimeMetrics(calendarDate);
        } else {
            setTimeout(initCalendarMirror, 500);
        }
    }
    
    setTimeout(initCalendarMirror, 300);
    
    // También actualizar métricas cuando cambie journalData
    setTimeout(() => {
        const calendarDate = window.currentDate || new Date();
        updateRealTimeMetrics(calendarDate);
    }, 1000);
    
    // ========== UPDATE ACCOUNT BALANCES IN DROPDOWN ==========
    function updateAccountBalancesInDropdown() {
        const journalData = window.journalData || {};
        const accounts = window.accounts || {};
        
        Object.keys(accounts).forEach(accountId => {
            const account = accounts[accountId];
            const initialBalance = account.initial_balance || account.balance || 0;
            let realBalance = initialBalance;
            
            // Sumar todos los trades de esta cuenta
            Object.keys(journalData).forEach(dateKey => {
                const trades = journalData[dateKey] || [];
                trades.forEach(trade => {
                    realBalance += (parseFloat(trade.profitUSD) || 0);
                });
            });
            
            // Actualizar el display del balance en el dropdown
            const balanceEl = document.querySelector(`[data-account-balance="${accountId}"]`);
            if (balanceEl) {
                balanceEl.textContent = `$${realBalance.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
            }
        });
    }
    
    // Llamar esta función periódicamente
    setInterval(updateAccountBalancesInDropdown, 2000);
    
    // ========== EQUITY PERIOD FILTERS ==========
    const periodButtons = document.querySelectorAll('.equity-period-btn');
    periodButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            // Remover clase activa de todos los botones
            periodButtons.forEach(b => {
                b.classList.remove('bg-blue-600', 'text-white');
                b.classList.add('bg-slate-800', 'text-slate-400');
            });
            
            // Agregar clase activa al botón clickeado
            this.classList.remove('bg-slate-800', 'text-slate-400');
            this.classList.add('bg-blue-600', 'text-white');
            
            // Actualizar período seleccionado
            selectedEquityPeriod = this.dataset.period;
            
            // Actualizar curva de equity con fecha del calendario
            const calendarDate = window.currentDate || new Date();
            updateRealTimeMetrics(calendarDate);
        });
    });
}

// Ejecutar cuando el DOM esté listo
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', simplifyCalendarDisplay);
} else {
    simplifyCalendarDisplay();
}

// Actualizar card de AVG TRADE DURATION con datos reales
function updateAvgTradeDurationCard() {
    const bridge = document.getElementById('calendar');
    if (!bridge) return;
    
    const allTrades = [];
    const dayTrades = bridge.querySelectorAll('.trade-item');
    
    dayTrades.forEach(tradeEl => {
        const entryTime = tradeEl.dataset.entryTime;
        const exitTime = tradeEl.dataset.exitTime;
        const profitClass = tradeEl.className;
        
        if (entryTime && exitTime) {
            const [eh, em] = String(entryTime).split(':').map(Number);
            const [xh, xm] = String(exitTime).split(':').map(Number);
            
            if (![eh, em, xh, xm].some(n => Number.isNaN(n))) {
                const start = eh * 60 + em;
                const end = xh * 60 + xm;
                const duration = Math.max(0, end - start);
                const isWin = profitClass.includes('win');
                const isLoss = profitClass.includes('loss');
                
                allTrades.push({ duration, isWin, isLoss });
            }
        }
    });
    
    if (allTrades.length === 0) return;
    
    // Calcular estadísticas
    const durations = allTrades.map(t => t.duration);
    const avgDuration = Math.round(durations.reduce((a, b) => a + b, 0) / durations.length);
    const minDuration = Math.min(...durations);
    const maxDuration = Math.max(...durations);
    
    // Análisis de experto: correlación duración vs resultado
    const shortTrades = allTrades.filter(t => t.duration < 60);
    const mediumTrades = allTrades.filter(t => t.duration >= 60 && t.duration < 180);
    const longTrades = allTrades.filter(t => t.duration >= 180);
    const veryLongTrades = allTrades.filter(t => t.duration >= 60);
    
    const shortWinRate = shortTrades.length > 0 ? (shortTrades.filter(t => t.isWin).length / shortTrades.length * 100).toFixed(0) : 0;
    const mediumWinRate = mediumTrades.length > 0 ? (mediumTrades.filter(t => t.isWin).length / mediumTrades.length * 100).toFixed(0) : 0;
    const longWinRate = longTrades.length > 0 ? (longTrades.filter(t => t.isWin).length / longTrades.length * 100).toFixed(0) : 0;
    const veryLongWinRate = veryLongTrades.length > 0 ? (veryLongTrades.filter(t => t.isWin).length / veryLongTrades.length * 100).toFixed(0) : 0;
    
    // Determinar el insight principal
    let insight = '';
    let mainStat = '';
    if (shortWinRate > mediumWinRate && shortWinRate > longWinRate) {
        insight = `Trades cortos (< 1h): ${shortWinRate}% ganadores - Tu fortaleza`;
        mainStat = shortWinRate;
    } else if (longWinRate > mediumWinRate && longWinRate > shortWinRate) {
        insight = `Trades largos (> 3h): ${longWinRate}% ganadores - Tendencia a STOP`;
        mainStat = longWinRate;
    } else {
        insight = `Balance en ${mediumWinRate}% - Trades medianos óptimos`;
        mainStat = mediumWinRate;
    }
    
    // Estadística adicional para > 1h
    const moreThan1hInsight = `Trades > 1h: ${veryLongWinRate}% ganadores`;
    
    // Formatear duraciones
    const formatDuration = (minutes) => {
        if (minutes < 60) return `${minutes}m`;
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        return m > 0 ? `${h}h ${m}m` : `${h}h`;
    };
    
    const avgText = formatDuration(avgDuration);
    const minText = formatDuration(minDuration);
    const maxText = formatDuration(maxDuration);
    
    // Actualizar la card
    const card = document.querySelector('[class*="Avg Trade Duration"]')?.closest('div') || 
                 Array.from(document.querySelectorAll('h2')).find(h => h.textContent.includes('Avg Trade'))?.closest('div[class*="backdrop"]');
    
    if (!card) return;
    
    const durationEl = card.querySelector('.text-3xl, .text-4xl');
    const minEl = Array.from(card.querySelectorAll('span')).find(s => s.textContent.includes('m'));
    const maxEl = Array.from(card.querySelectorAll('span')).filter(s => s.textContent.includes('m'))[1];
    const countEl = Array.from(card.querySelectorAll('div')).find(d => d.textContent.includes('Promedio'));
    const insightEl = card.querySelector('.insight-main');
    const insightExtraEl = card.querySelector('.insight-extra');
    
    if (durationEl) durationEl.textContent = avgText;
    if (minEl) minEl.textContent = minText;
    if (maxEl) maxEl.textContent = maxText;
    if (countEl) countEl.textContent = `${allTrades.length} trades analizados`;
    if (insightEl) insightEl.textContent = insight;
    if (insightExtraEl) insightExtraEl.textContent = moreThan1hInsight;
}

// Llamar cuando se actualiza el calendar
const originalMirror = window.mirrorBridgeToTailwind;
if (originalMirror) {
    window.mirrorBridgeToTailwind = function() {
        originalMirror.call(this);
        setTimeout(updateAvgTradeDurationCard, 100);
        
        // Re-aplicar eventos económicos después de cambiar de mes
        setTimeout(() => {
            const cachedEvents = localStorage.getItem(EVENTS_CACHE_KEY);
            if (cachedEvents) {
                try {
                    const eventsData = JSON.parse(cachedEvents);
                    markEconomicEventDates(eventsData);
                } catch (e) {

                }
            }
        }, 150);
    };
}
    
    
    // ========== CARGAR DATOS DEL USUARIO ==========
    function loadUserData() {
        const userName = localStorage.getItem('userName') || 'Usuario';
        const userInitials = userName.split(' ').map(n => n[0]).join('').toUpperCase() || 'TF';
        
        // Actualizar header con nombre del usuario - Nombre completo en userGreeting
        const userGreeting = document.getElementById('userGreeting');
        if (userGreeting) {
            userGreeting.textContent = userName.toUpperCase();
        }
        
        // Actualizar iniciales en el círculo
        const calendarUserInitials = document.getElementById('calendarUserInitials');
        if (calendarUserInitials) {
            calendarUserInitials.textContent = userInitials.substring(0, 1);
        }
        
        // Las cuentas se cargan desde app.js via setupAccountSwitcher() y populateAccountsFromAppJs()
        
        // Crear notificación de bienvenida (solo una vez por sesión)
        const sessionKey = 'tfx_welcome_shown_' + new Date().toDateString();
        if (!sessionStorage.getItem(sessionKey) && window.NotificationCenter) {
            setTimeout(() => {
                const userPlan = sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'FREE';
                window.NotificationCenter.add({
                    type: 'success',
                    title: `¡Bienvenido/a, ${userName}!`,
                    message: `Plan actual: ${userPlan.toUpperCase()}. Tu sesión está activa.`
                });
                sessionStorage.setItem(sessionKey, 'true');
            }, 2000);
        }
    }
    
    // ========== SINCRONIZAR CON CUENTAS DE APP.JS ==========
    function setupAccountSwitcher() {
        // Esperar a que app.js inicie window.accounts
        // Timeout mas largo: 15 segundos en lugar de 5
        const checkAccounts = setInterval(() => {
            // IMPORTANTE: window.currentAccount viene de app.js y es el identificador del usuario actual
            // Si window.accounts existe Y el usuario actual está definido, podemos proceder
            if (window.accounts && Object.keys(window.accounts).length > 0) {
                populateAccountsFromAppJs();
            }

            if (window.accounts && window.currentAccount !== undefined && window.currentAccount !== null) {
                clearInterval(checkAccounts);
                const selected = window.currentAccount || localStorage.getItem('selectedAccountId') || localStorage.getItem('selectedAccount');
                const first = Object.keys(window.accounts)[0];
                const currentId = selected || first;
                if (currentId) {
                    syncAccountSwitcherVisual(currentId);
                    if (typeof window.updateAccountSwitchUI === 'function') {
                        window.updateAccountSwitchUI(currentId);
                    }
                }
            }
        }, 200);
        
        // Timeout de 15 segundos en lugar de 5
        setTimeout(() => clearInterval(checkAccounts), 15000);
    }
    
    // Llenar dropdown con cuentas de app.js - GENERA DINÁMICAMENTE
    function populateAccountsFromAppJs() {
        if (!window.accounts) {
            return;
        }
        
        const accountIds = Object.keys(window.accounts);
        const accountsList = document.getElementById('accountsList');
        
        if (!accountsList) return;
        
        // Limpiar lista existente
        accountsList.innerHTML = '';
        
        const selectedRaw = window.currentAccount || localStorage.getItem('selectedAccountId') || localStorage.getItem('selectedAccount');
        const selected = selectedRaw != null ? String(selectedRaw) : null;
        
        // Filtrar solo cuentas activas (status = 'active' o sin estado) y no archivadas
        const activeAccounts = accountIds
            .filter(id => {
                const acc = window.accounts[id];
                return (acc.status === 'active' || !acc.status) && !isAccountArchivedLocal(acc);
            })
            .map(id => ({ id, account: window.accounts[id] }))
            .sort((a, b) => {
                const aPrimary = a.account.is_primary === 1 || a.account.is_primary === '1' ? 1 : 0;
                const bPrimary = b.account.is_primary === 1 || b.account.is_primary === '1' ? 1 : 0;
                return bPrimary - aPrimary;
            });

        if (activeAccounts.length === 0) {
            const nameEl = document.getElementById('accountSwitchName');
            const balanceEl = document.getElementById('accountSwitchBalance');
            if (nameEl) nameEl.textContent = 'Crea una cuenta';
            if (balanceEl) balanceEl.textContent = '$0.00';
            return;
        }
        
        // Crear botón para cada cuenta
        activeAccounts.forEach((item, index) => {
            const accountId = item.id;
            const account = item.account;
            const isActive = selected ? selected === String(accountId) : index === 0;
            
            const accountBtn = document.createElement('button');
            accountBtn.className = isActive 
                ? 'w-full text-left px-3 py-3 rounded-lg bg-blue-600/20 border border-blue-500/30 mb-2 hover:bg-blue-600/30 transition-colors group text-slate-200' 
                : 'w-full text-left px-3 py-3 rounded-lg hover:bg-slate-800/50 transition-colors group text-slate-200';
            accountBtn.dataset.accountId = accountId;
            
            accountBtn.innerHTML = `
                <div class="flex items-center gap-3">
                    <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center text-xs font-bold text-white">
                        ${(account.name || 'AC').substring(0, 2).toUpperCase()}
                    </div>
                    <div class="flex-1">
                        <div class="font-medium text-sm text-slate-200">${account.name}</div>
                    </div>
                    ${isActive ? '<svg class="w-5 h-5 text-green-400" data-active-check="1" fill="currentColor" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>' : ''}
                </div>
            `;
            
            // Evento click para cambiar de cuenta
            accountBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                switchAccountToAppJs(accountId);
                // Actualizar visual
                populateAccountsFromAppJs();
            });
            
            accountsList.appendChild(accountBtn);
        });

        // Controlar visibilidad de botones "Ajustes" e "Importar" según si hay cuentas
        const hasAccounts = activeAccounts.length > 0;
        const btnAccountSettings = document.getElementById('btnAccountSettings');
        const btnImportTradesModal = document.getElementById('btnImportTradesModal');
        const accountActionsDivider = document.getElementById('accountActionsDivider');
        const userPlan = (sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || localStorage.getItem('tfx_plan') || 'free').toLowerCase();
        const hideSettings = userPlan === 'free';
        
        if (btnAccountSettings) {
            btnAccountSettings.style.display = (hasAccounts && !hideSettings) ? 'flex' : 'none';
        }
        if (btnImportTradesModal) {
            btnImportTradesModal.style.display = hasAccounts ? 'flex' : 'none';
        }
        if (accountActionsDivider && !hasAccounts) {
            accountActionsDivider.style.display = 'none';
        } else if (accountActionsDivider) {
            accountActionsDivider.style.display = 'block';
        }

        const currentId = selected || accountIds[0];
        if (currentId) syncAccountSwitcherVisual(currentId);
    }

    function isAccountArchivedLocal(account) {
        if (!account) return true;
        const flag = account.is_archived;
        if (flag === true || flag === 'true' || flag === 1 || flag === '1') return true;
        if (flag === false || flag === 'false' || flag === 0 || flag === '0' || flag == null) return false;
        return Boolean(flag);
    }
    
    // Exponer globalmente para que app.js pueda llamarla después de crear una cuenta
    window.populateAccountsFromAppJs = populateAccountsFromAppJs;
    
    // Fallback si selectCustomOption no está disponible
    function switchAccountFallback(accountId, account) {
        window.currentAccount = accountId;
        localStorage.setItem('selectedAccount', accountId);
        
        // Cerrar dropdown
        const accountDropdown = document.getElementById('accountDropdown');
        if (accountDropdown) {
            accountDropdown.classList.remove('opacity-100', 'visible', 'scale-100');
            accountDropdown.classList.add('opacity-0', 'invisible', 'scale-95');
        }
        
        // Llamar a changeAccount de app.js
        if (typeof window.changeAccount === 'function') {
            window.changeAccount();
        }
        
        if (typeof window.showNotification === 'function') {
            window.showNotification('Cuenta cambiada: ' + account.name, 'success');
        }
    }
    
    // Cambiar cuenta sincronizando con app.js
    function switchAccountToAppJs(accountId) {
        if (!window.accounts || !window.accounts[accountId]) {
            return;
        }
        
        // Actualizar en app.js
        window.currentAccount = accountId;
        localStorage.setItem('selectedAccount', accountId);
        
        // Llamar a changeAccount de app.js (actualiza header + datos + display)
        if (typeof window.changeAccount === 'function') {
            window.changeAccount();
        }
        
        // Cerrar dropdown
        const accountDropdown = document.getElementById('accountDropdown');
        if (accountDropdown) {
            accountDropdown.classList.remove('opacity-100', 'visible', 'scale-100');
            accountDropdown.classList.add('opacity-0', 'invisible', 'scale-95');
        }
        
        if (typeof window.showNotification === 'function') {
            window.showNotification('Cuenta cambiada', 'success');
        }
    }

    function parseDateKey(dateKey) {
        if (!dateKey || typeof dateKey !== 'string') return null;
        const m = dateKey.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!m) return null;
        const year = Number(m[1]);
        const month = Number(m[2]);
        const day = Number(m[3]);
        const d = new Date(year, month - 1, day);
        if (Number.isNaN(d.getTime())) return null;
        return d;
    }

    function formatHumanDate(dateKey) {
        const d = parseDateKey(dateKey);
        if (!d) return String(dateKey || '');
        try {
            return new Intl.DateTimeFormat('es-ES', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            }).format(d);
        } catch (_) {
            return d.toDateString();
        }
    }

    function escapeHtml(text) {
        return String(text ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }
    
    // Exponer globalmente para uso en otras funciones
    window.escapeHtml = escapeHtml;

    function formatMoney(value) {
        const num = Number(value);
        const safe = Number.isFinite(num) ? num : 0;
        return safe.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function formatPercent(value) {
        const num = Number(value);
        const safe = Number.isFinite(num) ? num : 0;
        const sign = safe > 0 ? '+' : '';
        return `${sign}${safe.toFixed(2)}%`;
    }

    function computeWinRate(trades) {
        const list = Array.isArray(trades) ? trades : [];
        if (!list.length) return 0;
        const wins = list.filter(t => Number(t?.profitUSD) > 0).length;
        return Math.round((wins / list.length) * 100);
    }

    function computeDayTotals(trades) {
        const list = Array.isArray(trades) ? trades : [];
        const totalUsd = list.reduce((sum, t) => sum + (Number(t?.profitUSD) || 0), 0);
        const totalPct = list.reduce((sum, t) => sum + (Number(t?.result) || 0), 0);
        return { totalUsd, totalPct };
    }

    function getTradesForDate(dateKey) {
        const map = window.journalData || {};
        const trades = map[dateKey];
        return Array.isArray(trades) ? trades : [];
    }

    function getDailyNoteForDate(dateKey) {
        const map = window.__dailyNotesMap || {};
        const note = map[dateKey];
        return note && typeof note === 'object' ? note : null;
    }

    function setModalDateLabels(dateKey) {
        const human = formatHumanDate(dateKey);
        const tradeDate = document.getElementById('tradeModalDate');
        const notesDate = document.getElementById('notesModalDate');
        const cashflowDate = document.getElementById('cashflowModalDate');
        if (tradeDate) tradeDate.textContent = human;
        if (notesDate) notesDate.textContent = human;
        if (cashflowDate) cashflowDate.textContent = human;
    }

    function renderNotesPreview(dateKey) {
        const preview = document.getElementById('notesPreview');
        if (!preview) return;

        const note = getDailyNoteForDate(dateKey);
        if (!note || (!note.note && !note.sentiment && !note.day_outcome && !note.outcome)) {
            preview.innerHTML = `
                <div class="bg-slate-800/30 border border-dashed border-slate-700/50 rounded-xl p-4 text-center">
                    <div class="text-sm text-slate-400">Sin notas para este día.</div>
                    <div class="text-xs text-slate-500 mt-1">Añade una reflexión para mejorar tu consistencia.</div>
                </div>
            `;
            return;
        }

        // Mapeo de sentimientos con SVG icons y colores profesionales
        const sentimentConfig = {
            cabreado: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>', label: 'Frustrado', color: 'red' },
            estresado: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>', label: 'Estresado', color: 'orange' },
            tranquilo: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>', label: 'Tranquilo', color: 'green' },
            emocionado: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>', label: 'Emocionado', color: 'purple' },
            con_sueno: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/>', label: 'Cansado', color: 'slate' },
            otro: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>', label: 'Otro', color: 'blue' }
        };

        // Mapeo de outcomes con SVG icons
        const outcomeConfig = {
            ganador: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"/>', label: 'Ganador', color: 'emerald' },
            perdedor: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>', label: 'Perdedor', color: 'red' },
            break_even: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14"/>', label: 'Break Even', color: 'slate' },
            neutral: { icon: '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"/>', label: 'Neutral', color: 'slate' }
        };

        const sentiment = note.sentiment || '';
        const outcome = note.day_outcome || note.outcome || '';
        const noteText = String(note.note || '').trim();
        const short = noteText.length > 300 ? `${noteText.slice(0, 300)}…` : noteText;

        const sentimentData = sentimentConfig[sentiment];
        const outcomeData = outcomeConfig[outcome];

        preview.innerHTML = `
            <div class="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-xl p-5 group hover:bg-slate-800/70 hover:border-slate-600/50 transition-all duration-200 shadow-lg hover:shadow-xl">
                <!-- Header con badges -->
                <div class="flex items-center justify-between gap-3 mb-4">
                    <div class="flex items-center gap-2 flex-wrap">
                        ${sentimentData ? `
                        <div class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-${sentimentData.color}-500/10 border border-${sentimentData.color}-500/20 text-${sentimentData.color}-400 text-xs font-medium">
                            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">${sentimentData.icon}</svg>
                            <span>${sentimentData.label}</span>
                        </div>` : ''}
                        ${outcomeData ? `
                        <div class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-${outcomeData.color}-500/10 border border-${outcomeData.color}-500/20 text-${outcomeData.color}-400 text-xs font-medium">
                            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">${outcomeData.icon}</svg>
                            <span>${outcomeData.label}</span>
                        </div>` : ''}
                    </div>
                    <div class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
                        <button class="note-edit-btn p-2 hover:bg-blue-500/10 rounded-lg text-slate-400 hover:text-blue-400 transition-colors" title="Editar">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                        </button>
                        <button class="note-delete-btn p-2 hover:bg-red-500/10 rounded-lg text-slate-400 hover:text-red-400 transition-colors" title="Borrar">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                        </button>
                    </div>
                </div>
                
                <!-- Contenido de la nota -->
                <div class="text-sm text-slate-300 leading-relaxed whitespace-pre-wrap font-light">${escapeHtml(short || '—')}</div>
            </div>
        `;
    }

    function renderTradesList(dateKey) {
        const listEl = document.getElementById('tradesList');
        const countEl = document.getElementById('tradesCount');
        const deleteAllBtn = document.getElementById('deleteAllTradesBtn');
        if (!listEl) return;

        const allTradesRaw = getTradesForDate(dateKey);
        
        // 🆕 Ordenar trades por timestamp (más recientes primero)
        const allTrades = [...allTradesRaw].sort((a, b) => {
            const timeA = new Date(a.timestamp || 0).getTime();
            const timeB = new Date(b.timestamp || 0).getTime();
            return timeB - timeA;  // Descendente (más recientes primero)
        });
        
        if (countEl) countEl.textContent = `(${allTrades.length})`;
        
        // Mostrar/ocultar botón de borrar todos
        if (deleteAllBtn) {
            deleteAllBtn.style.display = allTrades.length > 0 ? 'flex' : 'none';
        }

        if (!allTrades.length) {
            listEl.innerHTML = `
                <div class="bg-slate-800/30 border border-slate-700/40 rounded-xl p-4">
                    <div class="text-sm text-slate-200 font-medium">Sin operaciones</div>
                    <div class="text-xs text-slate-500 mt-1">Añade tu primera operación para este día.</div>
                </div>
            `;
            return;
        }

        // Paginación: 2 operaciones por página
        const tradesPerPage = 2;
        let currentPage = 1;
        const totalPages = Math.ceil(allTrades.length / tradesPerPage);
        
        function renderPage(page) {
            const start = (page - 1) * tradesPerPage;
            const end = start + tradesPerPage;
            const pageTrades = allTrades.slice(start, end);
            
            const items = pageTrades.map((t) => {
                const pair = escapeHtml(t?.pair || t?.symbol || '');
                const direction = String(t?.direction || '').toUpperCase();
                const dirClass = direction === 'SHORT' ? 'bg-red-600/20 text-red-300 border-red-500/20' : 'bg-green-600/20 text-green-300 border-green-500/20';
                const profitUsd = Number(t?.profitUSD) || 0;
                const pnlClass = profitUsd >= 0 ? 'text-green-400' : 'text-red-400';
                // 🆕 Detectar tipo de volumen según instrumento
                const volumeInfo = window.getVolumeTypeForSymbol ? window.getVolumeTypeForSymbol(t?.pair || t?.symbol) : { type: 'lotes' };
                const lot = t?.lotSize != null && t?.lotSize !== '' ? `${escapeHtml(String(t.lotSize))} ${volumeInfo.type}` : '';
                const time = [t?.entryTime, t?.exitTime].filter(Boolean).join(' - ');
                const payload = encodeURIComponent(JSON.stringify(t || {}));

                return `
                    <div data-trade-item data-trade-json="${payload}" class="bg-slate-800/50 border border-slate-700 rounded-lg p-3 hover:border-blue-500/40 hover:bg-slate-800 transition-all group cursor-pointer">
                        <div class="flex items-center justify-between gap-3">
                            <div class="min-w-0 flex-1">
                                <div class="font-semibold text-white truncate">${pair || '—'}</div>
                                <div class="text-xs text-slate-400 flex flex-wrap gap-2 mt-1">
                                    <span class="px-2 py-0.5 rounded border ${dirClass}">${escapeHtml(direction || '—')}</span>
                                    ${lot ? `<span>${lot}</span>` : ''}
                                </div>
                            </div>
                            <div class="text-right shrink-0">
                                <div class="font-semibold ${pnlClass}">${profitUsd >= 0 ? '+' : ''}${formatMoney(profitUsd)}</div>
                                <div class="text-xs text-slate-500">${escapeHtml(time || '')}</div>
                            </div>
                            <div class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity shrink-0">
                                <button class="trade-delete-btn p-2 hover:bg-red-600/20 rounded text-slate-400 hover:text-red-400" title="Borrar">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                `;
            }).join('');
            
            const paginationHTML = totalPages > 1 ? `
                <div class="flex items-center justify-between pt-3 mt-3 border-t border-slate-700/50">
                    <button id="prevTradesPage" ${page === 1 ? 'disabled' : ''} class="px-3 py-1.5 text-xs font-medium rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                        ← Anterior
                    </button>
                    <span class="text-xs text-slate-400">
                        ${page} de ${totalPages} · ${allTrades.length} operaciones
                    </span>
                    <button id="nextTradesPage" ${page === totalPages ? 'disabled' : ''} class="px-3 py-1.5 text-xs font-medium rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                        Siguiente →
                    </button>
                </div>
            ` : '';
            
            listEl.innerHTML = items + paginationHTML;
            
            // Event listeners para paginación
            if (totalPages > 1) {
                const prevBtn = document.getElementById('prevTradesPage');
                const nextBtn = document.getElementById('nextTradesPage');
                
                if (prevBtn) prevBtn.onclick = () => renderPage(page - 1);
                if (nextBtn) nextBtn.onclick = () => renderPage(page + 1);
            }
        }
        
        renderPage(currentPage);
    }

    function renderDayModal(dateKey) {
        const titleEl = document.getElementById('modalDate');
        const statsEl = document.getElementById('modalStats');

        const trades = getTradesForDate(dateKey);
        
        const { totalUsd, totalPct } = computeDayTotals(trades);
        const wr = computeWinRate(trades);

        if (titleEl) titleEl.textContent = formatHumanDate(dateKey);

        if (statsEl) {
            if (!trades.length) {
                statsEl.textContent = 'Sin trades registrados.';
            } else {
                const pnlText = `${formatPercent(totalPct)} · $${formatMoney(totalUsd)}`;
                statsEl.textContent = `${trades.length} trade(s) · Win rate ${wr}% · ${pnlText}`;
            }
        }

        renderTradesList(dateKey);
        renderNotesPreview(dateKey);
        renderCashflowsSection(dateKey);
        renderEconomicEventsForDay(dateKey);
        setModalDateLabels(dateKey);
    }

    function openDayModalForDate(dateKey) {
        if (!dateKey) return;
        selectedDateForModal = dateKey;
        renderDayModal(dateKey);
        openModal(dayModal, dateKey);
    }

    function openAddTradeForSelectedDate() {
        if (!selectedDateForModal) {
            return;
        }

        const accountId = window.currentAccount;
        const account = accountId ? (window.accounts || {})[accountId] : null;
        const isSynced = !!(account && (account.mt_account_number || account.sync_provider === 'tradovate'));

        if (isSynced) {
            showSyncedAccountModal(account);
            return;
        }

        setModalDateLabels(selectedDateForModal);
        openModal(addTradeModal, selectedDateForModal);
    }

    function openAddNotesForSelectedDate() {
        if (!selectedDateForModal) return;
        setModalDateLabels(selectedDateForModal);

        const note = getDailyNoteForDate(selectedDateForModal);
        const sentimentEl = document.getElementById('notesSentiment');
        const outcomeEl = document.getElementById('notesOutcome');
        const textareaEl = document.getElementById('notesTextarea');
        if (sentimentEl) sentimentEl.value = note?.sentiment || '';
        if (outcomeEl) outcomeEl.value = note?.day_outcome || note?.outcome || '';
        if (textareaEl) textareaEl.value = note?.note || '';

        openModal(addNotesModal, selectedDateForModal);
    }

    function openAddBalanceAdjustmentForSelectedDate() {
        if (!selectedDateForModal) return;
        setModalDateLabels(selectedDateForModal);
        const modal = document.getElementById('addBalanceAdjustmentModal');
        openModal(modal, selectedDateForModal);
    }

    async function renderCashflowsSection(dateKey) {
        const listEl = document.getElementById('balanceAdjustmentsList');
        const countEl = document.getElementById('cashflowsCount');
        if (!listEl) return;

        const accountId = window.currentAccount;
        if (!accountId || !window.tursoClient) {
            listEl.innerHTML = '<div class="text-sm text-slate-400">Selecciona una cuenta primero.</div>';
            if (countEl) countEl.textContent = '(0)';
            return;
        }

        let rows = [];
        const cache = window.__cashflowsMap?.[accountId];
        if (cache && cache[dateKey]) {
            rows = cache[dateKey];
        } else {
            try {
                const res = await window.tursoClient.execute({
                    sql: 'SELECT id, type, amount, notes, date, created_at FROM cashflows WHERE account_id = ? AND date = ? ORDER BY created_at DESC',
                    args: [accountId, dateKey]
                });
                rows = res?.rows || [];
            } catch (e) {
                rows = [];
            }
        }

        if (countEl) countEl.textContent = `(${rows.length})`;

        if (!rows.length) {
            listEl.innerHTML = `
                <div class="text-sm text-slate-300">Sin ajustes de balance para este día.</div>
                <div class="text-xs text-slate-500 mt-1">Registra depósitos o retiros para mantener el balance real.</div>
            `;
            return;
        }

        listEl.innerHTML = rows.map(row => {
            const type = String(row.type || '').toLowerCase();
            const isWithdraw = type === 'withdraw';
            const amount = Number(row.amount) || 0;
            const signed = isWithdraw ? -Math.abs(amount) : Math.abs(amount);
            const amountClass = isWithdraw ? 'text-rose-400' : 'text-emerald-400';
            const label = isWithdraw ? 'Retiro' : 'Depósito';
            const note = row.notes ? escapeHtml(row.notes) : '';

            return `
                <div class="flex items-center justify-between gap-3 bg-slate-800/50 border border-slate-700/50 rounded-lg px-3 py-2">
                    <div class="min-w-0">
                        <div class="text-sm text-white font-semibold">${label}</div>
                        ${note ? `<div class="text-xs text-slate-400 truncate">${note}</div>` : ''}
                    </div>
                    <div class="flex items-center gap-2">
                        <div class="text-sm font-semibold ${amountClass}">${signed >= 0 ? '+' : ''}$${formatMoney(signed)}</div>
                        <button class="cashflow-delete-btn text-slate-400 hover:text-rose-400 transition-colors" data-cashflow-id="${row.id}">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                            </svg>
                        </button>
                    </div>
                </div>
            `;
        }).join('');
    }

    function showSyncedAccountModal(account) {
        const existing = document.getElementById('syncedAccountModal');
        const accountName = account?.name || 'Cuenta sincronizada';
        const providerLabel = account?.sync_provider === 'tradovate' ? 'Tradovate' : 'MetaTrader';

        if (!existing) {
            const overlay = document.createElement('div');
            overlay.id = 'syncedAccountModal';
            overlay.className = 'synced-account-modal-overlay';
            overlay.innerHTML = `
                <div class="synced-account-modal">
                    <div class="synced-account-modal-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <circle cx="12" cy="12" r="9"></circle>
                            <path d="M7.5 12.5l3 3 6-6"></path>
                        </svg>
                    </div>
                    <h3 class="synced-account-modal-title">Cuenta sincronizada</h3>
                    <p class="synced-account-modal-text">
                        La cuenta <strong>${accountName}</strong> está sincronizada con <strong>${providerLabel}</strong>.
                        Por consistencia, no se permiten operaciones manuales.
                    </p>
                    <div class="synced-account-modal-actions">
                        <button class="btn-primary" id="syncedAccountModalOk">Entendido</button>
                    </div>
                </div>
            `;
            document.body.appendChild(overlay);
        }

        const modal = document.getElementById('syncedAccountModal');
        if (!modal) return;

        modal.classList.add('show');
        modal.style.display = 'flex';

        const close = () => {
            modal.classList.remove('show');
            modal.style.display = 'none';
        };

        modal.addEventListener('click', (e) => {
            if (e.target === modal) close();
        }, { once: true });

        modal.querySelector('#syncedAccountModalOk')?.addEventListener('click', close, { once: true });
    }

    // ========== EXPONER FUNCIONES DE MODALES A WINDOW ==========
    window.openDayModalForDate = openDayModalForDate;
    window.openAddTradeForSelectedDate = openAddTradeForSelectedDate;
    window.openAddNotesForSelectedDate = openAddNotesForSelectedDate;

    // 🔧 GLOBAL: Función para generar IDs únicos (expuesta inmediatamente)
    function generateIdFallback() {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }
    window.generateIdFallback = generateIdFallback; // Exponer inmediatamente

    function getInitialBalanceForAccount(accountId) {
        const acc = (window.accounts || {})[accountId];
        const raw = acc?.initial_balance ?? acc?.balance ?? 10000;
        const num = Number(raw);
        return Number.isFinite(num) ? num : 10000;
    }

    async function saveTradeCalendarDemo(accountId, dateKey, trade) {
        if (!accountId) throw new Error('Selecciona una cuenta primero');
        if (!window.tursoClient) throw new Error('No tursoClient');

        const safeValue = (value, defaultValue = null) => {
            if (value === undefined || value === null || value === '' || Number.isNaN(Number(value))) {
                return defaultValue;
            }
            return value;
        };

        const payload = {
            id: trade.id || window.generateIdFallback(),
            pair: trade.pair || trade.symbol || '',
            direction: trade.direction || 'LONG',
            comment: trade.comment || null,
            entryTime: trade.entryTime || null,
            exitTime: trade.exitTime || null,
            tradingViewUrl: trade.tradingViewUrl || null,
            timestamp: trade.timestamp || new Date().toISOString(),
            ticket: trade.ticket || null,
            lotSize: safeValue(trade.lotSize, null),
            entryPrice: safeValue(trade.entryPrice, null),
            exitPrice: safeValue(trade.exitPrice, null),
            commission: safeValue(trade.commission, 0),
            swap: safeValue(trade.swap, 0),
            profitUSD: safeValue(trade.profitUSD, 0),
            importSource: trade.importSource || 'manual',
            entryModelId: trade.entryModelId || null,
            entryModelSnapshot: trade.entryModelSnapshot || null
        };

        await window.tursoClient.execute({
            sql: `INSERT INTO trades (
                id, account_id, date, pair, direction,
                comment, entry_time, exit_time, tradingview_url, timestamp,
                ticket, lot_size, entry_price, exit_price,
                commission, swap, profit_usd, import_source,
                entry_model_id, entry_model_snapshot
            ) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
            args: [
                payload.id,
                accountId,
                dateKey,
                payload.pair,
                payload.direction,
                payload.comment,
                payload.entryTime,
                payload.exitTime,
                payload.tradingViewUrl,
                payload.timestamp,
                payload.ticket,
                payload.lotSize,
                payload.entryPrice,
                payload.exitPrice,
                payload.commission,
                payload.swap,
                payload.profitUSD,
                payload.importSource,
                payload.entryModelId,
                payload.entryModelSnapshot
            ]
        });

        const initialBalance = getInitialBalanceForAccount(accountId);
        const profitNet = Number(payload.profitUSD) || 0;
        const resultPercent = (profitNet / initialBalance) * 100;
        const riskPercent = Math.abs(resultPercent);
        const derived = Object.assign({}, payload, {
            profitUSD: profitNet,
            result: resultPercent,
            risk: riskPercent,
            entry_model_id: payload.entryModelId,           // ✅ Snake_case para loadTradeEntryModelSection
            entry_model_snapshot: payload.entryModelSnapshot // ✅ Snake_case para loadTradeEntryModelSection
        });

        window.journalData = window.journalData || {};
        window.journalData[dateKey] = Array.isArray(window.journalData[dateKey]) ? window.journalData[dateKey] : [];
        window.journalData[dateKey].push(derived);
        
        // 🆕 Actualizar balance state manager y refrescar display
        if (window.balanceStateManager) {
            window.balanceStateManager.addTrade(accountId, derived);
        }
        
        // 🆕 Refrescar todas las secciones: Balance, Últimas Operaciones y Destacados
        setTimeout(() => {
            if (typeof window.updateBalanceDisplay === 'function') {
                window.updateBalanceDisplay();
            }
            if (typeof window.updateLatestTrades === 'function') {
                window.updateLatestTrades();
            }
            // Obtener todos los trades del mes para actualizar mejor/peor
            const journalData = window.journalData || {};
            const currentYear = new Date().getFullYear();
            const currentMonth = new Date().getMonth();
            const allTradesThisMonth = [];
            Object.keys(journalData).forEach(dateKey => {
                const trades = journalData[dateKey] || [];
                const tradeDate = new Date(dateKey + 'T00:00:00');
                if (tradeDate.getFullYear() === currentYear && tradeDate.getMonth() === currentMonth) {
                    allTradesThisMonth.push(...trades);
                }
            });
            if (typeof window.updateBestWorstTrades === 'function') {
                const currentAccountData = window.accounts?.[window.currentAccount];
                const initialBalance = currentAccountData?.initial_balance || currentAccountData?.balance || 10000;
                window.updateBestWorstTrades(allTradesThisMonth, initialBalance);
            }
        }, 50);
        
        return derived;
    }

    function computeDuration(entryTime, exitTime) {
        try {
            if (!entryTime || !exitTime) return '';
            const [eh, em] = String(entryTime).split(':').map(Number);
            const [xh, xm] = String(exitTime).split(':').map(Number);
            if ([eh, em, xh, xm].some(n => Number.isNaN(n))) return '';
            const start = eh * 60 + em;
            const end = xh * 60 + xm;
            const diff = Math.max(0, end - start);
            const h = Math.floor(diff / 60);
            const m = diff % 60;
            if (h && m) return `${h}h ${m}m`;
            if (h) return `${h}h`;
            if (m) return `${m}m`;
            return '—';
        } catch (_) {
            return '';
        }
    }

    async function openTradeDetails(trade, dateKey) {
        if (!trade) return;

        const normalizeTradeForDetails = (source, fallbackDateKey) => ({
            id: source?.id,
            pair: source?.pair || source?.symbol || '',
            symbol: source?.symbol || source?.pair || '',
            direction: source?.direction || source?.side || source?.type || '—',
            profitUSD: Number(source?.profitUSD ?? source?.profit_usd ?? source?.profit ?? 0) || 0,
            comment: source?.comment || '',
            entryTime: source?.entryTime || source?.entry_time || source?.open_time || source?.time_open || source?.entry || '',
            exitTime: source?.exitTime || source?.exit_time || source?.close_time || source?.time_close || source?.exit || '',
            tradingViewUrl: source?.tradingViewUrl || source?.tradingview_url || source?.url || '',
            lotSize: source?.lotSize ?? source?.lot_size ?? source?.volume ?? source?.lots ?? null,
            ticket: source?.ticket || null,
            entryPrice: source?.entryPrice ?? source?.entry_price ?? null,
            exitPrice: source?.exitPrice ?? source?.exit_price ?? null,
            commission: source?.commission ?? 0,
            swap: source?.swap ?? 0,
            importSource: source?.importSource || source?.import_source || null,
            entry_model_id: source?.entry_model_id || source?.entryModelId || null,
            entry_model_snapshot: source?.entry_model_snapshot || source?.entryModelSnapshot || null,
            date: source?.date || fallbackDateKey || ''
        });

        const renderTradeDetailsContent = (normalizedTrade) => {
            const dateEl = document.getElementById('tradeDetailsDate');
            const pairEl = document.getElementById('detailsPair');
            const dirEl = document.getElementById('detailsDirection');
            const resEl = document.getElementById('detailsResult');
            const lotEl = document.getElementById('detailsLotSize');
            const durEl = document.getElementById('detailsDuration');
            const entryEl = document.getElementById('detailsEntryTime');
            const exitEl = document.getElementById('detailsExitTime');
            const commentEl = document.getElementById('detailsComment');
            const commentSection = document.getElementById('commentSection');
            const urlSection = document.getElementById('urlSection');
            const urlEl = document.getElementById('detailsUrl');
            const lotTypeEl = document.getElementById('detailsLotType');

            const pair = String(normalizedTrade?.pair || normalizedTrade?.symbol || '—');
            const direction = String(normalizedTrade?.direction || '—').toUpperCase();
            const profitUsd = Number(normalizedTrade?.profitUSD) || 0;
            const entry = normalizedTrade?.entryTime || '';
            const exit = normalizedTrade?.exitTime || '';
            const duration = computeDuration(entry, exit);

            if (dateEl) dateEl.textContent = dateKey ? formatHumanDate(dateKey) : '';
            if (pairEl) pairEl.textContent = pair || '—';
            if (dirEl) dirEl.textContent = direction || '—';
            if (resEl) {
                resEl.textContent = `${profitUsd >= 0 ? '+' : ''}${formatMoney(profitUsd)}`;
                resEl.classList.remove('text-green-400', 'text-red-400');
                resEl.classList.add(profitUsd >= 0 ? 'text-green-400' : 'text-red-400');
            }

            if (lotEl) {
                const lotSize = normalizedTrade?.lotSize;
                lotEl.textContent = lotSize != null && lotSize !== '' ? String(lotSize) : '—';
            }
            if (lotTypeEl && window.updateDetailsVolumeType) {
                window.updateDetailsVolumeType(normalizedTrade?.pair || normalizedTrade?.symbol || '');
            }

            if (durEl) durEl.textContent = duration || '—';
            if (entryEl) entryEl.textContent = entry || '—';
            if (exitEl) exitEl.textContent = exit || '—';

            const comment = String(normalizedTrade?.comment || '').trim();
            if (commentEl) {
                if (comment && comment !== 'null' && comment !== 'undefined') {
                    commentEl.textContent = comment;
                    if (commentSection) commentSection.style.display = '';
                } else {
                    if (commentSection) commentSection.style.display = 'none';
                }
            }

            const tv = String(normalizedTrade?.tradingViewUrl || '').trim();
            const hasValidUrl = tv && tv !== 'null' && tv !== 'undefined' && tv !== '#';
            if (urlSection) {
                urlSection.style.display = hasValidUrl ? '' : 'none';
                urlSection.style.opacity = hasValidUrl ? '1' : '0';
                urlSection.style.pointerEvents = hasValidUrl ? 'auto' : 'none';
                urlSection.style.visibility = hasValidUrl ? 'visible' : 'hidden';
            }
            if (urlEl) {
                urlEl.href = hasValidUrl ? tv : '#';
            }
        };

        if (tradeDetailsModal) {
            tradeDetailsModal.classList.remove('hidden');
            tradeDetailsModal.style.display = 'flex';
        }

        let normalizedTrade = normalizeTradeForDetails(trade, dateKey);
        renderTradeDetailsContent(normalizedTrade);

        (async () => {
            try {
                if (normalizedTrade?.id && window.tursoClient) {
                    const result = await window.tursoClient.execute({
                        sql: 'SELECT * FROM trades WHERE id = ?',
                        args: [normalizedTrade.id]
                    });
                    if (result.rows && result.rows.length > 0) {
                        normalizedTrade = normalizeTradeForDetails(result.rows[0], dateKey);
                        renderTradeDetailsContent(normalizedTrade);
                    } else if (window.currentAccount && dateKey) {
                        const fallbackByFields = await window.tursoClient.execute({
                            sql: `SELECT * FROM trades
                                  WHERE account_id = ? AND date = ? AND pair = ? AND direction = ?
                                  ORDER BY timestamp DESC
                                  LIMIT 1`,
                            args: [window.currentAccount, dateKey, normalizedTrade.pair || '', normalizedTrade.direction || '']
                        });
                        if (fallbackByFields.rows && fallbackByFields.rows.length > 0) {
                            normalizedTrade = normalizeTradeForDetails(fallbackByFields.rows[0], dateKey);
                            renderTradeDetailsContent(normalizedTrade);
                        }
                    }
                } else if (window.tursoClient && window.currentAccount && dateKey) {
                    const fallbackByFields = await window.tursoClient.execute({
                        sql: `SELECT * FROM trades
                              WHERE account_id = ? AND date = ? AND pair = ? AND direction = ?
                              ORDER BY timestamp DESC
                              LIMIT 1`,
                        args: [window.currentAccount, dateKey, normalizedTrade.pair || '', normalizedTrade.direction || '']
                    });
                    if (fallbackByFields.rows && fallbackByFields.rows.length > 0) {
                        normalizedTrade = normalizeTradeForDetails(fallbackByFields.rows[0], dateKey);
                        renderTradeDetailsContent(normalizedTrade);
                    }
                }

                await loadTradeEntryModelSection(normalizedTrade, dateKey);
            } catch (err) {
                // Error loading trade silently caught
            }
        })();
    }

    async function deleteTradeFromCalendarDemo(trade, dateKey) {
        try {
            if (!trade?.id) throw new Error('Trade ID requerido');

            // Usar la función de app.js si está disponible
            if (window.deleteTradeFromDB) {
                const success = await window.deleteTradeFromDB(trade.id);
                if (!success) throw new Error('No se pudo eliminar el trade');
            } else {
                // Fallback: llamar a tursoClient
                const turso = window.tursoClient;
                if (!turso) throw new Error('No turso');
                
                await turso.execute({
                    sql: 'DELETE FROM trades WHERE id = ?',
                    args: [trade.id]
                });
            }

            // Eliminar de la data en memoria
            if (window.journalData && window.journalData[dateKey]) {
                window.journalData[dateKey] = window.journalData[dateKey].filter(t => t.id !== trade.id);
            }

            // 🆕 Actualizar balance state manager
            if (window.balanceStateManager && window.currentAccount) {
                window.balanceStateManager.removeTrade(window.currentAccount, trade.id);
            }

            // Aplicar la misma lógica que cuando se añade un trade
            if (typeof window.invalidateRecapCache === 'function') {
                try { window.invalidateRecapCache(); } catch (_) {}
            }
            if (typeof window.updateDisplay === 'function') {
                try { window.updateDisplay(); } catch (_) {}
            }

            // 🆕 Actualizar panel de Trade Control si está activo
            if (window.tradeControlUI && window.tradeControlUI.sessionPanel) {
                try {
                    await window.tradeControlUI.updateSessionPanel();
                } catch (e) {
                }
            }

            // 🆕 Refrescar todas las secciones: Balance, Últimas Operaciones y Destacados
            setTimeout(() => {
                if (typeof window.updateBalanceDisplay === 'function') {
                    window.updateBalanceDisplay();
                }
                if (typeof window.updateLatestTrades === 'function') {
                    window.updateLatestTrades();
                }
                // Refrescar tarjetas de performance
                if (typeof window.renderPerformanceCardsNew === 'function') {
                    window.renderPerformanceCardsNew();
                }
                // Obtener todos los trades del mes para actualizar mejor/peor
                const journalData = window.journalData || {};
                const currentYear = new Date().getFullYear();
                const currentMonth = new Date().getMonth();
                const allTradesThisMonth = [];
                Object.keys(journalData).forEach(dateKey => {
                    const trades = journalData[dateKey] || [];
                    const tradeDate = new Date(dateKey + 'T00:00:00');
                    if (tradeDate.getFullYear() === currentYear && tradeDate.getMonth() === currentMonth) {
                        allTradesThisMonth.push(...trades);
                    }
                });
                if (typeof window.updateBestWorstTrades === 'function') {
                    const currentAccountData = window.accounts?.[window.currentAccount];
                    const initialBalance = currentAccountData?.initial_balance || currentAccountData?.balance || 10000;
                    window.updateBestWorstTrades(allTradesThisMonth, initialBalance);
                }
            }, 50);

            // Cerrar el modal de detalles si está abierto
            closeModal(tradeDetailsModal);

            // Actualizar el modal del día
            renderDayModal(dateKey);

            // Mostrar notificación de éxito con diseño mejorado
            window.showAlert(
                'Trade Eliminado',
                `${trade.pair} ${trade.direction} ha sido eliminado exitosamente`,
                'success'
            );
        } catch (e) {
            window.showAlert(
                'Error al Eliminar',
                e.message || 'No se pudo eliminar el trade',
                'error'
            );
        }
    }
    
    // ========== MODAL HELPER FUNCTIONS ==========
    function closeModal(modal) {
        if (modal) {
            modal.classList.add('hidden');
            modal.style.display = 'none';
        }
        try {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
        } catch (e) {}
    }
    
    function openModal(modal, date) {
        if (!modal) {
            return;
        }
        selectedDateForModal = date;
        modal.classList.remove('hidden');
        modal.style.display = 'flex';
        modal.scrollTop = 0;
        try {
            document.body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
        } catch (e) {}

        const scrollArea = modal.querySelector('.modal-scroll');
        if (scrollArea) {
            scrollArea.scrollTop = 0;
        }
    }

    function initDayModal() {
        const closeBtn = document.getElementById('closeModal');
        closeBtn?.addEventListener('click', (e) => {
            e.stopPropagation();
            closeModal(dayModal);
        });

        dayModal?.addEventListener('click', function(e) {
            // Only close if clicking on the backdrop (the modal itself, not content)
            if (e.target === dayModal) {
                closeModal(dayModal);
            }
        });

        // Botón de borrar todos los trades del día
        document.getElementById('deleteAllTradesBtn')?.addEventListener('click', async (e) => {
            e.stopPropagation();
            
            const dateKey = selectedDateForModal;
            const allTrades = getTradesForDate(dateKey);
            
            if (!allTrades.length) return;
            
            const confirmed = await window.showConfirm({
                title: 'Eliminar Todos los Trades',
                message: `¿Estás seguro de eliminar las ${allTrades.length} operaciones del ${formatHumanDate(dateKey)}?\n\nEsta acción no se puede deshacer.`,
                confirmText: 'Eliminar Todos',
                cancelText: 'Cancelar',
                type: 'warning'
            });
            
            if (!confirmed) return;
            
            try {
                const userId = window.currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
                const currentAccount = window.currentAccount;
                
                if (!userId || !currentAccount) {
                    window.showAlert('Error de Sesión', 'Usuario o cuenta no encontrados', 'error');
                    return;
                }
                
                // Calcular P/L total de los trades a eliminar
                const totalPnL = allTrades.reduce((sum, t) => sum + (Number(t.profitUSD) || 0), 0);
                
                // Eliminar de BD
                const turso = window.tursoClient;
                if (turso) {
                    await turso.execute({
                        sql: 'DELETE FROM trades WHERE account_id = ? AND date = ?',
                        args: [currentAccount, dateKey]
                    });
                }
                
                // Actualizar balance
                if (window.accounts && window.accounts[currentAccount]) {
                    const newBalance = window.accounts[currentAccount].balance - totalPnL;
                    window.accounts[currentAccount].balance = newBalance;
                    
                    if (turso) {
                        await turso.execute({
                            sql: 'UPDATE accounts SET balance = ? WHERE id = ?',
                            args: [newBalance, currentAccount]
                        });
                    }
                }
                
                // Limpiar caché en memoria
                if (window.journalData && window.journalData[dateKey]) {
                    delete window.journalData[dateKey];
                }
                
                // Invalidar caché de recap
                if (window.invalidateRecapCache) window.invalidateRecapCache();
                
                // Actualizar UI
                if (window.updateDisplay) window.updateDisplay();
                
                // 🆕 Actualizar panel de Trade Control si está activo
                if (window.tradeControlUI && window.tradeControlUI.sessionPanel) {
                    try {
                        await window.tradeControlUI.updateSessionPanel();
                    } catch (e) {
                    }
                }
                
                // Actualizar el modal del día
                renderDayModal(dateKey);
                
                window.showNotification(`${allTrades.length} operaciones eliminadas correctamente`, 'success', 3000);
                
            } catch (err) {

                window.showAlert('Error al Eliminar', 'No se pudieron eliminar los trades: ' + (err.message || ''), 'error');
            }
        });

        // Delegate trade clicks inside the day modal - DELETE button & trade row
        document.getElementById('tradesList')?.addEventListener('click', async (e) => {
            const deleteBtn = e.target.closest('.trade-delete-btn');
            const item = e.target.closest('[data-trade-item]');
            
            if (!item) return;
            
            const packed = item.getAttribute('data-trade-json') || '';
            let trade = null;
            try {
                trade = JSON.parse(decodeURIComponent(packed));
            } catch (_) {
                return;
            }
            
            if (deleteBtn) {
                // Confirmación antes de eliminar (ahora con modal SAAS)
                const confirmed = await window.showConfirm(
                    'Eliminar Trade',
                    `¿Eliminar ${trade.pair} ${trade.direction} del ${formatHumanDate(selectedDateForModal)}?`,
                    'Eliminar',
                    'Cancelar',
                    'warning'
                );
                if (confirmed) {
                    deleteTradeFromCalendarDemo(trade, selectedDateForModal);
                }
            } else {
                // Click normal en la fila = abrir detalles
                openTradeDetails(trade, selectedDateForModal);
            }
        });

        // Delegate cashflow delete
        document.getElementById('balanceAdjustmentsList')?.addEventListener('click', async (e) => {
            const btn = e.target.closest('.cashflow-delete-btn');
            if (!btn) return;
            const cashflowId = btn.getAttribute('data-cashflow-id');
            if (!cashflowId) return;

            const accountId = window.currentAccount;
            if (!accountId || !window.tursoClient) return;

            const confirmed = await (window.showConfirm ? window.showConfirm('Eliminar ajuste', '¿Eliminar este ajuste de balance?') : Promise.resolve(confirm('¿Eliminar este ajuste de balance?')));
            if (!confirmed) return;

            try {
                await window.tursoClient.execute({
                    sql: 'DELETE FROM cashflows WHERE id = ? AND account_id = ?',
                    args: [cashflowId, accountId]
                });

                const cache = window.__cashflowsMap?.[accountId];
                if (cache && selectedDateForModal && cache[selectedDateForModal]) {
                    cache[selectedDateForModal] = cache[selectedDateForModal].filter(c => c.id !== cashflowId);
                }

                if (window.balanceStateManager) {
                    window.balanceStateManager.removeCashflow(accountId, cashflowId);
                }

                renderCashflowsSection(selectedDateForModal);
                if (typeof window.updateDisplay === 'function') {
                    try { window.updateDisplay(); } catch (_) {}
                }
            } catch (err) {
                showAlert('Error', 'No se pudo eliminar el ajuste.', 'error');
            }
        });

        // Delegate note buttons
        document.getElementById('notesPreview')?.addEventListener('click', async (e) => {
            const editBtn = e.target.closest('.note-edit-btn');
            const deleteBtn = e.target.closest('.note-delete-btn');
            
            if (editBtn) {
                openAddNotesForSelectedDate();
            } else if (deleteBtn) {
                // Confirmación antes de eliminar
                const confirmed = await window.showConfirm(
                    'Eliminar Nota',
                    `¿Eliminar la nota del ${formatHumanDate(selectedDateForModal)}?`,
                    'Eliminar',
                    'Cancelar',
                    'warning'
                );
                if (confirmed) {
                    try {
                        // Obtener dateKey correctamente (selectedDateForModal es un string YYYY-MM-DD)
                        const dateKey = typeof selectedDateForModal === 'string' 
                            ? selectedDateForModal 
                            : formatDateKey(selectedDateForModal);
                        
                        const userId = window.currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
                        const currentAccount = window.currentAccount;
                        
                        if (!userId || !currentAccount) {
                            window.showAlert('Error de Sesion', 'Error: sin usuario o cuenta', 'error');
                            return;
                        }
                        
                        // Eliminar de BD
                        const turso = window.tursoClient;
                        if (turso) {
                            await turso.execute({
                                sql: 'DELETE FROM daily_notes WHERE user_id = ? AND account_id = ? AND date = ?',
                                args: [userId, currentAccount, dateKey]
                            });
                        }
                        
                        // Limpiar caché en memoria
                        if (window.__dailyNotesMap) {
                            delete window.__dailyNotesMap[dateKey];
                        }
                        
                        // Mostrar éxito
                        window.showNotification('Nota eliminada correctamente', 'success', 3000);
                        
                        // Recargar UI
                        renderNotesPreview(dateKey);
                    } catch (err) {
                        // Error eliminando nota
                        window.showAlert('Error al Eliminar', 'No se pudo eliminar: ' + (err.message || ''), 'error');
                    }
                }
            }
        });
    }

    // ========== ACCOUNT SWITCHER DROPDOWN ==========
    function initAccountSwitcher() {
        const accountSwitchBtn = document.getElementById('accountSwitchBtn');
        const accountDropdown = document.getElementById('accountDropdown');
        const accountChevron = document.getElementById('accountChevron');

        if (!accountSwitchBtn || !accountDropdown) return;

        accountSwitchBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            const isOpen = accountDropdown.classList.contains('opacity-100');
            
            if (isOpen) {
                accountDropdown.classList.remove('opacity-100', 'visible', 'scale-100');
                accountDropdown.classList.add('opacity-0', 'invisible', 'scale-95');
                accountChevron.classList.remove('rotate-180');
            } else {
                accountDropdown.classList.add('opacity-100', 'visible', 'scale-100');
                accountDropdown.classList.remove('opacity-0', 'invisible', 'scale-95');
                accountChevron.classList.add('rotate-180');
            }
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', function(e) {
            if (!accountSwitchBtn.contains(e.target) && !accountDropdown.contains(e.target)) {
                accountDropdown.classList.remove('opacity-100', 'visible', 'scale-100');
                accountDropdown.classList.add('opacity-0', 'invisible', 'scale-95');
                accountChevron.classList.remove('rotate-180');
            }
        });

        // Account switching (sincronizado con app.js)
        const accountButtons = accountDropdown.querySelectorAll('button[class*="px-3 py-3"]');
        accountButtons.forEach((btn, index) => {
            if (index < 3) { // Only the 3 account buttons
                btn.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const accountIds = Object.keys(window.accounts || {});
                    const accountId = this.dataset.accountId || accountIds[index];
                    const account = (window.accounts || {})[accountId];

                    if (!accountId || !account) {
                        return;
                    }

                    // Remove active state from all accounts
                    accountButtons.forEach((b, i) => {
                        if (i < 3) {
                            b.classList.remove('bg-blue-600/20', 'border-blue-500/30');
                            b.classList.add('hover:bg-slate-800/50');
                        }
                    });
                    // Add active state to clicked account
                    this.classList.add('bg-blue-600/20', 'border-blue-500/30');

                    // Cambiar cuenta real
                    if (typeof window.selectCustomOption === 'function') {
                        window.selectCustomOption(accountId);
                        // Actualizar UI del switcher inmediatamente
                        try { syncAccountSwitcherVisual(accountId); } catch (e) {}
                    } else {
                        switchAccountFallback(accountId, account);
                    }

                    // Close dropdown
                    accountDropdown.classList.remove('opacity-100', 'visible', 'scale-100');
                    accountDropdown.classList.add('opacity-0', 'invisible', 'scale-95');
                    accountChevron.classList.remove('rotate-180');
                });
            }
        });

        // Create New Account button
        const openNewAccountBtn = document.getElementById('openNewAccountBtn');
        if (openNewAccountBtn) {
            openNewAccountBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                // Close dropdown first
                accountDropdown.classList.remove('opacity-100', 'visible', 'scale-100');
                accountDropdown.classList.add('opacity-0', 'invisible', 'scale-95');
                accountChevron.classList.remove('rotate-180');
                // Open account modal
                openModal(accountModal);
            });
        }
    }

    // ========== ADD TRADE & NOTES MODALS ==========
    function initTradeAndNotesModals() {
        const openAddTradeButtons = document.querySelectorAll('#openAddTradeBtn, #openAddTradeQuickBtn');
        const openAddNotesBtn = document.getElementById('openAddNotesBtn');
        const openAddNotesBtnTop = document.getElementById('openAddNotesBtnTop');
        const openAddBalanceAdjustmentBtn = document.getElementById('openAddBalanceAdjustmentBtn');
        const closeAddTradeBtn = document.getElementById('closeAddTradeModal');
        const closeAddNotesBtn = document.getElementById('closeAddNotesModal');
        const closeAddBalanceAdjustmentBtn = document.getElementById('closeAddBalanceAdjustmentModal');
        const cancelAddTrade = document.getElementById('cancelAddTrade');
        const cancelAddNotes = document.getElementById('cancelAddNotes');
        const cancelAddBalanceAdjustment = document.getElementById('cancelAddBalanceAdjustment');
        const addTradeForm = document.getElementById('addTradeForm');
        const addNotesForm = document.getElementById('addNotesForm');
        const addBalanceAdjustmentForm = document.getElementById('addBalanceAdjustmentForm');
        const addBalanceAdjustmentModal = document.getElementById('addBalanceAdjustmentModal');

        openAddTradeButtons.forEach((btn, index) => {
            btn.addEventListener('click', function(e) {
                e.stopPropagation();
                e.preventDefault();
                openAddTradeForSelectedDate();
            }, true); // Usar capture phase
        });

        if (openAddNotesBtn) {
            openAddNotesBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                openAddNotesForSelectedDate();
            });
        }

        if (openAddNotesBtnTop) {
            openAddNotesBtnTop.addEventListener('click', function(e) {
                e.stopPropagation();
                openAddNotesForSelectedDate();
            });
        }

        if (openAddBalanceAdjustmentBtn) {
            openAddBalanceAdjustmentBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                openAddBalanceAdjustmentForSelectedDate();
            });
        }

        closeAddTradeBtn?.addEventListener('click', () => closeModal(addTradeModal));
        closeAddNotesBtn?.addEventListener('click', () => closeModal(addNotesModal));
        closeAddBalanceAdjustmentBtn?.addEventListener('click', () => closeModal(addBalanceAdjustmentModal));
        cancelAddTrade?.addEventListener('click', () => closeModal(addTradeModal));
        cancelAddNotes?.addEventListener('click', () => closeModal(addNotesModal));
        cancelAddBalanceAdjustment?.addEventListener('click', () => closeModal(addBalanceAdjustmentModal));

        addTradeModal?.addEventListener('click', function(e) {
            if (e.target === addTradeModal) closeModal(addTradeModal);
        });

        addNotesModal?.addEventListener('click', function(e) {
            if (e.target === addNotesModal) closeModal(addNotesModal);
        });

        addBalanceAdjustmentModal?.addEventListener('click', function(e) {
            if (e.target === addBalanceAdjustmentModal) closeModal(addBalanceAdjustmentModal);
        });

        addTradeForm?.addEventListener('submit', async function(e) {
            // Prevent app.js handlers from running on this page
            e.preventDefault();
            e.stopImmediatePropagation();

            try {
                // ?? VALIDAR QUE HAY CUENTA ACTIVA - SIN FALLBACK A localStorage
                const currentAccount = window.currentAccount;
                const accounts = window.accounts || {};
                
                // Si no hay cuentas definidas en window, esperar muy poco
                if (Object.keys(accounts).length === 0 && !currentAccount) {
                    // Esperar máximo 500ms a que app.js termine de cargar
                    let waited = 0;
                    while (waited < 500 && !window.currentAccount) {
                        await new Promise(r => setTimeout(r, 50));
                        waited += 50;
                    }
                }
                
                if (!window.currentAccount) {
                    // Cerrar modal de trade
                    const addTradeModal = document.getElementById('addTradeModal');
                    if (addTradeModal) {
                        addTradeModal.classList.add('hidden');
                    }
                    // Esperar a que el usuario cierre el alert
                    await window.showAlert?.('Cuenta Requerida', 'Necesitas crear una cuenta primero para agregar trades', 'warning');
                    // DESPUÉS de cerrar el alert, mostrar el welcome modal
                    showWelcomeModal();
                    return;
                }

                if (!selectedDateForModal) throw new Error('No date selected');

                const currentAccountId = window.currentAccount;
                const currentAccountData = currentAccountId ? (window.accounts || {})[currentAccountId] : null;
                const isSynced = !!(currentAccountData && (currentAccountData.mt_account_number || currentAccountData.sync_provider === 'tradovate'));
                if (isSynced) {
                    showSyncedAccountModal(currentAccountData);
                    return;
                }

                // VALIDAR LIMITE DE PLAN (FREE = 20 trades/mes)
                const userPlan = sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'free';
                if (userPlan.toLowerCase() === 'free') {
                    const maxTradesPerMonth = 20;
                    const targetMonth = selectedDateForModal.slice(0, 7); // YYYY-MM
                    
                    // Contar trades del mes (desde DB)
                    let tradesInMonth = 0;
                    try {
                        if (typeof window.getMonthlyTradeCount === 'function') {
                            tradesInMonth = await window.getMonthlyTradeCount(window.currentAccount, targetMonth);
                        } else if (window.tursoClient) {
                            const result = await window.tursoClient.execute({
                                sql: "SELECT COUNT(*) as count FROM trades WHERE account_id = ? AND substr(REPLACE(REPLACE(date, '.', '-'), '/', '-'), 1, 7) = ?",
                                args: [window.currentAccount, targetMonth]
                            });
                            tradesInMonth = parseInt(result.rows[0]?.count || 0, 10);
                        } else {
                            // Fallback: contar desde memoria
                            tradesInMonth = Object.keys(window.journalData || {})
                                .filter(dateKey => String(dateKey).startsWith(targetMonth))
                                .reduce((sum, dateKey) => sum + ((window.journalData[dateKey] || []).length), 0);
                        }
                    } catch (error) {

                        // Fallback a memoria
                        tradesInMonth = Object.keys(window.journalData || {})
                            .filter(dateKey => dateKey.startsWith(targetMonth))
                            .reduce((sum, dateKey) => sum + ((window.journalData[dateKey] || []).length), 0);
                    }
                    
                    // Validar límite
                    if (tradesInMonth >= maxTradesPerMonth) {
                        if (typeof window.showAlert === 'function') {
                            await window.showAlert('Limite de Trades Alcanzado', `Has registrado ${tradesInMonth}/${maxTradesPerMonth} trades este mes. El plan FREE permite 20 trades/mes. Actualiza tu plan para trades ilimitados.`, 'warning');
                        } else if (typeof window.showNotification === 'function') {
                            window.showNotification(`Límite alcanzado: ${tradesInMonth}/${maxTradesPerMonth} trades este mes.`, 'warning', 4000);
                        }
                        return;
                    }
                }

                const pair = (document.getElementById('tradePair')?.value || '').trim().toUpperCase();
                const direction = document.getElementById('tradeDirection')?.value || '';
                const lotSize = Number(document.getElementById('tradeLotSize')?.value);
                const profitUSD = Number(document.getElementById('tradeProfitUSD')?.value);
                const entryTime = document.getElementById('tradeEntryTime')?.value || '';
                const exitTime = document.getElementById('tradeExitTime')?.value || '';
                const tradingViewUrl = (document.getElementById('tradeTradingViewUrl')?.value || '').trim();
                const comment = (document.getElementById('tradeComment')?.value || '').trim();
                
                // 🆕 Obtener modelo de entrada seleccionado
                const entryModelId = document.getElementById('tradeEntryModel')?.value || null;
                let entryModelSnapshot = null;
                
                if (entryModelId && window.selectedEntryModelData) {
                    entryModelSnapshot = JSON.stringify({
                        name: window.selectedEntryModelData.name,
                        conditions: window.selectedEntryModelData.conditions
                    });
                }

                if (!pair) throw new Error('Par requerido');
                if (!direction) throw new Error('Dirección requerida');
                if (!Number.isFinite(lotSize) || lotSize <= 0) throw new Error('Lotes inválidos');
                if (!Number.isFinite(profitUSD)) throw new Error('Resultado inválido');

                await saveTradeCalendarDemo(window.currentAccount, selectedDateForModal, {
                    pair,
                    direction,
                    lotSize,
                    profitUSD,
                    entryTime,
                    exitTime,
                    tradingViewUrl,
                    comment,
                    entryModelId,
                    entryModelSnapshot,
                    timestamp: new Date().toISOString(),
                    importSource: 'manual'
                });

                // 🆕 Actualizar panel de Trade Control si está activo
                if (window.tradeControlUI && window.tradeControlUI.sessionPanel) {
                    try {
                        await window.tradeControlUI.updateSessionPanel();
                    } catch (e) {
                    }
                }

                if (typeof window.invalidateRecapCache === 'function') {
                    try { window.invalidateRecapCache(); } catch (_) {}
                }
                if (typeof window.updateDisplay === 'function') {
                    try { window.updateDisplay(); } catch (_) {}
                }

                this.reset();
                closeModal(addTradeModal);
                renderDayModal(selectedDateForModal);

                // Agregar notificación al centro de notificaciones
                if (window.NotificationCenter) {
                    const userPlan = sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'free';
                    if (userPlan.toLowerCase() === 'free') {
                        // Contar trades del mes para advertir si está cerca del límite
                        const targetMonth = selectedDateForModal.slice(0, 7);
                        let tradesInMonth = Object.keys(window.journalData || {})
                            .filter(dateKey => dateKey.startsWith(targetMonth))
                            .reduce((sum, dateKey) => sum + ((window.journalData[dateKey] || []).length), 0);
                        
                        if (tradesInMonth >= 15 && tradesInMonth < 20) {
                            window.NotificationCenter.add({
                                type: 'warning',
                                title: 'Acercándote al límite',
                                message: `Has usado ${tradesInMonth}/20 trades este mes. Considera mejorar a PRO para trades ilimitados.`,
                                action: () => {
                                    window.location.href = '/perfil?tab=billing';
                                }
                            });
                        }
                    }
                    
                    // Notificación de trade ganador
                    if (profitUSD > 0) {
                        window.NotificationCenter.add({
                            type: 'success',
                            title: '¡Trade ganador registrado!',
                            message: `${pair} ${direction === 'BUY' ? '📈' : '📉'} +$${profitUSD.toFixed(2)}`
                        });
                    }
                }

                if (typeof window.showNotification === 'function') {
                    window.showNotification('Trade guardado', 'success');
                } else if (typeof showToast === 'function') {
                    showToast('Trade guardado correctamente', 'success');
                }
            } catch (err) {
                const rawMsg = err?.message || '';
                const isLimit = rawMsg.toLowerCase().includes('limite') || rawMsg.toLowerCase().includes('límite');
                if (isLimit && typeof window.showAlert === 'function') {
                    await window.showAlert('Limite de Trades Alcanzado', rawMsg, 'warning');
                    return;
                }
                const msg = window.getSafeErrorMessage(err) || 'No se pudo guardar el trade';
                if (typeof window.showNotification === 'function') {
                    window.showNotification(msg, 'error');
                } else if (typeof showToast === 'function') {
                    showToast(msg, 'error');
                }
            }
        }, { capture: true });

        addNotesForm?.addEventListener('submit', async function(e) {
            // Prevent app.js handlers from running on this page
            e.preventDefault();
            e.stopImmediatePropagation();

            try {
                // ?? VALIDAR QUE HAY CUENTA ACTIVA - SIN FALLBACK A localStorage
                if (!window.currentAccount) {
                    // Cerrar modal de notas
                    const addNotesModal = document.getElementById('addNotesModal');
                    if (addNotesModal) {
                        addNotesModal.classList.add('hidden');
                    }
                    // Esperar a que el usuario cierre el alert
                    await window.showAlert?.('Cuenta Requerida', 'Necesitas crear una cuenta primero para agregar notas', 'warning');
                    // DESPUÉS de cerrar el alert, mostrar el welcome modal
                    showWelcomeModal();
                    return;
                }

                if (!selectedDateForModal) throw new Error('No date selected');
                const sentiment = document.getElementById('notesSentiment')?.value || '';
                const outcome = document.getElementById('notesOutcome')?.value || '';
                const text = document.getElementById('notesTextarea')?.value || '';

                if (typeof window.saveDailyNote !== 'function') {
                    throw new Error('saveDailyNote no disponible');
                }

                const ok = await window.saveDailyNote(selectedDateForModal, sentiment, text, outcome);
                if (!ok) throw new Error('No se pudo guardar la nota');

                closeModal(addNotesModal);
                renderDayModal(selectedDateForModal);

                if (typeof window.showNotification === 'function') {
                    window.showNotification('Notas guardadas', 'success');
                } else if (typeof showToast === 'function') {
                    showToast('Notas guardadas correctamente', 'success');
                }
            } catch (err) {
                const msg = window.getSafeErrorMessage(err) || 'No se pudo guardar la nota';
                if (typeof window.showNotification === 'function') {
                    window.showNotification(msg, 'error');
                } else if (typeof showToast === 'function') {
                    showToast(msg, 'error');
                }
            }
        }, { capture: true });
    }

    // ========== IMPORT MODAL ==========
    function initImportModal() {
        const closeImportBtn = document.getElementById('closeImportModal');
        const cancelImport = document.getElementById('cancelImport');
        const importForm = document.getElementById('importForm');

        closeImportBtn?.addEventListener('click', () => closeModal(importModal));
        cancelImport?.addEventListener('click', () => closeModal(importModal));

        importModal?.addEventListener('click', function(e) {
            if (e.target === importModal) closeModal(importModal);
        });

        // NO manejar el submit aquí, dejamos que app.js lo maneje
        // app.js tiene toda la lógica de importación real
    }

    // ========== ACCOUNT MODAL ==========
    function initAccountModal() {
        const closeAccountBtn = document.getElementById('closeAccountModal');
        const cancelAccount = document.getElementById('cancelAccount');
        const accountForm = document.getElementById('accountForm');
        const tabManual = document.getElementById('tab-manual');
        const tabAuto = document.getElementById('tab-auto');
        const manualPanel = document.getElementById('manualPanel');
        const autoPanel = document.getElementById('autoPanel');
        const openImportBtn = document.getElementById('openImportBtn');
        const syncStep1 = document.getElementById('syncStep1');
        const syncStep2 = document.getElementById('syncStep2');
        const syncStep3 = document.getElementById('syncStep3');
        const platformBtns = document.querySelectorAll('.platform-btn');
        const proceedSyncBtn = document.getElementById('proceedSyncBtn');

        closeAccountBtn?.addEventListener('click', () => closeModal(accountModal));
        cancelAccount?.addEventListener('click', () => closeModal(accountModal));

        accountModal?.addEventListener('click', function(e) {
            if (e.target === accountModal) closeModal(accountModal);
        });

        // Tab switching
        tabManual?.addEventListener('click', () => {
            tabManual.classList.add('bg-gradient-to-r', 'from-blue-600', 'to-cyan-600', 'text-white');
            tabManual.classList.remove('text-slate-400', 'hover:text-white');
            tabAuto?.classList.remove('bg-gradient-to-r', 'from-blue-600', 'to-cyan-600', 'text-white');
            tabAuto?.classList.add('text-slate-400', 'hover:text-white');
            manualPanel?.classList.remove('hidden');
            autoPanel?.classList.add('hidden');
        });

        tabAuto?.addEventListener('click', () => {
            tabAuto.classList.add('bg-gradient-to-r', 'from-blue-600', 'to-cyan-600', 'text-white');
            tabAuto.classList.remove('text-slate-400', 'hover:text-white');
            tabManual?.classList.remove('bg-gradient-to-r', 'from-blue-600', 'to-cyan-600', 'text-white');
            tabManual?.classList.add('text-slate-400', 'hover:text-white');
            autoPanel?.classList.remove('hidden');
            manualPanel?.classList.add('hidden');
        });

        // Account form - Event listener removed (handled in line 3919 with full validation)
        // The submit event is now properly managed by the dedicated handler below

        // Open import from account
        openImportBtn?.addEventListener('click', () => {
            closeModal(accountModal);
            openModal(importModal);
        });

        // Platform selection
        platformBtns.forEach(btn => {
            btn.addEventListener('click', function() {
                syncStep1?.classList.add('hidden');
                syncStep2?.classList.remove('hidden');
            });
        });

        // Proceed to sync
        proceedSyncBtn?.addEventListener('click', () => {
            syncStep2?.classList.add('hidden');
            syncStep3?.classList.remove('hidden');
        });

        addBalanceAdjustmentForm?.addEventListener('submit', async function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            try {
                if (!selectedDateForModal) throw new Error('No date selected');
                const accountId = window.currentAccount;
                const userId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');

                if (!accountId || !userId) {
                    showAlert('Cuenta requerida', 'Selecciona una cuenta primero.', 'warning');
                    return;
                }

                const typeEl = document.getElementById('cashflowType');
                const amountEl = document.getElementById('cashflowAmount');
                const notesEl = document.getElementById('cashflowNotes');

                const type = typeEl ? typeEl.value : 'deposit';
                const amount = amountEl ? Number(amountEl.value) : 0;
                const notes = notesEl ? notesEl.value.trim() : '';

                if (!amount || amount <= 0) {
                    showAlert('Monto inválido', 'Ingresa un monto válido.', 'warning');
                    return;
                }

                const id = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : `cash_${Date.now()}_${Math.random().toString(16).slice(2)}`;
                const createdAt = new Date().toISOString();

                await window.tursoClient.execute({
                    sql: 'INSERT INTO cashflows (id, user_id, account_id, type, amount, date, notes, created_at) VALUES (?, ?, ?, ?, ?, ?, ?, ?)',
                    args: [id, userId, accountId, type, amount, selectedDateForModal, notes || null, createdAt]
                });

                const record = { id, user_id: userId, account_id: accountId, type, amount, date: selectedDateForModal, notes, created_at: createdAt };
                window.__cashflowsMap = window.__cashflowsMap || {};
                window.__cashflowsMap[accountId] = window.__cashflowsMap[accountId] || {};
                window.__cashflowsMap[accountId][selectedDateForModal] = window.__cashflowsMap[accountId][selectedDateForModal] || [];
                window.__cashflowsMap[accountId][selectedDateForModal].unshift(record);

                if (window.balanceStateManager) {
                    window.balanceStateManager.addCashflow(accountId, record);
                }

                if (amountEl) amountEl.value = '';
                if (notesEl) notesEl.value = '';

                closeModal(addBalanceAdjustmentModal);
                renderCashflowsSection(selectedDateForModal);
                if (typeof window.updateDisplay === 'function') {
                    try { window.updateDisplay(); } catch (_) {}
                }
            } catch (err) {
                showAlert('Error', err.message || 'No se pudo guardar el ajuste.', 'error');
            }
        });
    }

    // ========== TRADE DETAILS MODAL ==========
    function initTradeDetailsModal() {
        const closeTradeDetailsBtn = document.getElementById('closeTradeDetailsModal');

        const closeTradeDetails = () => {
            if (tradeDetailsModal) {
                tradeDetailsModal.classList.add('hidden');
                tradeDetailsModal.style.display = 'none';
            }
        };

        closeTradeDetailsBtn?.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            closeTradeDetails();
        });

        tradeDetailsModal?.addEventListener('click', function(e) {
            // Only close if clicking on the backdrop (the modal itself, not content)
            if (e.target === tradeDetailsModal) {
                e.stopPropagation();
                e.preventDefault();
                closeTradeDetails();
            }
        });
    }

    // ========== TRADE CONTROL ==========
    function initTradeControl() {
        if (window.tradeControlUI) {
            window.tradeControlUI.init();
        }
        
        const btn = document.getElementById('tradeControlBtn');
        if (btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();

                const access = window.getUserAccess ? window.getUserAccess() : {
                    userPlan: (sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'free').toLowerCase().trim(),
                    userType: (sessionStorage.getItem('userType') || localStorage.getItem('userType') || 'user').toLowerCase().trim(),
                    isLoggedIn: !!(sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId'))
                };

                const hasAccess = access.userType === 'admin' || access.userPlan === 'unlimited';

                if (!hasAccess) {
                    if (typeof showToast === 'function') {
                        showToast('IA Scanner está disponible solo para UNLIMITED. Actualiza tu plan desde tu perfil.', 'warning', 5000);
                    }
                    return;
                }

                // IA Scanner maneja la apertura del modal
                if (window.iaScannerSAAS && typeof window.iaScannerSAAS.open === 'function') {
                    window.iaScannerSAAS.open();
                }
            });
        }
        
        updateTradeControlVisibility();
    }

    function updateTradeControlVisibility() {
        const btn = document.getElementById('tradeControlBtn');
        if (!btn) return;

        const access = window.getUserAccess ? window.getUserAccess() : {
            userPlan: (sessionStorage.getItem('userPlan') || localStorage.getItem('userPlan') || 'free').toLowerCase().trim(),
            userType: (sessionStorage.getItem('userType') || localStorage.getItem('userType') || 'user').toLowerCase().trim(),
            isLoggedIn: !!(sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId'))
        };

        const hasAccess = access.userType === 'admin' || access.userPlan === 'unlimited';
        const isLoggedIn = access.isLoggedIn;

        if (!isLoggedIn || !hasAccess) {
            btn.style.display = 'none';
        } else {
            btn.style.display = 'flex';
        }

    }

    window.updateTradeControlVisibility = updateTradeControlVisibility;

    // ========== NAVIGATION BUTTONS (MONTH NAVIGATION) ==========
    // Vincular botones prev/next month con changeMonth de app.js
    const prevMonthBtn = document.getElementById('prevMonth');
    const nextMonthBtn = document.getElementById('nextMonth');
    
    if (prevMonthBtn) {
        prevMonthBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // En vista anual, la navegación la gestiona journal-calendar.js
            if (window.journalCalendar?.syncState?.viewMode === 'annual') return;
            if (typeof window.changeMonth === 'function') {
                window.changeMonth(-1);
            }
        });
    }
    
    if (nextMonthBtn) {
        nextMonthBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // En vista anual, la navegación la gestiona journal-calendar.js
            if (window.journalCalendar?.syncState?.viewMode === 'annual') return;
            if (typeof window.changeMonth === 'function') {
                window.changeMonth(1);
            }
        });
    }

    // ========== SOBRESCRIBIR window.closeModal para evitar conflictos con app.js ==========
    window.closeModal = function(modalToClose) {
        // Si se pasa un modal específico, cerrarlo
        if (modalToClose) {
            modalToClose.classList.add('hidden');
            modalToClose.style.display = 'none';
            return;
        }
        // Si no se pasa nada, cerrar el dayModal por defecto
        const dayModal = document.getElementById('dayModal');
        if (dayModal) {
            dayModal.classList.add('hidden');
            dayModal.style.display = 'none';
        }
    };
    
    // ========== END OF DOMCONTENTLOADED ==========
});

// ========== EBOOK DOWNLOAD BUTTON ==========
function initEbookBtn() {
    const ebookBtn = document.getElementById('downloadEbookBtn');
    if (!ebookBtn) return;
    
    ebookBtn.addEventListener('click', function() {
        // Estado de cargando
        ebookBtn.disabled = true;
        ebookBtn.classList.add('opacity-60');
        
        // Obtener el SVG y agregarlo animación
        const svg = ebookBtn.querySelector('svg');
        if (svg) {
            svg.classList.add('animate-spin');
        }
        
        // Cambiar texto
        const textNode = ebookBtn.childNodes[ebookBtn.childNodes.length - 1];
        const originalText = textNode.textContent;
        textNode.textContent = ' Descargando...';
        
        // Llamar función de descarga real
        if (typeof window.downloadEbook === 'function') {
            window.downloadEbook();
        }
        
        // Restaurar botón después de 2 segundos
        setTimeout(() => {
            ebookBtn.disabled = false;
            ebookBtn.classList.remove('opacity-60');
            if (svg) {
                svg.classList.remove('animate-spin');
            }
            textNode.textContent = ' ' + originalText;
        }, 2000);
    });
}

// ========== CALCULATOR MODAL ==========
function initCalculatorModal() {
    const openBtn = document.getElementById('openCalculatorBtn');
    const modal = document.getElementById('calculatorModal');
    const closeBtn = document.getElementById('closeCalculatorModal');
    const content = document.getElementById('calculatorModalContent');
    
    if (!modal || !closeBtn || !content) {
        return;
    }
    
    const openCalculatorModal = () => {
        modal.classList.remove('hidden');
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        
        // Renderizar calculadora en el modal
        if (window.tradeControlCalculator) {
            window.tradeControlCalculator.render('calculatorModalContent');
            
            // Auto-sincronizar balance actual
            setTimeout(() => {
                if (typeof window.tradeControlCalculator.syncBalance === 'function') {
                    window.tradeControlCalculator.syncBalance();
                }
            }, 100);
        }
    };
    
    // Cerrar modal
    const closeCalculatorModal = () => {
        modal.classList.add('hidden');
        modal.style.display = 'none';
        document.body.style.overflow = '';
    };
    
    // Exponer a window para acceso global
    window.openCalculatorModal = openCalculatorModal;
    window.closeCalculatorModal = closeCalculatorModal;
    
    // Abrir modal
    if (openBtn) {
        openBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openCalculatorModal();
        });
    }
    
    closeBtn.addEventListener('click', closeCalculatorModal);
    
    // Cerrar al hacer clic fuera del modal
    modal.addEventListener('click', function(e) {
        if (e.target === modal) {
            closeCalculatorModal();
        }
    });
    
    // Cerrar con ESC
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) {
            closeCalculatorModal();
        }
    });
}

// ========== RECAP BUTTON ==========
function initRecapBtn() {
    const recapBtn = document.getElementById('generateRecapBtn');
    if (!recapBtn) return;
    
    recapBtn.addEventListener('click', async function() {
        // Mostrar indicador de carga
        const originalHTML = recapBtn.innerHTML;
        recapBtn.disabled = true;
        recapBtn.innerHTML = `
            <svg class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            <span>Generando...</span>
        `;
        
        // Simular proceso de carga
        await new Promise(resolve => setTimeout(resolve, 800));
        
        // Restaurar botón
        recapBtn.disabled = false;
        recapBtn.innerHTML = originalHTML;
        // Llamar a la función openRecapModal del recap-card.js
        if (typeof openRecapModal === 'function') {
            openRecapModal();
        } else {
            if (typeof showError === 'function') {
                showError('Error: Módulo de recap no cargado. Recarga la página.');
            } else if (typeof showToast === 'function') {
                showToast('Error: Módulo de recap no cargado', 'error');
            }
        }
    });
}


// ========== MOBILE MENU ==========
function initMobileMenu() {
    const mobileMenuBtn = document.getElementById('mobileMenuBtn');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileMenuBackdrop = document.getElementById('mobileMenuBackdrop');
    const mobileMenuSidebar = document.getElementById('mobileMenuSidebar');
    const closeMobileMenu = document.getElementById('closeMobileMenu');
    
    if (!mobileMenuBtn || !mobileMenu) return;
    
    // ?? IMPORTANTE: Actualizar visibilidad de botones admin SIEMPRE
    function updateAdminButtonVisibility() {
        const userType = (localStorage.getItem('userType') || '').toLowerCase().trim();
        const isAdmin = userType === 'admin';
        
        // Botón Desktop Admin
        const desktopAdminBtn = document.getElementById('desktopAdminBtn');
        if (desktopAdminBtn) {
            desktopAdminBtn.style.display = isAdmin ? 'inline-block' : 'none';
        }
        
        // Botón Móvil Admin
        const mobileAdminBtn = document.getElementById('mobileAdminBtn');
        if (mobileAdminBtn) {
            mobileAdminBtn.style.display = isAdmin ? 'block' : 'none';
        }
    }
    
    // Ejecutar al cargar
    updateAdminButtonVisibility();
    
    // Abrir menú móvil con animación
    mobileMenuBtn.addEventListener('click', function() {
        mobileMenu.style.display = 'block';
        document.body.style.overflow = 'hidden';
        
        // Trigger animations
        requestAnimationFrame(() => {
            if (mobileMenuBackdrop) mobileMenuBackdrop.style.opacity = '1';
            if (mobileMenuSidebar) mobileMenuSidebar.style.transform = 'translateX(0)';
        });
        
        // Actualizar info del usuario
        const userName = localStorage.getItem('userName') || (sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail'))?.split('@')[0] || 'Usuario';
        const userEmail = sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail') || '';
        const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
        
        const mobileUserName = document.getElementById('mobileUserName');
        const mobileUserEmail = document.getElementById('mobileUserEmail');
        const mobileUserInitials = document.getElementById('mobileUserInitials');
        const mobileGestionLink = document.getElementById('mobileGestionLink');
        
        if (mobileUserName) mobileUserName.textContent = userName;
        if (mobileUserEmail) mobileUserEmail.textContent = userEmail;
        if (mobileUserInitials) mobileUserInitials.textContent = userName.substring(0, 1).toUpperCase();
        
        // Mostrar Gestión solo si no es free
        if (mobileGestionLink) {
            mobileGestionLink.style.display = (userPlan !== 'free') ? 'flex' : 'none';
        }
        
        // ?? Actualizar visibilidad de botones admin cuando abre menú
        updateAdminButtonVisibility();
    });
    
    // Función para cerrar con animación
    function closeMenuWithAnimation() {
        if (mobileMenuBackdrop) mobileMenuBackdrop.style.opacity = '0';
        if (mobileMenuSidebar) mobileMenuSidebar.style.transform = 'translateX(calc(100% + 16px))';
        
        setTimeout(() => {
            mobileMenu.style.display = 'none';
            document.body.style.overflow = '';
        }, 300); // Esperar a que termine la animación
    }
    
    // Cerrar menú móvil
    if (closeMobileMenu) {
        closeMobileMenu.addEventListener('click', closeMenuWithAnimation);
    }
    
    // Cerrar al hacer clic en el backdrop
    if (mobileMenuBackdrop) {
        mobileMenuBackdrop.addEventListener('click', closeMenuWithAnimation);
    }
}

// ========== USER PROFILE DISPLAY (DESKTOP) ==========
function initUserProfileBtn() {
    // Actualizar el nombre del usuario en el header desktop
    const userGreeting = document.getElementById('userGreeting');
    if (userGreeting) {
        const userName = localStorage.getItem('userName') || (sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail'))?.split('@')[0] || 'Usuario';
        userGreeting.textContent = userName.toUpperCase();
    }
    
    // Actualizar las iniciales
    const calendarUserInitials = document.getElementById('calendarUserInitials');
    if (calendarUserInitials) {
        const userName = localStorage.getItem('userName') || (sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail'))?.split('@')[0] || 'Usuario';
        calendarUserInitials.textContent = userName.substring(0, 1).toUpperCase();
    }
}

// Actualizar visibilidad del botón de Eventos según el plan
function updateSyncEventsButtonVisibility() {
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    const syncEventsBtn = document.getElementById('syncEventsBtn');
    if (syncEventsBtn) {
        const shouldShow = userPlan !== 'free';
        if (shouldShow) {
            syncEventsBtn.classList.remove('hidden');
            syncEventsBtn.style.removeProperty('display');
        } else {
            syncEventsBtn.classList.add('hidden');
            syncEventsBtn.style.display = 'none !important';
        }
    }
}

// ========== SINCRONIZACIÓN TIP NOTIFICATION ==========
// Mostrar notificación flotante una sola vez por login explicando cómo resincronizar
function initSyncTipNotification() {
    // Solo mostrar si hay cuentas sincronizadas
    const accounts = JSON.parse(localStorage.getItem('accountsData') || '[]');
    const syncedAccounts = accounts.filter(acc => acc.type === 'trading' && acc.synced_at);
    
    if (syncedAccounts.length === 0) return;
    
    const currentUser = sessionStorage.getItem('userEmail') || localStorage.getItem('userEmail') || 'unknown';
    const tipShownKey = `syncTipShown_${currentUser}`;
    
    // Verificar si ya se mostró en esta sesión
    if (sessionStorage.getItem(tipShownKey)) {
        return;
    }
    
    // Marcar que ya se mostró
    sessionStorage.setItem(tipShownKey, '1');
    
    // Crear el banner flotante
    const banner = document.createElement('div');
    banner.className = 'fixed bottom-4 right-4 bg-blue-950/95 backdrop-blur border border-blue-500/30 rounded-lg shadow-2xl p-4 max-w-sm z-50 animate-slideInUp';
    banner.innerHTML = `
        <div class="flex gap-3">
            <div class="flex-shrink-0">
                <div class="flex items-center justify-center h-8 w-8 rounded-full bg-blue-500/20 border border-blue-500/50">
                    <svg class="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                    </svg>
                </div>
            </div>
            <div class="flex-1">
                <h3 class="text-sm font-semibold text-blue-200">Sincronización de trades</h3>
                <p class="text-xs text-blue-300/90 mt-1 leading-relaxed">
                    Si no ves un trade sincronizado después de cerrarlo, cierra MetaTrader y vuelve a abrirlo. El EA se resincronizará automáticamente.
                </p>
            </div>
            <button class="flex-shrink-0 ml-2">
                <svg class="h-5 w-5 text-blue-400 hover:text-blue-300 transition-colors" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
            </button>
        </div>
    `;
    
    // Agregar al DOM
    document.body.appendChild(banner);
    
    // Cerrar al hacer clic en la X
    const closeBtn = banner.querySelector('button');
    closeBtn.addEventListener('click', () => {
        banner.style.animation = 'slideOutDown 0.3s ease-out forwards';
        setTimeout(() => banner.remove(), 300);
    });
    
    // Auto-cerrar después de 8 segundos
    setTimeout(() => {
        if (banner.parentElement) {
            banner.style.animation = 'slideOutDown 0.3s ease-out forwards';
            setTimeout(() => banner.remove(), 300);
        }
    }, 8000);
}

// Escuchar cambios en localStorage para actualizar botón de eventos
window.addEventListener('storage', function(e) {
    if (e.key === 'userPlan') {
        updateSyncEventsButtonVisibility();
    }
});

// ============ ECONOMIC EVENTS INTEGRATION ============
// Lee eventos desde BD (sincronizados automáticamente cada día a las 3AM UTC por el worker)
// Cache de 6 horas para proteger el plan gratuito de Cloudflare Workers

const EVENTS_CACHE_KEY = 'economicEventsCache';
const EVENTS_CACHE_TIMESTAMP_KEY = 'economicEventsCacheTimestamp';
const CACHE_DURATION_MS = 6 * 60 * 60 * 1000; // 6 horas

function setupEconomicEventsSync() {
    const syncBtn = document.getElementById('syncEventsBtn');
    if (!syncBtn) return;

    function hasEventsForCurrentWeek(eventsData) {
        if (!Array.isArray(eventsData) || eventsData.length === 0) return false;
        // Calculate current week boundaries (Monday to Sunday)
        const now = new Date();
        const dayOfWeek = now.getDay(); // 0=Sun, 1=Mon...
        const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
        const monday = new Date(now);
        monday.setDate(now.getDate() + diffToMonday);
        monday.setHours(0, 0, 0, 0);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        sunday.setHours(23, 59, 59, 999);
        const mondayStr = monday.toISOString().split('T')[0];
        const sundayStr = sunday.toISOString().split('T')[0];
        return eventsData.some(e => {
            const eventDate = (e.date || '').split('T')[0];
            return eventDate >= mondayStr && eventDate <= sundayStr;
        });
    }

    function setEventsButtonState(hasCurrentWeekEvents) {
        if (!syncBtn) return;
        if (hasCurrentWeekEvents) {
            syncBtn.disabled = false; // Keep clickable for manual re-sync
            syncBtn.classList.remove('is-disabled');
            syncBtn.title = 'Eventos de esta semana visibles — click para resincronizar';
        } else {
            syncBtn.disabled = false;
            syncBtn.classList.remove('is-disabled');
            syncBtn.title = 'Sincronizar eventos de esta semana';
        }
    }

    // Cargar eventos automáticamente al iniciar (desde cache o BD)
    loadEconomicEventsFromDB(false).then(eventsData => {
        const hasThisWeek = hasEventsForCurrentWeek(eventsData);
        setEventsButtonState(hasThisWeek);
        
        // Auto-sync if no events for current week
        if (!hasThisWeek && eventsData !== undefined) {
            // Trigger auto-sync silently
            fetch('https://trading-journal-preprod.monkeydfx-trader.workers.dev/api/sync-economic-events', { method: 'POST' })
                .then(r => r.ok ? loadEconomicEventsFromDB(true) : null)
                .then(freshData => {
                    if (freshData) setEventsButtonState(hasEventsForCurrentWeek(freshData));
                })
                .catch(() => {}); // Silent fallback
        }
    }); // false = no forzar, usar cache si es válido
    
    // Controlar visibilidad inicial
    updateEventsButtonVisibility();

    syncBtn.addEventListener('click', async function() {
        if (window.demoGate && window.demoGate('events', 'Eventos')) {
            return;
        }
        if (syncBtn.disabled) return; // Prevenir clicks múltiples
        
        const icon = document.getElementById('syncIcon');
        
        const now = Date.now();
        
        // Mostrar animación de carga
        if (icon) icon.classList.add('animate-spin');
        syncBtn.disabled = true;
        
        try {
            // Obtener token del usuario desde localStorage
            const userToken = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
            if (!userToken) {
                throw new Error('No hay sesión activa. Por favor inicia sesión nuevamente.');
            }
            
            // Forzar sync en el worker y luego recargar desde BD
            const syncResponse = await fetch(
                'https://trading-journal-preprod.monkeydfx-trader.workers.dev/api/sync-economic-events',
                { method: 'POST' }
            );
            if (!syncResponse.ok) {
                throw new Error('No se pudo sincronizar eventos');
            }

            const eventsData = await loadEconomicEventsFromDB(true);
            setEventsButtonState(hasEventsForCurrentWeek(eventsData));
            
            // Desactivar botón después de sincronizar exitosamente
            syncBtn.disabled = true;
            syncBtn.title = '✅ Eventos sincronizados — disponibles en el calendario';
            
            if (typeof showToast === 'function') {
                showToast('Eventos económicos actualizados', 'success');
            }
            
            // Re-habilitar botón después de 30 segundos
            setTimeout(() => {
                syncBtn.disabled = false;
                syncBtn.title = 'Sincronizar eventos de esta semana';
            }, 30000);
        } catch (error) {
            // En caso de error, re-habilitar inmediatamente
            syncBtn.disabled = false;
            if (typeof showToast === 'function') {
                showToast(error.message, 'error');
            }
        } finally {
            // Restaurar solo la animación, no el estado del botón
            if (icon) icon.classList.remove('animate-spin');
        }
    });
}

// Controlar visibilidad del botón Eventos según mes visible
function updateEventsButtonVisibility() {
    const syncBtn = document.getElementById('syncEventsBtn');
    if (!syncBtn) return;
    
    // PRIMERO: Verificar plan del usuario
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    if (userPlan !== 'unlimited') {
        // Si no es UNLIMITED, NO MOSTRAR bajo ninguna circunstancia
        syncBtn.classList.add('hidden');
        syncBtn.style.display = 'none !important';
        return;
    }
    
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();
    
    // Obtener mes visible del calendario
    const visibleDate = window.currentDate || now;
    const visibleMonth = visibleDate.getMonth();
    const visibleYear = visibleDate.getFullYear();
    
    // Mostrar solo si estamos en el mes actual Y NO ES PLAN FREE
    if (currentMonth === visibleMonth && currentYear === visibleYear) {
        syncBtn.classList.remove('hidden');
        syncBtn.style.display = 'inline-flex !important';
    } else {
        syncBtn.classList.add('hidden');
        syncBtn.style.display = 'none !important';
    }
}

// Exponer globalmente para que app.js pueda actualizar al cambiar de mes
window.updateEventsButtonVisibility = updateEventsButtonVisibility;

async function loadEconomicEventsFromDB(forceRefresh = false) {
    try {
        // VERIFICAR PLAN - Solo UNLIMITED tiene acceso
        const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
        if (userPlan !== 'unlimited') {
            // Plan no UNLIMITED: No cargar eventos
            return;
        }
        
        const userToken = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
        if (!userToken) return;
        
        // Verificar cache válido
        const lastFetch = parseInt(localStorage.getItem(EVENTS_CACHE_TIMESTAMP_KEY) || '0');
        const now = Date.now();
        const cacheValid = (now - lastFetch) < CACHE_DURATION_MS;
        
        // Also invalidate cache if it's from a different week (Mon-Sun)
        let cacheWeekValid = true;
        if (cacheValid && lastFetch > 0) {
            const cachedDate = new Date(lastFetch);
            const currentDate = new Date();
            // Get Monday of each week
            const getMonday = (d) => {
                const day = d.getDay();
                const diff = day === 0 ? -6 : 1 - day;
                const m = new Date(d);
                m.setDate(d.getDate() + diff);
                m.setHours(0,0,0,0);
                return m.getTime();
            };
            cacheWeekValid = getMonday(cachedDate) === getMonday(currentDate);
        }
        
        let eventsData;
        
        if (!forceRefresh && cacheValid && cacheWeekValid) {
            // Usar cache
            const cachedEvents = localStorage.getItem(EVENTS_CACHE_KEY);
            if (cachedEvents) {
                try {
                    eventsData = JSON.parse(cachedEvents);

                    markEconomicEventDates(eventsData);
                    return eventsData;
                } catch (e) {

                }
            }
        }
        
        // Fetch desde BD (protegido por rate limiting)
        const today = new Date();
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const futureDate = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);
        
        const fromDate = monthStart.toISOString().split('T')[0];
        const toDate = futureDate.toISOString().split('T')[0];
        
        const eventsResponse = await fetch(
            `https://trading-journal-preprod.monkeydfx-trader.workers.dev/api/economic-events?from=${fromDate}&to=${toDate}`,
            {
                headers: {
                    'Authorization': `Bearer ${userToken}`
                }
            }
        );
        
        if (!eventsResponse.ok) {
            throw new Error('Error al obtener eventos');
        }
        
        const response = await eventsResponse.json();
        eventsData = response.rows || [];
        
        // Guardar en cache
        localStorage.setItem(EVENTS_CACHE_KEY, JSON.stringify(eventsData));
        localStorage.setItem(EVENTS_CACHE_TIMESTAMP_KEY, now.toString());
        
        // Marcar fechas con eventos en el calendario
        if (Array.isArray(eventsData)) {
            markEconomicEventDates(eventsData);

        }
        return eventsData;
    } catch (error) {

        
        // Intentar cargar desde cache como fallback
        const cachedEvents = localStorage.getItem(EVENTS_CACHE_KEY);
        if (cachedEvents) {
            try {
                const eventsData = JSON.parse(cachedEvents);
                markEconomicEventDates(eventsData);
                return eventsData;

            } catch (e) {
                // Ignore
            }
        }
    }

    return [];
}

function markEconomicEventDates(events) {
    // VERIFICAR PLAN - Solo UNLIMITED tiene acceso a eventos económicos
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    if (userPlan !== 'unlimited') {
        // Plan no UNLIMITED: NO marcar eventos ni guardar datos
        window.economicEventsByDate = {};
        return;
    }
    
    // Agrupar eventos por fecha (sin hora, solo YYYY-MM-DD)
    const eventsByDate = {};
    events.forEach(event => {
        const dateOnly = event.date.split('T')[0]; // Extraer solo YYYY-MM-DD
        if (!eventsByDate[dateOnly]) {
            eventsByDate[dateOnly] = [];
        }
        eventsByDate[dateOnly].push(event);
    });
    

    
    // Guardar para acceso global
    window.economicEventsByDate = eventsByDate;
    
    // Marcar cada fecha en el calendario
    const calendarDays = document.getElementById('calendarDays');
    if (!calendarDays) {

        return;
    }
    
    const dayCells = calendarDays.querySelectorAll('[data-date]');

    
    let cellsMarked = 0;
    
    dayCells.forEach(cell => {
        const cellDate = cell.getAttribute('data-date');
        if (eventsByDate[cellDate] && eventsByDate[cellDate].length > 0) {
            // Agregar clase para destacar la celda (solo borde sutil)
            cell.classList.add('has-economic-event');
            cellsMarked++;
        }
    });
    

    
    // Aplicar estilos CSS para las celdas con eventos
    addEconomicEventStyles();
}

// Exponer globalmente para que app.js pueda re-aplicar al cambiar de mes
window.markEconomicEventDates = markEconomicEventDates;

function addEconomicEventStyles() {
    // Verificar si ya existen los estilos
    if (document.getElementById('economic-events-styles')) {

        return;
    }
    
    const style = document.createElement('style');
    style.id = 'economic-events-styles';
    style.textContent = `
        .day-cell.has-economic-event {
            position: relative;
            overflow: hidden !important;
            z-index: 1;
        }
        
        .day-cell.has-economic-event::after {
            content: '';
            position: absolute;
            top: 6px;
            right: 6px;
            width: 8px;
            height: 8px;
            background: linear-gradient(135deg, #fbbf24, #f59e0b);
            border-radius: 50%;
            box-shadow: 0 0 8px rgba(251, 191, 36, 0.6), 0 0 3px rgba(251, 191, 36, 0.8);
            z-index: 10;
            pointer-events: none;
            animation: pulse-dot 2s ease-in-out infinite;
        }
        
        @keyframes pulse-dot {
            0%, 100% { opacity: 1; transform: scale(1); }
            50% { opacity: 0.7; transform: scale(1.1); }
        }
        
        .day-cell.has-economic-event:hover::after {
            box-shadow: 0 0 12px rgba(251, 191, 36, 0.8), 0 0 6px rgba(251, 191, 36, 1);
        }
    `;
    
    document.head.appendChild(style);

}

// Renderizar eventos económicos del día en el modal
function renderEconomicEventsForDay(dateKey) {
    const section = document.getElementById('economicEventsSection');
    const timeline = document.getElementById('economicEventsTimeline');
    
    if (!section || !timeline) return;
    
    // VERIFICAR PLAN - Solo UNLIMITED tiene acceso a eventos económicos
    const userPlan = (localStorage.getItem('userPlan') || 'free').toLowerCase();
    if (userPlan !== 'unlimited') {
        section.classList.add('hidden');
        return;
    }
    
    // Obtener eventos del día desde window.economicEventsByDate
    const allEvents = window.economicEventsByDate?.[dateKey] || [];
    
    if (allEvents.length === 0) {
        section.classList.add('hidden');
        return;
    }
    
    // Mostrar sección
    section.classList.remove('hidden');
    
    // Ordenar eventos por hora
    const sortedEvents = [...allEvents].sort((a, b) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
    });
    
    // Paginación: 2 eventos por página
    const eventsPerPage = 2;
    let currentPage = 1;
    const totalPages = Math.ceil(sortedEvents.length / eventsPerPage);
    
    function renderPage(page) {
        const start = (page - 1) * eventsPerPage;
        const end = start + eventsPerPage;
        const pageEvents = sortedEvents.slice(start, end);
        
        const eventsHTML = pageEvents.map((event, index) => {
            const eventDate = new Date(event.date);
            const hours = eventDate.getHours().toString().padStart(2, '0');
            const minutes = eventDate.getMinutes().toString().padStart(2, '0');
            const timeStr = `${hours}:${minutes}`;
            
            const impactColor = event.impact === 'high' ? 'red' : event.impact === 'medium' ? 'yellow' : 'green';
            const impactBg = event.impact === 'high' ? 'bg-red-500/10' : event.impact === 'medium' ? 'bg-yellow-500/10' : 'bg-green-500/10';
            const impactBorder = event.impact === 'high' ? 'border-red-500/30' : event.impact === 'medium' ? 'border-yellow-500/30' : 'border-green-500/30';
            const impactText = event.impact === 'high' ? 'text-red-400' : event.impact === 'medium' ? 'text-yellow-400' : 'text-green-400';
            const impactDot = event.impact === 'high' ? 'bg-red-500' : event.impact === 'medium' ? 'bg-yellow-500' : 'bg-green-500';
            const impactLabel = event.impact === 'high' ? 'High' : event.impact === 'medium' ? 'Medium' : 'Low';
            
            // Formatear valores: null, undefined, vacíos → "-"
            const formatValue = (val) => (val === null || val === undefined || val === '' || val === 'null') ? '-' : val;
            
            return `
                <div class="relative pl-6 pb-3 last:pb-0 group">
                    ${index < pageEvents.length - 1 ? `
                        <div class="absolute left-2 top-6 bottom-0 w-px bg-gradient-to-b from-${impactColor}-500/20 to-transparent"></div>
                    ` : ''}
                    
                    <div class="absolute left-0 top-1 w-4 h-4 rounded-full ${impactBg} border ${impactBorder} flex items-center justify-center">
                        <div class="w-1.5 h-1.5 rounded-full ${impactDot}"></div>
                    </div>
                    
                    <div class="${impactBg} backdrop-blur-sm rounded-lg border ${impactBorder} p-3 hover:bg-opacity-20 transition-all">
                        <div class="flex items-start justify-between gap-2 mb-1.5">
                            <h4 class="text-white font-medium text-sm leading-tight flex-1">${event.title || '-'}</h4>
                            <div class="flex items-center gap-1 text-yellow-400 font-semibold text-sm shrink-0">
                                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                </svg>
                                ${timeStr}
                            </div>
                        </div>
                        
                        <div class="flex items-center gap-2 flex-wrap">
                            <span class="px-1.5 py-0.5 rounded text-[10px] font-medium ${impactBg} ${impactText} border ${impactBorder}">
                                ${impactLabel} Impact
                            </span>
                            <span class="px-1.5 py-0.5 rounded text-[10px] font-medium bg-slate-700/30 text-slate-300 border border-slate-600/30">
                                ${formatValue(event.currency)}
                            </span>
                            ${event.country ? `
                                <span class="px-1.5 py-0.5 rounded text-[10px] font-medium bg-slate-700/30 text-slate-400 border border-slate-600/30">
                                    ${formatValue(event.country)}
                                </span>
                            ` : ''}
                        </div>
                        
                        ${event.forecast || event.previous ? `
                            <div class="mt-2 pt-2 border-t ${impactBorder} flex gap-3 text-[11px]">
                                ${event.forecast ? `
                                    <div>
                                        <span class="text-slate-500">Forecast:</span>
                                        <span class="text-slate-300 ml-1">${formatValue(event.forecast)}</span>
                                    </div>
                                ` : ''}
                                ${event.previous ? `
                                    <div>
                                        <span class="text-slate-500">Previous:</span>
                                        <span class="text-slate-300 ml-1">${formatValue(event.previous)}</span>
                                    </div>
                                ` : ''}
                            </div>
                        ` : ''}
                    </div>
                </div>
            `;
        }).join('');
        
        const paginationHTML = totalPages > 1 ? `
            <div class="flex items-center justify-between pt-3 mt-3 border-t border-slate-700/50">
                <button id="prevEventsPage" ${page === 1 ? 'disabled' : ''} class="px-3 py-1.5 text-xs font-medium rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                    ← Anterior
                </button>
                <span class="text-xs text-slate-400">
                    ${page} de ${totalPages} · ${sortedEvents.length} eventos
                </span>
                <button id="nextEventsPage" ${page === totalPages ? 'disabled' : ''} class="px-3 py-1.5 text-xs font-medium rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-300 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                    Siguiente →
                </button>
            </div>
        ` : '';
        
        timeline.innerHTML = eventsHTML + paginationHTML;
        
        // Event listeners para paginación
        if (totalPages > 1) {
            const prevBtn = document.getElementById('prevEventsPage');
            const nextBtn = document.getElementById('nextEventsPage');
            
            if (prevBtn) prevBtn.onclick = () => renderPage(page - 1);
            if (nextBtn) nextBtn.onclick = () => renderPage(page + 1);
        }
    }
    
    renderPage(currentPage);
}

// ========== ÚLTIMAS OPERACIONES - UPDATE REAL DATA ==========
function updateLatestTrades() {
    try {
        // Verificar si hay cuenta actual
        const currentAccount = window.currentAccount;
        
        if (!currentAccount) {
            showEmptyRecentTrades();
            return;
        }
        
        // Buscar el contenedor correcto por ID
        const container = document.getElementById('latestTradesContainer');
        
        if (!container) {
            setTimeout(() => updateLatestTrades(), 500);
            return;
        }
        
        // Intentar obtener trades del balance-state-manager primero
        let allTrades = [];
        
        if (window.balanceStateManager && window.balanceStateManager.tradesCache.has(currentAccount)) {
            allTrades = window.balanceStateManager.tradesCache.get(currentAccount) || [];
        } else {
            // Fallback: Obtener de journalData
            let journalData = window.journalData || {};
            
            // Si no hay datos en window.journalData, intentar cargar desde localStorage
            if (Object.keys(journalData).length === 0) {
                try {
                    journalData = JSON.parse(localStorage.getItem('journalData')) || {};
                } catch (e) {
                    // Ignore localStorage errors
                }
            }
            
            // Filtrar trades de la cuenta actual solamente
            Object.keys(journalData).forEach(dateKey => {
                const tradesForDate = journalData[dateKey] || [];
                if (Array.isArray(tradesForDate)) {
                    tradesForDate.forEach(trade => {
                        // Solo incluir trades de la cuenta actual
                        if (!window.currentAccount || trade.accountId === window.currentAccount) {
                            allTrades.push({
                                ...trade,
                                dateKey: dateKey
                            });
                        }
                    });
                }
            });
        }
        
        // Si no hay trades, mostrar mensaje vacío
        if (allTrades.length === 0) {
            container.innerHTML = `
                <div class="flex flex-col items-center justify-center py-8 text-center">
                    <div class="text-4xl lg:text-5xl mb-3 opacity-40">📊</div>
                    <p class="text-slate-500 text-sm lg:text-base mb-1">Sin trades registrados</p>
                    <p class="text-slate-600 text-xs">Añade tu primera operación</p>
                </div>
            `;
            return;
        }
        
        // Ordenar por timestamp descendente (últimos primero)
        allTrades.sort((a, b) => {
            const dateA = new Date(a.timestamp || a.created_at || 0).getTime();
            const dateB = new Date(b.timestamp || b.created_at || 0).getTime();
            return dateB - dateA;
        });
        
        // Obtener últimos 4 trades
        const recentTrades = allTrades.slice(0, 4);
        
        // Crear HTML para cada trade
        const tradesHTML = recentTrades.map((trade, index) => {
            const pair = trade.pair || trade.symbol || 'N/A';
            const direction = trade.direction || trade.action || 'LONG';
            
            // Calcular resultado
            let result = 0;
            let resultClass = 'text-gray-400';
            let resultSign = '';
            let currency = '%';
            
            // Priorizar profitUSD para mostrar en dólares
            if (trade.profitUSD !== undefined && trade.profitUSD !== null && trade.profitUSD !== '' && !isNaN(parseFloat(trade.profitUSD))) {
                result = parseFloat(trade.profitUSD);
                currency = '$';
            } else if (trade.pnl !== undefined && trade.pnl !== null && trade.pnl !== '' && !isNaN(parseFloat(trade.pnl))) {
                result = parseFloat(trade.pnl);
                currency = '%';
            } else if (trade.profit !== undefined && trade.profit !== null && trade.profit !== '' && !isNaN(parseFloat(trade.profit))) {
                result = parseFloat(trade.profit);
                currency = '%';
            } else if (trade.profitPercentage !== undefined && trade.profitPercentage !== null && trade.profitPercentage !== '' && !isNaN(parseFloat(trade.profitPercentage))) {
                result = parseFloat(trade.profitPercentage);
                currency = '%';
            } else if (trade.closePrice && trade.openPrice && !isNaN(parseFloat(trade.closePrice)) && !isNaN(parseFloat(trade.openPrice))) {
                const openPrice = parseFloat(trade.openPrice);
                const closePrice = parseFloat(trade.closePrice);
                const priceDiff = direction === 'LONG' ? 
                    closePrice - openPrice : 
                    openPrice - closePrice;
                const percentage = (priceDiff / openPrice) * 100;
                result = percentage;
                currency = '%';
            } else {
                // Si no hay datos de resultado, mostrar como neutral
                result = 0;
                currency = '';
            }
            
            if (result > 0) {
                resultClass = 'text-green-400';
                resultSign = '+';
            } else if (result < 0) {
                resultClass = 'text-red-400';
            }
            
            // Formatear tiempo
            let timeText = 'Reciente';
            const tradeTime = new Date(trade.timestamp || trade.created_at || trade.closeTime);
            if (!isNaN(tradeTime.getTime())) {
                const now = new Date();
                const diffMs = now - tradeTime;
                const diffMins = Math.floor(diffMs / 60000);
                const diffHours = Math.floor(diffMs / 3600000);
                const diffDays = Math.floor(diffMs / 86400000);
                
                if (diffMins < 60) {
                    timeText = `${diffMins}min ago`;
                } else if (diffHours < 24) {
                    timeText = `${diffHours}h ago`;
                } else {
                    timeText = `${diffDays}d ago`;
                }
            }
            
            const directionClass = direction === 'LONG' ? 'bg-green-600/20 text-green-400' : 'bg-red-600/20 text-red-400';
            
            return `
                <div class="bg-slate-900/50 p-2 lg:p-3 rounded-lg hover:bg-slate-900/70 transition-colors cursor-default" data-trade-index="${index}">
                    <div class="flex items-center justify-between mb-1">
                        <div class="flex items-center gap-2">
                            <span class="font-medium">${pair}</span>
                            <span class="text-[9px] lg:text-xs px-1.5 py-0.5 rounded ${directionClass} font-medium">${direction}</span>
                        </div>
                        <span class="font-medium ${resultClass}">${result === 0 && currency === '' ? '--' : `${resultSign}${Math.abs(result).toFixed(2)}${currency}`}</span>
                    </div>
                    <div class="text-[10px] lg:text-xs text-slate-500">${timeText}</div>
                </div>
            `;
        }).join('');
        
        // Actualizar el contenedor
        container.innerHTML = tradesHTML;
        
    } catch (error) {
        // En caso de error, mostrar estado por defecto
        const container = document.getElementById('latestTradesContainer');
        if (container) {
            container.innerHTML = `
                <div class="flex flex-col items-center justify-center py-8 text-center">
                    <div class="text-4xl lg:text-5xl mb-3 opacity-40">⚠️</div>
                    <p class="text-slate-500 text-sm lg:text-base mb-1">Error cargando trades</p>
                    <p class="text-slate-600 text-xs">Intenta recargar la página</p>
                </div>
            `;
        }
    }
}

// Hacer disponible globalmente
window.updateLatestTrades = updateLatestTrades;

// Modal para mostrar todos los trades con paginación
function openAllTradesModal(trades) {
    // Si no se proporciona trades, obtener todos los trades del journalData
    if (!trades || !Array.isArray(trades) || trades.length === 0) {
        try {
            const journalData = window.journalData || {};
            const allTrades = [];
            Object.keys(journalData).forEach(dateKey => {
                const tradesForDate = journalData[dateKey] || [];
                if (Array.isArray(tradesForDate)) {
                    tradesForDate.forEach(trade => {
                        allTrades.push({
                            ...trade,
                            dateKey: dateKey,
                            trade_date: trade.trade_date || dateKey  // Asegurar que tiene trade_date
                        });
                    });
                }
            });
            trades = allTrades;
        } catch (e) {
            return; // Error obteniendo trades
        }
    }
    
    const modal = document.createElement('div');
    modal.className = 'fixed inset-0 bg-black/80 z-[999] flex items-center justify-center p-4';
    modal.style.backdropFilter = 'blur(4px)';
    
    const getTradeOpenDate = (trade) => {
        const entry = trade.entryTime || trade.entry_time || '';
        const baseDate = trade.trade_date || trade.date || trade.dateKey || '';
        let dateStr = '';

        if (entry) {
            const looksLikeFull = /\d{4}[-./]\d{1,2}[-./]\d{1,2}/.test(entry) || entry.includes('T');
            if (looksLikeFull) {
                dateStr = entry;
            } else if (baseDate) {
                dateStr = `${baseDate} ${entry}`;
            } else {
                dateStr = entry;
            }
        } else {
            dateStr = baseDate;
        }

        dateStr = String(dateStr || '').trim();
        if (!dateStr) return null;
        dateStr = dateStr.replace(/\./g, '-');
        if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateStr)) {
            dateStr = `${dateStr} 00:00`;
        }
        const dateObj = new Date(dateStr.replace(' ', 'T'));
        return Number.isNaN(dateObj.getTime()) ? null : dateObj;
    };

    const getTradeOpenMs = (trade) => {
        const d = getTradeOpenDate(trade);
        return d ? d.getTime() : 0;
    };

    // Filtrar trades del mes actual
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    const monthTrades = trades.filter(t => {
        // Intentar obtener la fecha de varios campos posibles
        const dateStr = t.trade_date || t.date || t.dateKey || '';
        const d = new Date(dateStr + 'T00:00:00');
        return d.getMonth() === currentMonth && d.getFullYear() === currentYear;
    }).sort((a, b) => {
        // Ordenar por hora de APERTURA (entryTime) descendente
        return getTradeOpenMs(b) - getTradeOpenMs(a);
    });
    
    // Paginación: 5 trades por página
    const itemsPerPage = 5;
    const totalPages = Math.ceil(monthTrades.length / itemsPerPage);
    let currentPage = 1;
    
    const renderPage = (pageNum) => {
        const startIdx = (pageNum - 1) * itemsPerPage;
        const endIdx = startIdx + itemsPerPage;
        const pageItems = monthTrades.slice(startIdx, endIdx);
        
        return pageItems.map(trade => {
            const profit = parseFloat(trade.profitUSD) || 0;
            const isProfit = profit >= 0;
            const direction = (trade.direction || 'LONG').toUpperCase();
            const directionClass = direction === 'LONG' ? 'bg-green-600/20 text-green-400' : 'bg-red-600/20 text-red-400';
            const resultClass = isProfit ? 'text-green-400' : 'text-red-400';
            const resultText = isProfit ? `+${profit.toFixed(2)}$` : `-${Math.abs(profit).toFixed(2)}$`;
            const openDate = getTradeOpenDate(trade);
            const tradeDate = openDate
                ? openDate.toLocaleDateString('es-ES', { 
                weekday: 'short', 
                day: '2-digit', 
                month: 'short', 
                hour: '2-digit',
                minute: '2-digit'
                })
                : '—';
            
            return `
                <div class="bg-slate-800/50 p-2 lg:p-3 rounded-lg border border-slate-700/50 hover:border-blue-500/30 transition-colors">
                    <div class="flex items-center justify-between gap-2 flex-wrap">
                        <div class="flex items-center gap-2 min-w-0">
                            <span class="font-semibold text-sm lg:text-base truncate">${trade.pair || 'N/A'}</span>
                            <span class="text-[9px] lg:text-xs px-1.5 py-0.5 rounded ${directionClass} font-bold whitespace-nowrap">${direction}</span>
                        </div>
                        <span class="font-semibold ${resultClass} text-sm lg:text-base whitespace-nowrap">${resultText}</span>
                    </div>
                    <div class="text-[10px] lg:text-xs text-slate-400 mt-1">${tradeDate}</div>
                </div>
            `;
        }).join('');
    };
    
    const contentDiv = document.createElement('div');
    contentDiv.className = 'bg-slate-900 rounded-xl border border-slate-700 w-full max-w-2xl max-h-[85vh] shadow-2xl flex flex-col overflow-hidden';
    
    // Header
    const header = document.createElement('div');
    header.className = 'sticky top-0 rounded-t-xl bg-slate-900/95 backdrop-blur-xl border-b border-slate-700 px-4 lg:px-6 py-3 lg:py-4 flex items-center justify-between z-10 flex-wrap gap-3';
    header.innerHTML = `
        <h3 class="text-base lg:text-lg font-bold text-white">Todas las Operaciones</h3>
        <div class="flex items-center gap-2">
            <select id="sortTrades" class="px-3 py-1 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg text-white text-sm transition-colors">
                <option value="date-desc">Más recientes</option>
                <option value="date-asc">Más antiguas</option>
                <option value="profit-desc">Mayor ganancia</option>
                <option value="profit-asc">Mayor pérdida</option>
            </select>
        </div>
        <button id="closeTradesModal" class="text-slate-400 hover:text-white transition-colors p-1 ml-auto">
            <svg class="w-5 h-5 lg:w-6 lg:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
        </button>
    `;
    
    // Content area
    const content = document.createElement('div');
    content.className = 'flex-1 overflow-y-auto p-4 lg:p-6 space-y-2';
    
    // Footer con paginación
    const footer = document.createElement('div');
    footer.className = 'sticky bottom-0 rounded-b-xl bg-slate-900/95 backdrop-blur-xl border-t border-slate-700 px-4 lg:px-6 py-3 lg:py-4';
    
    // 🆕 Función para actualizar content y footer juntos
    const updateContentAndFooter = () => {
        if (monthTrades.length === 0) {
            content.innerHTML = '<p class="text-slate-400 text-center py-8">No hay operaciones en este mes</p>';
            footer.innerHTML = '';
        } else {
            content.innerHTML = renderPage(currentPage);
            
            if (monthTrades.length > itemsPerPage) {
                const newTotalPages = Math.ceil(monthTrades.length / itemsPerPage);
                footer.innerHTML = `
                    <div class="flex items-center justify-between gap-2 flex-wrap">
                        <button id="prevPage" class="px-3 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-white text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed">← Anterior</button>
                        <span id="pageInfo" class="text-slate-400 text-sm">Página <span id="currentPage">${currentPage}</span> de ${newTotalPages}</span>
                        <button id="nextPage" class="px-3 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-white text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed">Siguiente →</button>
                    </div>
                `;
                
                // Agregar event listeners a los botones de paginación
                const prevBtn = footer.querySelector('#prevPage');
                const nextBtn = footer.querySelector('#nextPage');
                
                if (prevBtn) prevBtn.disabled = currentPage === 1;
                if (nextBtn) nextBtn.disabled = currentPage === newTotalPages;
                
                if (prevBtn) {
                    prevBtn.onclick = () => {
                        if (currentPage > 1) {
                            currentPage--;
                            updateContentAndFooter();
                            content.scrollTop = 0;
                        }
                    };
                }
                if (nextBtn) {
                    nextBtn.onclick = () => {
                        if (currentPage < newTotalPages) {
                            currentPage++;
                            updateContentAndFooter();
                            content.scrollTop = 0;
                        }
                    };
                }
            } else {
                footer.innerHTML = `<p class="text-slate-400 text-center text-sm">Total: ${monthTrades.length} operaciones</p>`;
            }
        }
    };
    
    // Renderizar inicial
    updateContentAndFooter();
    
    contentDiv.appendChild(header);
    contentDiv.appendChild(content);
    contentDiv.appendChild(footer);
    modal.appendChild(contentDiv);
    document.body.appendChild(modal);
    
    // Event listeners
    const closeBtn = modal.querySelector('#closeTradesModal');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            modal.remove();
        });
    }
    
    const sortSelect = modal.querySelector('#sortTrades');
    
    // 🆕 Event listener para ordenamiento
    if (sortSelect) {
        sortSelect.addEventListener('change', (e) => {
            const sortBy = e.target.value;
            
            // 🆕 Ordenar monthTrades según la selección, usando campos correctos
            if (sortBy === 'date-desc') {
                monthTrades.sort((a, b) => getTradeOpenMs(b) - getTradeOpenMs(a));
            } else if (sortBy === 'date-asc') {
                monthTrades.sort((a, b) => getTradeOpenMs(a) - getTradeOpenMs(b));
            } else if (sortBy === 'profit-desc') {
                monthTrades.sort((a, b) => (parseFloat(b.profitUSD) || 0) - (parseFloat(a.profitUSD) || 0));
            } else if (sortBy === 'profit-asc') {
                monthTrades.sort((a, b) => (parseFloat(a.profitUSD) || 0) - (parseFloat(b.profitUSD) || 0));
            }
            
            // Resetear a página 1 y re-renderizar todo (content + footer)
            currentPage = 1;
            updateContentAndFooter();
            content.scrollTop = 0;
        });
    }
    
    // Click outside to close
    modal.addEventListener('click', (e) => {
        if (e.target === modal) modal.remove();
    });
}

// ================================
// MODAL DE BIENVENIDA MEJORADO
// ================================

// Función para mostrar estado vacío cuando no hay cuentas
function showEmptyUserState() {
    // 1. Vaciar el select de cuentas
    clearAccountSelect();
    
    // 2. Mostrar métricas en 0
    showEmptyMetrics();
    
    // 3. Mostrar mensaje en últimas operaciones
    showEmptyRecentTrades();
    
    // 4. Aplicar restricciones de plan
    applyPlanRestrictions();
}

// ?? APLICAR RESTRICCIONES SEGÚN PLAN
function applyPlanRestrictions() {
    const planFromStorage = localStorage.getItem('userPlan') || 'free';
    const userPlan = planFromStorage.toLowerCase().trim();
    






    
    // Ajustar grid de KPI cards según plan
    const kpiGrid = document.getElementById('kpiCardsGrid');
    if (kpiGrid) {
        // Remover clases anteriores
        kpiGrid.classList.remove('md:grid-cols-2', 'lg:grid-cols-4', 'md:grid-cols-3', 'lg:grid-cols-5');
        
        if (userPlan === 'free') {
            // FREE: 4 cards (Balance, Win Rate, Trades, Profit)
            // Mobile: 1, Tablet: 2, Desktop: 4
            kpiGrid.classList.add('md:grid-cols-2', 'lg:grid-cols-4');

        } else {
            // PRO/UNLIMITED: 5 cards (incluye Racha Actual)
            // Mobile: 1, Tablet: 3, Desktop: 5
            kpiGrid.classList.add('md:grid-cols-3', 'lg:grid-cols-5');

        }
    }
    
    // En plan FREE: ocultar TODOS los features premium
    if (userPlan === 'free') {
        // Ocultar contenedor completo de features PRO
        const proContainer = document.getElementById('proFeaturesContainer');
        if (proContainer) {
            proContainer.style.display = 'none';

        }
        
        // Ocultar Racha Actual
        const rachaCard = document.getElementById('rachaActualCard');
        if (rachaCard) {
            rachaCard.style.display = 'none';

        } else {

        }
        
        // OCULTAR SECCIONES DE DASHBOARD PREMIUM
        const dashboardSectionIds = [
            'equityCurveSection',      // Equity Curve
            'tradeDurationCard',       // Avg Trade Duration
            'emotionalControlSection', // Control Emocional
            'latestOperationsSection', // Últimas Operaciones
            'monthHighlightsSection',  // Destacados del Mes
            'shortsVsLongsSection'     // Shorts vs Longs
        ];
        
        dashboardSectionIds.forEach(id => {
            const section = document.getElementById(id);
            if (section) {
                section.style.display = 'none';

            }
        });
        
        // OCULTAR BOTONES DE EVENTOS PARA FREE
        const syncEventsBtn2 = document.getElementById('syncEventsBtn');
        if (syncEventsBtn2) {
            syncEventsBtn2.classList.add('hidden');
            syncEventsBtn2.style.display = 'none !important';
        }
        
        // EXPANDIR CALENDARIO PARA OCUPAR TODO EL GRID
        // El grid principal debería ocupar todo sin la columna derecha
        const mainGrid = document.getElementById('mainDashboardGrid');
        if (mainGrid) {
            // Cambiar de 4 columnas a 1 (full-width)
            mainGrid.classList.remove('lg:grid-cols-4');
            mainGrid.classList.add('lg:grid-cols-1');

        }
    } else {
        // En PRO/UNLIMITED: mostrar el contenedor
        const proContainer = document.getElementById('proFeaturesContainer');
        if (proContainer) {
            proContainer.style.display = 'flex';

        }
        
        // Mostrar/ocultar botones individuales según plan
        // Recap y Events: para PRO y UNLIMITED
        const generateRecapBtn = document.getElementById('generateRecapBtn');
        const syncEventsBtn = document.getElementById('syncEventsBtn');
        
        if (generateRecapBtn) {
            generateRecapBtn.style.display = 'flex';

        }
        if (syncEventsBtn) {
            syncEventsBtn.classList.remove('hidden');
            syncEventsBtn.style.display = 'inline-flex !important';

        }
        
        // Calculadora: para PRO y UNLIMITED
        const openCalculatorBtn = document.getElementById('openCalculatorBtn');
        if (openCalculatorBtn) {
            openCalculatorBtn.style.display = 'flex';

        }
        
        // eBook: solo para UNLIMITED
        const downloadEbookBtn = document.getElementById('downloadEbookBtn');
        if (downloadEbookBtn) {
            if (userPlan === 'unlimited') {
                downloadEbookBtn.style.display = 'flex';

            } else {
                downloadEbookBtn.style.display = 'none';

            }
        }
        
        // Mostrar Racha Actual
        const rachaCard = document.getElementById('rachaActualCard');
        if (rachaCard) {
            rachaCard.style.display = 'block';

        }
        
        // MOSTRAR SECCIONES DE DASHBOARD PARA PRO/UNLIMITED
        const dashboardSectionIds = [
            'equityCurveSection',      // Equity Curve
            'tradeDurationCard',       // Avg Trade Duration
            'emotionalControlSection', // Control Emocional
            'latestOperationsSection', // Últimas Operaciones
            'monthHighlightsSection',  // Destacados del Mes
            'shortsVsLongsSection'     // Shorts vs Longs
        ];
        
        dashboardSectionIds.forEach(id => {
            const section = document.getElementById(id);
            if (section) {
                section.style.display = 'block';

            } else {

            }
        });
        
        // RESTAURAR GRID PRINCIPAL A ORIGINAL PARA PRO/UNLIMITED
        const mainGrid = document.getElementById('mainDashboardGrid');
        if (mainGrid) {
            // Restaurar a 4 columnas original (3 izq + 1 derecha)
            mainGrid.classList.remove('lg:grid-cols-1');
            mainGrid.classList.add('lg:grid-cols-4');

        }
    }
    

}




// Función para limpiar el select de cuentas
function clearAccountSelect() {
    const select = document.getElementById('accountSelector');
    const accountsList = document.getElementById('accountsList');
    
    if (select) {
        select.innerHTML = '<option value="">Sin cuentas disponibles</option>';
        select.disabled = true;
    }
    
    if (accountsList) {
        accountsList.innerHTML = '<div class="text-center py-4 text-slate-400 text-sm">Sin cuentas disponibles</div>';
    }
    
    // Ocultar solo los botones de acciones cuando no hay cuentas (NO el contenedor completo)
    const accountActionsDivider = document.getElementById('accountActionsDivider');
    const btnAccountSettings = document.getElementById('btnAccountSettings');
    const btnImportTradesModal = document.getElementById('btnImportTradesModal');
    
    if (accountActionsDivider) accountActionsDivider.classList.add('hidden');
    if (btnAccountSettings) btnAccountSettings.classList.add('hidden');
    if (btnImportTradesModal) btnImportTradesModal.classList.add('hidden');
    
    // Actualizar el botón del dropdown también
    const selectedDisplay = document.querySelector('.selected-display');
    if (selectedDisplay) {
        selectedDisplay.textContent = 'Sin cuentas';
    }
}

// Función para poblar cuentas dinámicamente
function populateAccountsDropdown(accounts) {
    const accountsList = document.getElementById('accountsList');
    const currentAccountBtn = document.getElementById('accountSwitchBtn');
    
    if (!accountsList) return;
    
    // Si no hay cuentas, mostrar estado vacío
    if (!accounts || Object.keys(accounts).length === 0) {
        clearAccountSelect();
        return;
    }
    
    // Convertir a array y filtrar solo cuentas activas
    const allAccounts = Object.values(accounts);
    let activeAccounts = allAccounts.filter(acc => (acc.status === 'active' || !acc.status) && !isAccountArchivedFlag(acc));
    if (activeAccounts.length === 0 && allAccounts.length > 0) {
        activeAccounts = allAccounts;
    }
    
    // Mostrar botones de acciones cuando hay cuentas
    const accountActionsDivider = document.getElementById('accountActionsDivider');
    const btnAccountSettings = document.getElementById('btnAccountSettings');
    const btnImportTradesModal = document.getElementById('btnImportTradesModal');
    
    const userPlan = (localStorage.getItem('userPlan') || localStorage.getItem('tfx_plan') || 'free').toLowerCase();
    const hideSettings = userPlan === 'free';

    if (accountActionsDivider) accountActionsDivider.classList.remove('hidden');
    if (btnAccountSettings) {
        btnAccountSettings.classList.toggle('hidden', hideSettings);
        if (hideSettings) {
            btnAccountSettings.style.display = 'none';
        } else {
            btnAccountSettings.style.removeProperty('display');
        }
    }
    if (btnImportTradesModal) btnImportTradesModal.classList.remove('hidden');
    
    // Ordenar por is_primary primero
    const sortedAccounts = activeAccounts.sort((a, b) => {
        if (a.is_primary === 1 || a.is_primary === '1') return -1;
        if (b.is_primary === 1 || b.is_primary === '1') return 1;
        return (a.name || '').localeCompare(b.name || '');
    });
    
    // Generar HTML para las cuentas
    accountsList.innerHTML = sortedAccounts.map(account => {
        const isActive = window.currentAccount === account.id;
        const accountInitials = (account.name || 'C').substring(0, 2).toUpperCase();
        
        return `
            <button onclick="selectAccountWrapper('${account.id}')" class="w-full text-left px-3 py-3 rounded-lg text-slate-200 ${
                isActive 
                ? 'bg-blue-600/20 border border-blue-500/30 mb-2 hover:bg-blue-600/30' 
                : 'hover:bg-slate-800/50 mb-2'
            } transition-colors group">
                <div class="flex items-center gap-3">
                    <div class="w-8 h-8 rounded-lg bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center text-xs font-bold text-white">
                        ${accountInitials}
                    </div>
                    <div class="flex-1">
                        <div class="font-medium text-sm text-slate-200">${account.name || 'Sin nombre'}</div>
                        <div class="text-xs text-slate-400">$${(account.balance || 0).toLocaleString()}</div>
                    </div>
                    ${isActive ? `
                        <svg class="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                        </svg>
                    ` : ''}
                </div>
            </button>
        `;
    }).join('');
    
    // Actualizar el botón principal con la cuenta actual
    const currentAccount = sortedAccounts.find(acc => acc.id === window.currentAccount) || sortedAccounts[0];
    if (currentAccount && currentAccountBtn) {
        const accountName = document.querySelector('#accountSwitchBtn .font-semibold');
        const accountBalance = document.querySelector('#accountSwitchBtn .text-xs');
        if (accountName) accountName.textContent = currentAccount.name || 'Sin nombre';
        if (accountBalance) accountBalance.textContent = `$${(currentAccount.balance || 0).toLocaleString()}`;
    }
    
    // Aplicar restricciones de plan después de poblar cuentas
    applyPlanRestrictions();
}

function isAccountArchivedFlag(account) {
    if (!account) return true;
    const flag = account.is_archived;
    if (flag === true || flag === 'true' || flag === 1 || flag === '1') return true;
    if (flag === false || flag === 'false' || flag === 0 || flag === '0' || flag == null) return false;
    return Boolean(flag);
}

// Función para seleccionar una cuenta
// Función para seleccionar una cuenta
async function selectAccount(accountId) {
    window.currentAccount = accountId;
    // FIX: Guardar la cuenta seleccionada para persistir al hacer refresh
    localStorage.setItem('selectedAccountId', accountId);
    localStorage.setItem('selectedAccount', accountId);
    
    // FIX: Limpiar cache del plan cuando se cambia de cuenta
    if (window.planManagerV2 && typeof window.planManagerV2.clearPlanCache === 'function') {
        window.planManagerV2.clearPlanCache(accountId);
    }
    
    // Repoblar el dropdown para actualizar estados
    const accounts = window.accounts || {};
    populateAccountsDropdown(accounts);
    
    // Cerrar dropdown
    const dropdown = document.getElementById('accountDropdown');
    if (dropdown) {
        dropdown.classList.remove('opacity-100', 'visible');
        dropdown.classList.add('opacity-0', 'invisible');
    }
    
    // Actualizar métricas con la nueva cuenta
    if (typeof updateRealTimeMetrics === 'function') {
        updateRealTimeMetrics();
    }
    
    // FIX: Actualizar botón del plan con la nueva cuenta - ESPERAR A QUE SE COMPLETE
    if (window.updateFollowPlanButton) {
        await window.updateFollowPlanButton(accountId);
    }
    
    // Actualizar últimas operaciones
    setTimeout(() => {
        if (typeof updateLatestTrades === 'function') {
            updateLatestTrades();
        }
    }, 100); // Pequeño delay para que la cuenta se actualice
}

// Wrapper síncrono para onclick que dispara la función async
function selectAccountWrapper(accountId) {
    // Dispara la función async sin esperar (fire and forget)
    selectAccount(accountId).catch(err => {
        // Error silently handled
    });
}

// Función para mostrar métricas vacías
function showEmptyMetrics() {
    // Balance Total
    const balanceElement = document.querySelector('[data-metric="totalBalance"]');
    if (balanceElement) balanceElement.textContent = '$0.00';
    
    // P&L del Mes
    const pnlElement = document.querySelector('[data-metric="monthlyPnL"]');
    if (pnlElement) {
        pnlElement.textContent = '$0.00';
        pnlElement.className = 'text-lg lg:text-xl font-bold text-slate-400'; // Color neutro
    }
    
    // Total Operaciones
    const tradesElement = document.querySelector('[data-metric="totalTrades"]');
    if (tradesElement) tradesElement.textContent = '0';
    
    // Win Rate
    const winRateElement = document.querySelector('[data-metric="winRate"]');
    if (winRateElement) winRateElement.textContent = '0%';
    
    // Avg Trade Duration (si existe)
    const avgDurationElement = document.querySelector('[data-metric="avgDuration"]');
    if (avgDurationElement) avgDurationElement.textContent = '0h 0m';
}

// Función para mostrar mensaje vacío en últimas operaciones
function showEmptyRecentTrades() {
    const container = document.querySelector('[data-trade-index="0"]')?.parentElement;
    if (!container) return;
    
    container.innerHTML = `
        <div class="flex flex-col items-center justify-center py-8 text-center">
            <div class="text-4xl lg:text-5xl mb-3 opacity-40">📊</div>
            <p class="text-slate-500 text-sm lg:text-base mb-1">Sin trades registrados</p>
            <p class="text-slate-600 text-xs">Crea una cuenta para comenzar</p>
        </div>
    `;
}

// Función para mostrar el modal de bienvenida
function showWelcomeModal() {
    // Usar el nuevo modal basado en showConfirm con colores morados
    if (window.showConfirm) {
        window.showConfirm({
            title: '👋 ¡Bienvenido a TFX!',
            message: 'Tu trading journal profesional está listo. Crea tu primera cuenta en menos de 30 segundos para empezar a registrar y analizar tus trades.',
            confirmText: '✨ Crear Primera Cuenta',
            cancelText: 'Más Tarde',
            type: 'info'
        }).then(confirmed => {
            if (confirmed && window.showAddAccountModal) {
                window.showAddAccountModal();
            }
        });
    }
}

// Función para cerrar el modal de bienvenida - YA NO NECESARIA (usa showConfirm)
function closeWelcomeModal() {
    // DEPRECATED - El nuevo sistema usa showConfirm que maneja automáticamente los clics
}

// Función adaptada para abrir modal de cuenta desde bienvenida
function showFirstAccountModal() {
    // Llamar a la versión completa desde app.js
    if (window.showFirstAccountModal) {
        window.showFirstAccountModal();
    }
}

// Función para cerrar el modal de cuenta
function closeAccountModal() {
    const accountModal = document.getElementById('accountModal');
    if (accountModal) {
        accountModal.classList.add('hidden');
    }
}

// Inicializar modal de cuenta - DISABLED (form submission handled in app.js via event delegation)
// This duplicate function was causing conflicts with the main handler in app.js
function initAccountModal_DISABLED() {
    const accountForm = document.getElementById('accountForm');
    const accountModal = document.getElementById('accountModal');
    
    if (!accountForm) return;
    
    // DISABLED - The submit event is now handled exclusively by app.js
    /* accountForm.addEventListener('submit', async function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        
        const accountName = document.getElementById('accountName')?.value?.trim();
        const accountBalance = parseFloat(document.getElementById('accountBalance')?.value);
        
        if (!accountName || !accountBalance || accountBalance <= 0) {
            if (window.showAlert) {
                window.showAlert('Campos Incompletos', 'Por favor completa todos los campos correctamente', 'error');
            }
            return;
        }
        
        if (accountBalance > 1000000) {
            if (window.showAlert) {
                window.showAlert('Balance Invalido', 'El balance no puede exceder $1,000,000', 'error');
            }
            return;
        }
        
        try {
            // Usar la función de app.js para crear cuenta si está disponible
            if (window.tursoClient && window.currentUserId) {
                const accountId = `acc_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
                const userId = window.currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
                
                if (!userId) {
                    throw new Error('Usuario no identificado');
                }
                
                // Insertar en BD
                await window.tursoClient.execute({
                    sql: `INSERT INTO accounts (id, user_id, name, type, balance, initial_balance, status, is_primary, created_at) 
                          VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)`,
                    args: [
                        accountId,
                        userId,
                        accountName,
                        'live',
                        accountBalance,
                        accountBalance,
                        'active',
                        1, // Primera cuenta será principal
                        new Date().toISOString()
                    ]
                });
                
                // Recargar cuentas si la función existe
                if (typeof window.loadAccounts === 'function') {
                    await window.loadAccounts();
                }
                
                // Mostrar éxito
                if (window.showAlert) {
                    window.showAlert('Cuenta Creada', `✅ Cuenta "${accountName}" creada exitosamente`, 'success');
                }
                
                // Cerrar modal y limpiar form
                closeAccountModal();
                accountForm.reset();
                
                // Recargar página para aplicar cambios
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
                
            } else {
                // Fallback: guardar en localStorage
                const accounts = JSON.parse(localStorage.getItem('accounts') || '{}');
                const accountId = `acc_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
                
                accounts[accountId] = {
                    id: accountId,
                    name: accountName,
                    type: 'live',
                    balance: accountBalance,
                    initial_balance: accountBalance,
                    status: 'active',
                    is_primary: Object.keys(accounts).length === 0 ? 1 : 0,
                    created_at: new Date().toISOString()
                };
                
                localStorage.setItem('accounts', JSON.stringify(accounts));
                
                if (window.showAlert) {
                    window.showAlert('Cuenta Creada', `✅ Cuenta "${accountName}" creada exitosamente`, 'success');
                }
                
                closeAccountModal();
                accountForm.reset();
                
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        } catch (error) {

            if (window.showAlert) {
                window.showAlert('Error al Crear Cuenta', 'No se pudo crear la cuenta. Por favor intenta de nuevo.', 'error');
            }
        }
    });
    */ // End of disabled submit handler
    
    // Cerrar modal al hacer clic fuera
    if (accountModal) {
        accountModal.addEventListener('click', function(e) {
            if (e.target === accountModal) {
                closeAccountModal();
            }
        });
    }
}

// ========== TABS Y SINCRONIZACIÓN ==========

// Función para cambiar entre tabs
function switchAccountTab(tabName) {
    // Bloquear sincronización automática en móvil
    const isMobile = window.innerWidth <= 768;
    if (tabName === 'auto' && isMobile) {
        if (window.showAlert) {
            window.showAlert('Solo disponible en Desktop', 'La sincronización automática requiere instalar una aplicación en tu ordenador. Por favor, accede desde tu PC o portátil.', 'info');
        } else if (typeof showToast === 'function') {
            showToast('Sincronización solo disponible en Desktop', 'info');
        }
        return;
    }
    
    // Ocultar todos los paneles
    document.getElementById('manualPanel')?.classList.add('hidden');
    document.getElementById('autoPanel')?.classList.add('hidden');
    
    // Mostrar el panel seleccionado
    if (tabName === 'manual') {
        document.getElementById('manualPanel')?.classList.remove('hidden');
    } else if (tabName === 'auto') {
        document.getElementById('autoPanel')?.classList.remove('hidden');
    }
    
    // Actualizar estilos de los tabs
    const tabs = document.querySelectorAll('.tab-button');
    tabs.forEach(tab => {
        const isActive = tab.getAttribute('data-tab') === tabName;
        if (isActive) {
            tab.classList.add('active', 'text-white', 'border-b-2', 'border-blue-500', 'bg-blue-500/10');
            tab.classList.remove('text-slate-400');
        } else {
            tab.classList.remove('active', 'text-white', 'border-b-2', 'border-blue-500', 'bg-blue-500/10');
            tab.classList.add('text-slate-400');
        }
    });
}

// Función para manejar selección de plataforma
document.addEventListener('DOMContentLoaded', function() {
    const platformButtons = document.querySelectorAll('.platform-btn');
    platformButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            const platform = this.getAttribute('data-platform');
            
            // Ocultar paso 1, mostrar paso 2
            document.getElementById('syncStep1')?.classList.add('hidden');
            document.getElementById('syncStep2')?.classList.remove('hidden');
        });
    });
});

// Función para proceder a sincronización (solo si app.js no la definió)
if (!window.proceedToSync) {
    window.proceedToSync = function() {
        document.getElementById('syncStep2')?.classList.add('hidden');
        document.getElementById('syncStep3')?.classList.remove('hidden');

        if (typeof window.startPendingAccountsPolling === 'function') {
            window.startPendingAccountsPolling();
            return;
        }

        if (window.showAlert) {
            window.showAlert('Esperando Conexion', '🔄 Esperando conexión con MetaTrader...', 'info');
        }
    };
}

// Función para abrir modal de importación (solo si no existe en app.js)
if (!window.openImportFromAccountModal) {
    window.openImportFromAccountModal = function() {
        // Bloquear en móvil
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
            if (window.showAlert) {
                window.showAlert('Solo disponible en Desktop', 'La importación de trades requiere un ordenador. Por favor, accede desde tu PC o portátil para usar esta función.', 'info');
            } else if (typeof showToast === 'function') {
                showToast('Importación solo disponible en Desktop', 'info');
            }
            return;
        }
        
        if (typeof window.closeAccountModal === 'function') {
            window.closeAccountModal();
        }
        const importModal = document.getElementById('importModal');
        if (importModal) {
            importModal.classList.remove('hidden');
            importModal.style.display = 'flex';
            importModal.setAttribute('aria-hidden', 'false');
        } else if (window.showAlert) {
            window.showAlert('Proximamente', 'Función de importación próximamente disponible', 'info');
        }
    };
}

// Función para cerrar modal de importación (solo si no existe en app.js)
if (!window.closeImportModal) {
    window.closeImportModal = function() {
        const importModal = document.getElementById('importModal');
        if (importModal) {
            importModal.classList.add('hidden');
            importModal.style.display = 'none';
            importModal.setAttribute('aria-hidden', 'true');
        }
        
        // Limpiar formulario
        const importForm = document.getElementById('importForm');
        if (importForm) {
            importForm.reset();
        }
        
        // Ocultar preview
        const importPreview = document.getElementById('importPreview');
        if (importPreview) {
            importPreview.classList.add('hidden');
        }
    };
}

// Mostrar modal de bienvenida al cargar si no hay cuentas
window.addEventListener('DOMContentLoaded', async function() {
    // IMPORTANTE: Usar window.accounts de app.js en lugar de hacer fallback a localStorage
    // Esto asegura que vemos los datos correctos del usuario actual
    let accounts = window.accounts || {};
    
    // Si window.accounts aún no está disponible, esperar a que app.js lo cargue
    if (!window.accounts) {
        // Esperar hasta 10 segundos a que app.js cargue los datos
        let waited = 0;
        while (waited < 10000 && !window.accounts) {
            await new Promise(r => setTimeout(r, 200));
            waited += 200;
        }
        accounts = window.accounts || {};
    }
    
    // Solo mostrar modal de bienvenida si NO hay ninguna cuenta
    // Verificar tanto en accounts cargadas como hacer una verificación extra
    // IMPORTANTE: Usar currentUserId de app.js, no userId de localStorage
    const userId = window.currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
    
    if (Object.keys(accounts).length === 0) {
        // Intentar recuperar cuentas directamente desde BD si están disponibles
        const turso = window.tursoClient;
        if (turso && userId) {
            try {
                const result = await turso.execute({
                    sql: 'SELECT * FROM accounts WHERE user_id = ? AND (is_archived = 0 OR is_archived IS NULL) ORDER BY created_at',
                    args: [userId]
                });
                const freshAccounts = {};
                for (const row of (result?.rows || [])) {
                    freshAccounts[row.id] = {
                        id: row.id,
                        name: row.name,
                        balance: row.balance,
                        initial_balance: row.initial_balance || row.balance,
                        status: row.status || 'active',
                        is_primary: row.is_primary || 0,
                        data: {}
                    };
                }
                if (Object.keys(freshAccounts).length > 0) {
                    accounts = freshAccounts;
                    window.accounts = freshAccounts;
                    populateAccountsDropdown(accounts);
                    applyPlanRestrictions();
                    return;
                }
            } catch (e) {
                // Ignorar y continuar a estado vacío
            }
        }

        // Mostrar estado vacío inmediatamente
        showEmptyUserState();
        
        // NO mostrar el modal de bienvenida automáticamente en el load
        // Solo se mostrará cuando el usuario intente una acción (agregar trade, nota, etc.)
        // setTimeout(() => {
        //     showWelcomeModal();
        // }, 800);
    } else {
        // Hay cuentas, poblar el dropdown
        populateAccountsDropdown(accounts);
    }
    
    // Asegurar que las restricciones de plan se apliquen
    applyPlanRestrictions();
    
    // Actualizar visibilidad de Trade Control (en calendar-demo.html)
    if (window.updateTradeControlVisibility) {
        window.updateTradeControlVisibility();
    }
});

// Event listeners para cerrar modal con ESC
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
        closeWelcomeModal();
    }
});

// 🆕 Escuchar cambios en localStorage para aplicar restricciones de plan
window.addEventListener('storage', function(e) {
    if (e.key === 'userPlan' || e.key === 'userType') {

        applyPlanRestrictions();
    }
});

// 🆕 También aplicar restricciones cuando el usuario inicia sesión (desde app.js)
// Hacer la función accesible globalmente
window.applyPlanRestrictionsFromAppJs = function() {

    applyPlanRestrictions();
};

// Aplicar restricciones con pequeno delay para garantizar DOM listo
setTimeout(() => {

    applyPlanRestrictions();
}, 100);


// ========== BÚSQUEDA DE TRADES Y NOTAS (DROPDOWN INLINE) ==========
(function() {
    let searchTimer = null;
    let currentFilter = 'all';
    let cachedResults = [];

    function normalizeSearchQuery(raw, maxLen = 80) {
        const base = window.sanitizeString
            ? window.sanitizeString(raw, maxLen)
            : String(raw || '').replace(/<[^>]*>/g, '').slice(0, maxLen);
        return base.replace(/\s+/g, ' ').trim();
    }

    function isUnsafeSearchQuery(query) {
        if (!query) return false;
        const sqlPattern = /(--|;|\/\*|\*\/|@@|\b(select|insert|update|delete|drop|union|where|from|truncate|alter|create|grant|revoke|exec|execute|declare|cast|char|nchar|sleep|benchmark|load_file|outfile)\b)/i;
        return sqlPattern.test(query) || /['"`\\]/.test(query);
    }

    function blockUnsafeSearch(options) {
        const input = options.input;
        const dropdown = options.dropdown;
        const results = options.results;
        const countEl = options.countEl;
        const isMobile = options.isMobile;

        if (input) input.value = '';
        if (dropdown) dropdown.classList.add('hidden');
        if (countEl) countEl.textContent = '0 resultados';
        if (results) {
            results.innerHTML = isMobile
                ? '<div class="p-6 text-center"><p class="text-slate-500 text-sm">Búsqueda bloqueada por seguridad</p></div>'
                : '<div class="p-4 text-center text-slate-500 text-sm">Búsqueda bloqueada por seguridad</div>';
        }
        if (typeof showAlert === 'function') {
            showAlert('Búsqueda bloqueada', 'Por seguridad no se permiten caracteres o patrones sospechosos.', 'warning');
        }
    }
    
    function init() {
        const input = document.getElementById('tradeNotesSearch');
        const dropdown = document.getElementById('searchDropdown');
        const container = document.getElementById('searchContainer');
        
        if (!input || !dropdown) {
            return;
        }
        
        // Input event con debounce
        input.addEventListener('input', function() {
            const query = normalizeSearchQuery(this.value, 80);
            if (query !== this.value) this.value = query;
            
            // Limpiar timer anterior
            clearTimeout(searchTimer);

            if (isUnsafeSearchQuery(query)) {
                blockUnsafeSearch({
                    input: this,
                    dropdown: dropdown,
                    results: document.getElementById('searchResults'),
                    countEl: document.getElementById('searchResultCount'),
                    isMobile: false
                });
                return;
            }
            
            // Si menos de 2 caracteres, cerrar dropdown
            if (query.length < 2) {
                dropdown.classList.add('hidden');
                return;
            }
            
            // Debounce de 250ms
            searchTimer = setTimeout(function() {
                cachedResults = search(query);
                render(cachedResults);
                dropdown.classList.remove('hidden');
            }, 250);
        });
        
        // Focus en input abre dropdown si hay query
        input.addEventListener('focus', function() {
            if (this.value.trim().length >= 2 && cachedResults.length > 0) {
                dropdown.classList.remove('hidden');
            }
        });
        
        // Click fuera cierra dropdown
        document.addEventListener('click', function(e) {
            if (!container.contains(e.target)) {
                dropdown.classList.add('hidden');
            }
        });
        
        // ESC cierra dropdown
        input.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                dropdown.classList.add('hidden');
                this.blur();
            }
        });
        
        // Filtros
        dropdown.querySelectorAll('.search-filter-btn').forEach(function(btn) {
            btn.addEventListener('click', function() {
                // Actualizar estilo botones
                dropdown.querySelectorAll('.search-filter-btn').forEach(function(b) {
                    b.className = 'search-filter-btn px-3 py-1.5 rounded-lg text-xs font-medium text-slate-400 hover:bg-slate-700/50';
                });
                this.className = 'search-filter-btn px-3 py-1.5 rounded-lg text-xs font-medium bg-cyan-500/20 text-cyan-300 border border-cyan-500/30';
                
                // Aplicar filtro
                currentFilter = this.dataset.filter;
                render(cachedResults);
            });
        });
    }
    
    function search(query) {
        const cleanQuery = normalizeSearchQuery(query, 80);
        if (!cleanQuery || isUnsafeSearchQuery(cleanQuery)) return [];
        const q = cleanQuery.toLowerCase();
        const results = [];
        const currentAccount = window.currentAccount; // Cuenta seleccionada
        
        // Buscar en trades (solo de la cuenta actual)
        if (window.journalData) {
            Object.entries(window.journalData).forEach(function(entry) {
                const dateKey = entry[0];
                const trades = entry[1];
                
                if (!Array.isArray(trades)) return;
                
                trades.forEach(function(trade) {
                    // Filtrar por cuenta actual
                    if (currentAccount && trade.accountId && trade.accountId !== currentAccount) {
                        return; // Skip trades de otras cuentas
                    }
                    
                    const text = (trade.pair || trade.symbol || '') + ' ' + (trade.direction || '') + ' ' + dateKey;
                    
                    if (text.toLowerCase().includes(q)) {
                        results.push({
                            type: 'trade',
                            date: dateKey,
                            pair: trade.pair || trade.symbol || 'N/A',
                            direction: trade.direction || '',
                            profit: parseFloat(trade.profitUSD || 0)
                        });
                    }
                });
            });
        }
        
        // Buscar en notas
        if (window.__dailyNotesMap) {
            Object.entries(window.__dailyNotesMap).forEach(function(entry) {
                const dateKey = entry[0];
                const note = entry[1];
                
                if (!note || !note.note) return;
                
                const text = (note.note || '') + ' ' + (note.sentiment || '') + ' ' + dateKey;
                
                if (text.toLowerCase().includes(q)) {
                    results.push({
                        type: 'note',
                        date: dateKey,
                        preview: (note.note || '').substring(0, 60),
                        sentiment: note.sentiment || ''
                    });
                }
            });
        }
        
        // Ordenar por fecha (más reciente primero)
        results.sort(function(a, b) {
            return new Date(b.date) - new Date(a.date);
        });
        
        return results;
    }
    
    function render(results) {
        const container = document.getElementById('searchResults');
        const countEl = document.getElementById('searchResultCount');
        
        // Filtrar
        let filtered = results;
        if (currentFilter !== 'all') {
            filtered = results.filter(function(r) {
                return r.type === currentFilter;
            });
        }
        
        // Contador
        countEl.textContent = filtered.length + ' resultado' + (filtered.length !== 1 ? 's' : '');
        
        // Sin resultados
        if (filtered.length === 0) {
            container.innerHTML = '<div class="p-4 text-center text-slate-500 text-sm">Sin resultados</div>';
            return;
        }
        
        // Renderizar
        var html = '';
        filtered.slice(0, 10).forEach(function(item, idx) {
            if (item.type === 'trade') {
                var profitClass = item.profit >= 0 ? 'text-green-400' : 'text-red-400';
                var profitSign = item.profit >= 0 ? '+' : '';
                var dirClass = item.direction === 'LONG' ? 'text-green-400' : 'text-red-400';
                
                html += '<div class="search-result-item flex items-center gap-3 px-3 py-2.5 hover:bg-slate-800/60 cursor-pointer transition-colors" data-date="' + item.date + '" data-type="trade">';
                html += '<span class="text-lg">🔷</span>';
                html += '<div class="flex-1 min-w-0">';
                html += '<div class="flex items-center gap-2">';
                html += '<span class="font-semibold text-white text-sm">' + item.pair + '</span>';
                html += '<span class="text-xs ' + dirClass + '">' + item.direction + '</span>';
                html += '</div>';
                html += '<span class="text-xs text-slate-500">' + item.date + '</span>';
                html += '</div>';
                html += '<span class="text-sm font-medium ' + profitClass + '">' + profitSign + item.profit.toFixed(2) + '</span>';
                html += '</div>';
            } else {
                html += '<div class="search-result-item flex items-center gap-3 px-3 py-2.5 hover:bg-slate-800/60 cursor-pointer transition-colors" data-date="' + item.date + '" data-type="note">';
                html += '<span class="text-lg">📝</span>';
                html += '<div class="flex-1 min-w-0">';
                html += '<p class="text-sm text-white truncate">' + item.preview + '</p>';
                html += '<span class="text-xs text-slate-500">' + item.date + '</span>';
                html += '</div>';
                html += '</div>';
            }
        });
        
        container.innerHTML = html;
        
        // Click en resultados
        container.querySelectorAll('.search-result-item').forEach(function(el) {
            el.addEventListener('click', function() {
                var dateKey = this.dataset.date;
                var type = this.dataset.type;
                
                // Cerrar dropdown y limpiar
                document.getElementById('searchDropdown').classList.add('hidden');
                document.getElementById('tradeNotesSearch').value = '';
                
                // Abrir modal del día
                if (typeof openDayModalForDate === 'function') {
                    openDayModalForDate(dateKey);
                    
                    // Si es nota, scroll a sección notas
                    if (type === 'note') {
                        setTimeout(function() {
                            var modal = document.querySelector('#dayModal .overflow-y-auto');
                            if (modal) modal.scrollTop = modal.scrollHeight;
                        }, 200);
                    }
                }
            });
        });
    }
    
    // ========== MOBILE SEARCH ==========
    function initMobile() {
        var mobileBtn = document.getElementById('mobileSearchBtn');
        var mobileModal = document.getElementById('mobileSearchModal');
        var mobileClose = document.getElementById('mobileSearchClose');
        var mobileInput = document.getElementById('mobileSearchInput');
        var mobileResults = document.getElementById('mobileSearchResults');
        var mobileCount = document.getElementById('mobileSearchCount');
        var mobileFilters = document.querySelectorAll('.mobile-search-filter');
        var mobileTimer = null;
        var mobileFilter = 'all';
        
        if (!mobileBtn || !mobileModal) return;
        
        // Abrir modal
        mobileBtn.addEventListener('click', function() {
            mobileModal.classList.remove('hidden');
            mobileModal.classList.add('flex');
            document.body.style.overflow = 'hidden';
            setTimeout(function() {
                mobileInput.focus();
            }, 100);
        });
        
        // Cerrar modal
        function closeMobile() {
            mobileModal.classList.add('hidden');
            mobileModal.classList.remove('flex');
            document.body.style.overflow = '';
            mobileInput.value = '';
        }
        
        mobileClose.addEventListener('click', closeMobile);
        
        // Filtros móvil
        mobileFilters.forEach(function(btn) {
            btn.addEventListener('click', function() {
                mobileFilter = this.dataset.filter;
                mobileFilters.forEach(function(b) {
                    b.classList.remove('bg-cyan-500/20', 'text-cyan-300', 'border-cyan-500/30');
                    b.classList.add('text-slate-400', 'bg-slate-800/50', 'border-slate-700');
                });
                this.classList.remove('text-slate-400', 'bg-slate-800/50', 'border-slate-700');
                this.classList.add('bg-cyan-500/20', 'text-cyan-300', 'border-cyan-500/30');
                
                // Re-renderizar si hay resultados
                if (cachedResults.length > 0) {
                    renderMobile(cachedResults);
                }
            });
        });
        
        // Búsqueda móvil
        mobileInput.addEventListener('input', function() {
            var query = normalizeSearchQuery(this.value, 80);
            if (query !== this.value) this.value = query;
            clearTimeout(mobileTimer);

            if (isUnsafeSearchQuery(query)) {
                blockUnsafeSearch({
                    input: this,
                    dropdown: null,
                    results: mobileResults,
                    countEl: mobileCount,
                    isMobile: true
                });
                return;
            }
            
            if (query.length < 2) {
                mobileResults.innerHTML = '<div class="p-6 text-center"><svg class="w-12 h-12 mx-auto mb-3 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg><p class="text-slate-500">Busca trades por símbolo, dirección o P&L</p><p class="text-slate-600 text-sm mt-1">También puedes buscar en tus notas</p></div>';
                mobileCount.textContent = '0 resultados';
                return;
            }
            
            mobileTimer = setTimeout(function() {
                cachedResults = search(query);
                renderMobile(cachedResults);
            }, 250);
        });
        
        function renderMobile(results) {
            var filtered = results;
            if (mobileFilter !== 'all') {
                filtered = results.filter(function(r) { return r.type === mobileFilter; });
            }
            
            mobileCount.textContent = filtered.length + ' resultado' + (filtered.length !== 1 ? 's' : '');
            
            if (filtered.length === 0) {
                mobileResults.innerHTML = '<div class="p-6 text-center"><svg class="w-12 h-12 mx-auto mb-3 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg><p class="text-slate-500">No se encontraron resultados</p></div>';
                return;
            }
            
            var html = '';
            filtered.slice(0, 20).forEach(function(item) {
                if (item.type === 'trade') {
                    var profitClass = item.profit >= 0 ? 'text-green-400' : 'text-red-400';
                    var profitSign = item.profit >= 0 ? '+' : '';
                    var dirClass = item.direction === 'LONG' ? 'text-green-400' : 'text-red-400';
                    
                    html += '<div class="mobile-result-item flex items-center gap-4 px-4 py-3 border-b border-slate-800/50 active:bg-slate-800/60" data-date="' + item.date + '" data-type="trade">';
                    html += '<div class="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center"><span class="text-xl">📊</span></div>';
                    html += '<div class="flex-1 min-w-0">';
                    html += '<div class="flex items-center gap-2">';
                    html += '<span class="font-semibold text-white">' + item.pair + '</span>';
                    html += '<span class="text-xs px-2 py-0.5 rounded-full ' + (item.direction === 'LONG' ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400') + '">' + item.direction + '</span>';
                    html += '</div>';
                    html += '<span class="text-xs text-slate-500">' + item.date + '</span>';
                    html += '</div>';
                    html += '<span class="text-base font-semibold ' + profitClass + '">' + profitSign + item.profit.toFixed(2) + '</span>';
                    html += '</div>';
                } else {
                    html += '<div class="mobile-result-item flex items-center gap-4 px-4 py-3 border-b border-slate-800/50 active:bg-slate-800/60" data-date="' + item.date + '" data-type="note">';
                    html += '<div class="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center"><span class="text-xl">📝</span></div>';
                    html += '<div class="flex-1 min-w-0">';
                    html += '<p class="text-sm text-white line-clamp-1">' + item.preview + '</p>';
                    html += '<span class="text-xs text-slate-500">' + item.date + '</span>';
                    html += '</div>';
                    html += '</div>';
                }
            });
            
            mobileResults.innerHTML = html;
            
            // Click en resultados móvil
            mobileResults.querySelectorAll('.mobile-result-item').forEach(function(el) {
                el.addEventListener('click', function() {
                    var dateKey = this.dataset.date;
                    var type = this.dataset.type;
                    
                    closeMobile();
                    
                    if (typeof openDayModalForDate === 'function') {
                        openDayModalForDate(dateKey);
                        
                        if (type === 'note') {
                            setTimeout(function() {
                                var modal = document.querySelector('#dayModal .overflow-y-auto');
                                if (modal) modal.scrollTop = modal.scrollHeight;
                            }, 200);
                        }
                    }
                });
            });
        }
    }
    
    // Inicializar cuando DOM esté listo
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            init();
            initMobile();
        });
    } else {
        init();
        initMobile();
    }
})();

// ============================================
// 📝 ENTRY MODELS SYSTEM
// ============================================

// Límites de modelos por plan
const MODEL_LIMITS = {
    'free': 1,
    'pro': 5,
    'unlimited': Infinity
};

// Crear tabla si no existe
async function ensureEntryModelsTable() {
    if (!window.tursoClient) return;
    try {
        await window.tursoClient.execute({
            sql: `CREATE TABLE IF NOT EXISTS entry_models (
                id TEXT PRIMARY KEY,
                name TEXT NOT NULL,
                conditions TEXT NOT NULL,
                user_id TEXT NOT NULL,
                created_at TEXT NOT NULL,
                updated_at TEXT NOT NULL
            )`
        });
        
        await window.tursoClient.execute({
            sql: `CREATE INDEX IF NOT EXISTS idx_entry_models_user 
                ON entry_models(user_id)`
        });
        
        // 🔧 Asegurar que la tabla trades tenga las columnas de modelos
        try {
            await window.tursoClient.execute({
                sql: `ALTER TABLE trades ADD COLUMN entry_model_id TEXT`
            });
        } catch (e) {
            // Columna ya existe o error, ignorar
        }
        
        try {
            await window.tursoClient.execute({
                sql: `ALTER TABLE trades ADD COLUMN entry_model_snapshot TEXT`
            });
        } catch (e) {
            // Columna ya existe o error, ignorar
        }
        
        try {
            await window.tursoClient.execute({
                sql: `CREATE INDEX IF NOT EXISTS idx_trades_model 
                    ON trades(entry_model_id)`
            });
        } catch (e) {
            // Índice ya existe o error, ignorar
        }
    } catch (err) {
        // Table creation error silently handled
    }
}

// Crear modelo
async function createEntryModel(userId, name, conditions) {
    if (!userId) throw new Error('User ID requerido');
    if (!name || name.trim().length < 3) throw new Error('Nombre debe tener al menos 3 caracteres');
    if (!conditions || conditions.length === 0) throw new Error('Debe haber al menos 1 condición');
    
    // Validar límite del plan
    const userPlan = window.userPlan || 'free';
    const existingModels = await getEntryModels(userId);
    const limit = MODEL_LIMITS[userPlan] || 1;
    
    if (existingModels.length >= limit) {
        throw new Error(`Límite alcanzado. Plan ${userPlan.toUpperCase()} permite ${limit} modelo(s)`);
    }
    
    // Validar nombre único
    if (existingModels.some(m => m.name.toLowerCase() === name.toLowerCase())) {
        throw new Error('Ya existe un modelo con ese nombre');
    }
    
    const id = window.generateIdFallback();
    const now = new Date().toISOString();
    const conditionsJson = JSON.stringify(conditions);
    
    if (window.tursoClient) {
        await ensureEntryModelsTable();
        await window.tursoClient.execute({
            sql: `INSERT INTO entry_models (id, name, conditions, user_id, created_at, updated_at) 
                  VALUES (?, ?, ?, ?, ?, ?)`,
            args: [id, name, conditionsJson, userId, now, now]
        });
    }
    
    // Guardar en localStorage como backup (ahora por userId)
    const localModels = JSON.parse(localStorage.getItem('entryModels') || '{}');
    if (!localModels[userId]) localModels[userId] = [];
    localModels[userId].push({ id, name, conditions, created_at: now, updated_at: now });
    localStorage.setItem('entryModels', JSON.stringify(localModels));
    
    return { id, name, conditions, created_at: now, updated_at: now };
}

// Obtener modelos del usuario
async function getEntryModels(userId) {
    if (!userId) return [];
    
    let models = [];
    
    if (window.tursoClient) {
        try {
            await ensureEntryModelsTable();
            const result = await window.tursoClient.execute({
                sql: 'SELECT * FROM entry_models WHERE user_id = ? ORDER BY created_at DESC',
                args: [userId]
            });
            
            models = (result.rows || []).map(row => ({
                id: row.id,
                name: row.name,
                conditions: JSON.parse(row.conditions || '[]'),
                created_at: row.created_at,
                updated_at: row.updated_at
            }));
        } catch (err) {
            // Error loading models silently handled
        }
    }
    
    // Fallback a localStorage
    if (models.length === 0) {
        const localModels = JSON.parse(localStorage.getItem('entryModels') || '{}');
        models = localModels[userId] || [];
    }
    
    return models;
}

// Actualizar modelo
async function updateEntryModel(modelId, userId, updates) {
    if (!modelId || !userId) throw new Error('ID y user requeridos');
    
    const { name, conditions } = updates;
    
    if (name && name.trim().length < 3) {
        throw new Error('Nombre debe tener al menos 3 caracteres');
    }
    
    if (conditions && conditions.length === 0) {
        throw new Error('Debe haber al menos 1 condición');
    }
    
    // Validar nombre único (excluyendo el modelo actual)
    if (name) {
        const existingModels = await getEntryModels(userId);
        if (existingModels.some(m => m.id !== modelId && m.name.toLowerCase() === name.toLowerCase())) {
            throw new Error('Ya existe un modelo con ese nombre');
        }
    }
    
    const now = new Date().toISOString();
    const conditionsJson = conditions ? JSON.stringify(conditions) : undefined;
    
    if (window.tursoClient) {
        await ensureEntryModelsTable();
        
        const updateFields = [];
        const args = [];
        
        if (name) {
            updateFields.push('name = ?');
            args.push(name);
        }
        if (conditionsJson) {
            updateFields.push('conditions = ?');
            args.push(conditionsJson);
        }
        updateFields.push('updated_at = ?');
        args.push(now);
        args.push(modelId);
        
        await window.tursoClient.execute({
            sql: `UPDATE entry_models SET ${updateFields.join(', ')} 
                  WHERE id = ?`,
            args
        });
    }
    
    // Actualizar localStorage
    const localModels = JSON.parse(localStorage.getItem('entryModels') || '{}');
    if (localModels[userId]) {
        const index = localModels[userId].findIndex(m => m.id === modelId);
        if (index !== -1) {
            if (name) localModels[userId][index].name = name;
            if (conditions) localModels[userId][index].conditions = conditions;
            localModels[userId][index].updated_at = now;
            localStorage.setItem('entryModels', JSON.stringify(localModels));
        }
    }
}

// Borrar modelo
async function deleteEntryModel(modelId, userId) {
    if (!modelId || !userId) throw new Error('ID y user requeridos');
    
    if (window.tursoClient) {
        await ensureEntryModelsTable();
        await window.tursoClient.execute({
            sql: 'DELETE FROM entry_models WHERE id = ?',
            args: [modelId]
        });
    }
    
    // Borrar de localStorage
    const localModels = JSON.parse(localStorage.getItem('entryModels') || '{}');
    if (localModels[userId]) {
        localModels[userId] = localModels[userId].filter(m => m.id !== modelId);
        localStorage.setItem('entryModels', JSON.stringify(localModels));
    }
}

// Obtener stats de un modelo (AGREGADO DE TODAS LAS CUENTAS DEL USUARIO)
async function getModelStats(modelId, userId, accountId = null) {
    if (!modelId || !userId) return null;
    
    let trades = [];
    
    if (window.tursoClient) {
        try {
            // 🔥 Si accountId especificado, buscar solo en esa cuenta; sino, en TODAS las cuentas del usuario
            let sql, args;
            if (accountId) {
                sql = 'SELECT profit_usd FROM trades WHERE user_id = ? AND entry_model_id = ? AND account_id = ?';
                args = [userId, modelId, accountId];
            } else {
                sql = 'SELECT profit_usd FROM trades WHERE user_id = ? AND entry_model_id = ?';
                args = [userId, modelId];
            }
            const result = await window.tursoClient.execute({ sql, args });
            trades = result.rows || [];
        } catch (err) {
            // Error loading stats silently handled
        }
    }
    
    // Fallback: buscar en journalData
    if (trades.length === 0 && window.journalData) {
        Object.values(window.journalData).forEach(dayTrades => {
            (dayTrades || []).forEach(trade => {
                if (trade.entry_model_id === modelId) {
                    // Si accountId especificado, filtrar por esa cuenta
                    if (!accountId || trade.account_id === accountId || trade.accountId === accountId) {
                        trades.push({ profit_usd: trade.profitUSD });
                    }
                }
            });
        });
    }
    
    if (trades.length === 0) {
        return { total: 0, wins: 0, losses: 0, winRate: 0 };
    }
    
    const wins = trades.filter(t => (Number(t.profit_usd) || 0) > 0).length;
    const losses = trades.filter(t => (Number(t.profit_usd) || 0) < 0).length;
    const winRate = trades.length > 0 ? Math.round((wins / trades.length) * 100) : 0;
    
    return {
        total: trades.length,
        wins,
        losses,
        winRate
    };
}

// Exponer funciones globalmente
window.createEntryModel = createEntryModel;
window.getEntryModels = getEntryModels;
window.updateEntryModel = updateEntryModel;
window.deleteEntryModel = deleteEntryModel;
window.getModelStats = getModelStats;
window.MODEL_LIMITS = MODEL_LIMITS;

// 🆕 EXPOSE FUNCTIONS TO GLOBAL SCOPE FOR ONCLICK HANDLERS
window.openAllTradesModal = openAllTradesModal;
window.selectAccountWrapper = selectAccountWrapper;
// generateIdFallback ya expuesta arriba (línea 2779)

// 🆕 TRADE MODEL EDITING IN DETAILS MODAL
let currentTradeForModel = null;
let currentDateForModel = null;

async function loadTradeEntryModelSection(trade, dateKey) {
    currentTradeForModel = trade;
    currentDateForModel = dateKey;
    
    const modelSelect = document.getElementById('detailsModelSelect');
    const modelBadge = document.getElementById('detailsModelBadge');
    const saveBtn = document.getElementById('saveTradeModelBtn');
    
    if (!modelSelect) return;
    
    const userId = window.currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
    if (!userId) return;
    
    // Cargar modelos disponibles (globales del usuario)
    const models = await window.getEntryModels(userId);
    modelSelect.innerHTML = '<option value="">Sin modelo...</option>';
    models.forEach(model => {
        const option = document.createElement('option');
        option.value = model.id;
        option.textContent = model.name;
        modelSelect.appendChild(option);
    });
    
    // Establecer modelo actual si existe (normalizar a string vacío si no hay)
    const currentModelId = trade?.entry_model_id || null;
    const modelValue = currentModelId || '';
    modelSelect.value = modelValue;
    
    // Forzar selección de "Sin modelo..." si no hay modelo
    if (!currentModelId) {
        modelSelect.selectedIndex = 0;
    }
    
    // Actualizar badge
    if (modelBadge) {
        if (currentModelId) {
            const model = models.find(m => m.id === currentModelId);
            if (model) {
                modelBadge.textContent = model.name;
                modelBadge.className = 'ml-auto px-2 py-0.5 bg-amber-600/20 text-amber-300 border border-amber-500/30 text-[10px] rounded-full';
            }
        } else {
            modelBadge.textContent = 'Sin modelo';
            modelBadge.className = 'ml-auto px-2 py-0.5 bg-slate-700/50 text-slate-400 text-[10px] rounded-full';
        }
    }
    
    // Mostrar preview si hay modelo
    updateDetailsModelPreview(currentModelId);
    
    // Habilitar botón solo si hay cambios
    if (saveBtn) {
        saveBtn.disabled = false;
    }
}

function updateDetailsModelPreview(modelId) {
    const previewContainer = document.getElementById('detailsModelPreview');
    const conditionsList = document.getElementById('detailsModelConditions');
    
    if (!modelId || !previewContainer || !conditionsList) {
        if (previewContainer) previewContainer.classList.add('hidden');
        return;
    }
    
    const userId = window.currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
    if (!userId) return;
    
    window.getEntryModels(userId).then(models => {
        const model = models.find(m => m.id === modelId);
        if (model) {
            conditionsList.innerHTML = model.conditions.map(cond => `
                <div class="text-xs text-slate-300 flex items-start gap-1.5">
                    <span class="text-amber-400">•</span>
                    <span>${window.escapeHtml(cond)}</span>
                </div>
            `).join('');
            previewContainer.classList.remove('hidden');
        } else {
            previewContainer.classList.add('hidden');
        }
    });
}

async function saveTradeModel() {
    if (!currentTradeForModel || !window.tursoClient) {
        if (window.showNotification) {
            window.showNotification('No hay trade seleccionado', 'error');
        }
        return;
    }
    
    const modelSelect = document.getElementById('detailsModelSelect');
    const selectedModelId = modelSelect?.value || '';
    
    try {
        // Obtener snapshot del modelo si existe
        let modelSnapshot = null;
        if (selectedModelId) {
            const userId = window.currentUserId || sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
            const models = await window.getEntryModels(userId);
            const model = models.find(m => m.id === selectedModelId);
            if (model) {
                modelSnapshot = JSON.stringify({
                    id: model.id,
                    name: model.name,
                    conditions: model.conditions
                });
            }
        }
        
        // Actualizar solo entry_model_id y entry_model_snapshot
        await window.tursoClient.execute({
            sql: 'UPDATE trades SET entry_model_id = ?, entry_model_snapshot = ? WHERE id = ?',
            args: [selectedModelId || null, modelSnapshot, currentTradeForModel.id]
        });
        
        // Actualizar en memoria
        currentTradeForModel.entry_model_id = selectedModelId || null;
        currentTradeForModel.entry_model_snapshot = modelSnapshot;
        
        // Actualizar en journalData - CORREGIDO
        if (window.journalData && window.journalData[currentDateForModel]) {
            const trades = window.journalData[currentDateForModel];
            if (Array.isArray(trades)) {
                const tradeIndex = trades.findIndex(t => t.id === currentTradeForModel.id);
                if (tradeIndex !== -1) {
                    trades[tradeIndex].entry_model_id = selectedModelId || null;
                    trades[tradeIndex].entry_model_snapshot = modelSnapshot;
                }
            }
        }
        
        if (window.showNotification) {
            window.showNotification('Modelo asignado correctamente', 'success');
        }
        
        // Refrescar vista
        await loadTradeEntryModelSection(currentTradeForModel, currentDateForModel);
        
    } catch (error) {
        if (window.showNotification) {
            window.showNotification(error.message || 'Error al guardar el modelo', 'error');
        }
    }
}

// Event listeners para el modal de detalles
const detailsModelSelect = document.getElementById('detailsModelSelect');
const saveTradeModelBtn = document.getElementById('saveTradeModelBtn');

if (detailsModelSelect) {
    detailsModelSelect.addEventListener('change', (e) => {
        updateDetailsModelPreview(e.target.value);
    });
}

if (saveTradeModelBtn) {
    saveTradeModelBtn.addEventListener('click', saveTradeModel);
}

